(function(){"use strict";try{if(typeof document!="undefined"&&document.head){var t=document.createElement("style");t.appendChild(document.createTextNode("._container_1lxa9_1{display:flex;flex-direction:column;align-items:center;width:100%;transition:all .4s ease-in-out}._container_1lxa9_1 svg{display:block}._second_1lxa9_11{display:flex;align-items:center;position:absolute;height:120px;font-size:40px;transition:opacity .2s ease-in-out}._tips_1lxa9_19{margin-top:18px;transition:opacity .2s ease-in-out;text-align:center;padding:0 8px}._tips_1lxa9_19 span{color:#fd6f8e}._cancelButton_1lxa9_28{width:72px;height:32px;margin-top:24px;color:#fff;background:rgba(255,255,255,.1);border:none;border-radius:8px;cursor:pointer}._stopped_1lxa9_38,._stopped_1lxa9_38 ._tips_1lxa9_19,._stopped_1lxa9_38 ._second_1lxa9_11{opacity:0}._container_2hh0t_1{display:flex;flex-direction:column;padding:16px}._title_2hh0t_6{color:#fff;margin-bottom:12px}._message_2hh0t_10{color:#98a2b3}._buttons_2hh0t_13{display:flex;flex-grow:1;justify-content:flex-end;align-items:flex-end}._buttons_2hh0t_13 button{min-width:80px;height:28px;margin-left:8px;border:none;color:#fff;background:rgba(255,255,255,.1);border-radius:4px;cursor:pointer}._buttons_2hh0t_13 button._primary_2hh0t_29{background:linear-gradient(90deg,#fe1889 0%,#ff5f7d 100%),#f63d68}._container_15hlf_1{width:36px;height:36px;border-radius:36px;cursor:pointer;opacity:1}._container_15hlf_1:hover{opacity:1}._circle_15hlf_11{display:flex;width:36px;height:36px;align-items:center;justify-content:center;border-radius:36px;border:2px solid white}._rect_15hlf_20{width:14px;height:14px;background:#e54136;border-radius:2px}._active_15hlf_26._container_15hlf_1 ._rect_15hlf_20{animation:1.2s infinite alternate _stop-button-animation_15hlf_1}@keyframes _stop-button-animation_15hlf_1{0%{opacity:1}70%{opacity:.7}to{opacity:1}}._container_14o0x_1{display:flex;align-items:center}._stopButton_14o0x_5{transition:all .4s ease-in-out}._timeDisplay_14o0x_8{margin-left:9px;font-size:14px;transition:all .3s ease-in-out}._buttons_14o0x_13{display:flex;margin-left:4px}.mini ._container_14o0x_1{width:64px;height:32px}.mini ._container_14o0x_1._recording_14o0x_21{animation:1.2s infinite alternate _mini-recorder-controller-animation_14o0x_1}.mini ._container_14o0x_1 ._stopButton_14o0x_5{transform:scale(0);width:0;opacity:0}.mini ._container_14o0x_1 ._buttons_14o0x_13{opacity:0}._container_36akj_7{display:flex;align-items:center;justify-content:center;position:fixed;z-index:9999999;width:136px;height:48px;color:#fff;background:linear-gradient(63.44deg,#1d2939 16.72%,#475467 83.39%);border-radius:32px;user-select:none;font-size:14px;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;cursor:default;transition:all .3s ease-in-out}._container_36akj_7 *{box-sizing:border-box}._overlay_36akj_27{position:fixed;z-index:9999998;inset:0;user-select:none;transition:all .3s ease-in-out}._overlay_36akj_27._masking_36akj_37{user-select:all;backdrop-filter:brightness(66%) blur(4px)}._controller_36akj_41{position:absolute;margin-left:8px;opacity:0;transition:all .3s ease-in-out}._countdown_36akj_47{position:absolute;opacity:0;transition:all .5s ease-in-out}._messageBox_36akj_52{position:absolute;inset:0;opacity:0;pointer-events:none;transition:all .24s ease-in-out}._handleBar_36akj_62{display:flex;flex-wrap:wrap;position:absolute;right:16px;width:24px;height:24px;padding:2px 4px;pointer-events:none;cursor:move;opacity:0;transition:opacity .3s ease-in-out}._handleBar_36akj_62 ._dot_36akj_78{display:flex;align-items:center;justify-content:center;flex-grow:0;flex-shrink:0;width:50%;height:33%}._handleBar_36akj_62 ._dot_36akj_78>div{width:3px;height:3px;border-radius:100%;background:#d9d9d9}._initial_36akj_93._container_36akj_7{opacity:0;transform:translateY(-100px)}._countingDown_36akj_97._container_36akj_7{width:216px;height:268px;border-radius:24px;transition:all .5s ease-in-out}._countingDown_36akj_97._container_36akj_7._center_36akj_103{transform:translate(-40px)}._countingDown_36akj_97._container_36akj_7 ._controller_36akj_41 ::global(._stopButton_36akj_106){transform:translate(200px) scale(7)}._countingDown_36akj_97._container_36akj_7 ._countdown_36akj_47{opacity:1;transform:none}._recording_36akj_113._container_36akj_7{justify-content:flex-start;transition:all .3s ease-in-out}._recording_36akj_113._container_36akj_7 ._controller_36akj_41{opacity:1}._recording_36akj_113._container_36akj_7 ._countdown_36akj_47{transform:scale(.3) translate(-200px,-20px)}._recording_36akj_113._container_36akj_7 ._handleBar_36akj_62{opacity:.5;pointer-events:all}._recording_36akj_113._container_36akj_7 ._handleBar_36akj_62:hover{opacity:1}._mini_36akj_130._container_36akj_7{overflow:hidden;width:64px;height:32px;border-radius:24px;background:linear-gradient(63.44deg,#1d2939 16.72%,#475467 83.39%);transition:all .4s ease-in-out}._mini_36akj_130._container_36akj_7.recording{animation:1.2s infinite alternate _mini-recorder-controller-animation_36akj_1}._mini_36akj_130._container_36akj_7._center_36akj_103{transform:translate(36px)}._mini_36akj_130._container_36akj_7 ._controller_36akj_41{opacity:1}._message_36akj_52._container_36akj_7{width:300px;height:140px;border-radius:24px}._message_36akj_52._container_36akj_7._center_36akj_103{transform:translate(-82px)}._message_36akj_52._container_36akj_7 ._messageBox_36akj_52{opacity:1;pointer-events:all}@keyframes _mini-recorder-controller-animation_36akj_1{0%{background:#f04438}70%{background:#d92d20}to{background:#f04438}}._dragContainer_36akj_170{position:absolute;inset:0;z-index:9999997}")),document.head.appendChild(t)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
var Ve = Object.defineProperty, We = Object.defineProperties;
var Re = Object.getOwnPropertyDescriptors;
var te = Object.getOwnPropertySymbols, fe = Object.getPrototypeOf, Ze = Object.prototype.hasOwnProperty, pe = Object.prototype.propertyIsEnumerable, Ye = Reflect.get;
var he = Math.pow, de = (n, l, t) => l in n ? Ve(n, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[l] = t, v = (n, l) => {
  for (var t in l || (l = {}))
    Ze.call(l, t) && de(n, t, l[t]);
  if (te)
    for (var t of te(l))
      pe.call(l, t) && de(n, t, l[t]);
  return n;
}, M = (n, l) => We(n, Re(l));
var le = (n, l) => {
  var t = {};
  for (var s in n)
    Ze.call(n, s) && l.indexOf(s) < 0 && (t[s] = n[s]);
  if (n != null && te)
    for (var s of te(n))
      l.indexOf(s) < 0 && pe.call(n, s) && (t[s] = n[s]);
  return t;
};
var d = (n, l, t) => (de(n, typeof l != "symbol" ? l + "" : l, t), t);
var Xe = (n, l, t) => Ye(fe(n), t, l);
var V = (n, l, t) => new Promise((s, c) => {
  var a = (h) => {
    try {
      o(t.next(h));
    } catch (b) {
      c(b);
    }
  }, r = (h) => {
    try {
      o(t.throw(h));
    } catch (b) {
      c(b);
    }
  }, o = (h) => h.done ? s(h.value) : Promise.resolve(h.value).then(a, r);
  o((t = t.apply(n, l)).next());
}), ne = function(n, l) {
  this[0] = n, this[1] = l;
}, ye = (n, l, t) => {
  var s = (r, o, h, b) => {
    try {
      var u = t[r](o), Z = (o = u.value) instanceof ne, p = u.done;
      Promise.resolve(Z ? o[0] : o).then((G) => Z ? s(r === "return" ? r : "next", o[1] ? { done: G.done, value: G.value } : G, h, b) : h({ value: G, done: p })).catch((G) => s("throw", G, h, b));
    } catch (G) {
      b(G);
    }
  }, c = (r) => a[r] = (o) => new Promise((h, b) => s(r, o, h, b)), a = {};
  return t = t.apply(n, l), a[Symbol.asyncIterator] = () => a, c("next"), c("throw"), c("return"), a;
};
class RuntimeError extends Error {
  constructor(t, s) {
    var c;
    super(t, s);
    d(this, "localizedMessage");
    this.name = "bytereplay.core.RuntimeError", this.localizedMessage = (c = s == null ? void 0 : s.localizedMessage) != null ? c : t;
  }
}
class ServerError extends RuntimeError {
  constructor(t, s) {
    super(t, s);
    d(this, "_code");
    this.name = "bytereplay.core.ServerError", this._code = s == null ? void 0 : s.code;
  }
  get code() {
    return this._code;
  }
}
class UnsupportedError extends RuntimeError {
  constructor(l, t) {
    super(l, t), this.name = "bytereplay.core.UnsupportedError";
  }
}
var commonjsGlobal = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function getDefaultExportFromCjs(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
/*! formdata-polyfill. MIT License. Jimmy W?rting <https://jimmy.warting.se/opensource> */
(function() {
  var n;
  function l(m) {
    var X = 0;
    return function() {
      return X < m.length ? { done: !1, value: m[X++] } : { done: !0 };
    };
  }
  var t = typeof Object.defineProperties == "function" ? Object.defineProperty : function(m, X, y) {
    return m == Array.prototype || m == Object.prototype || (m[X] = y.value), m;
  };
  function s(m) {
    m = [typeof globalThis == "object" && globalThis, m, typeof window == "object" && window, typeof self == "object" && self, typeof commonjsGlobal == "object" && commonjsGlobal];
    for (var X = 0; X < m.length; ++X) {
      var y = m[X];
      if (y && y.Math == Math)
        return y;
    }
    throw Error("Cannot find global object");
  }
  var c = s(this);
  function a(m, X) {
    if (X)
      e: {
        var y = c;
        m = m.split(".");
        for (var W = 0; W < m.length - 1; W++) {
          var T = m[W];
          if (!(T in y))
            break e;
          y = y[T];
        }
        m = m[m.length - 1], W = y[m], X = X(W), X != W && X != null && t(y, m, { configurable: !0, writable: !0, value: X });
      }
  }
  a("Symbol", function(m) {
    function X(K) {
      if (this instanceof X)
        throw new TypeError("Symbol is not a constructor");
      return new y(W + (K || "") + "_" + T++, K);
    }
    function y(K, j) {
      this.A = K, t(this, "description", { configurable: !0, writable: !0, value: j });
    }
    if (m)
      return m;
    y.prototype.toString = function() {
      return this.A;
    };
    var W = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", T = 0;
    return X;
  }), a("Symbol.iterator", function(m) {
    if (m)
      return m;
    m = Symbol("Symbol.iterator");
    for (var X = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), y = 0; y < X.length; y++) {
      var W = c[X[y]];
      typeof W == "function" && typeof W.prototype[m] != "function" && t(W.prototype, m, { configurable: !0, writable: !0, value: function() {
        return r(l(this));
      } });
    }
    return m;
  });
  function r(m) {
    return m = { next: m }, m[Symbol.iterator] = function() {
      return this;
    }, m;
  }
  function o(m) {
    var X = typeof Symbol != "undefined" && Symbol.iterator && m[Symbol.iterator];
    return X ? X.call(m) : { next: l(m) };
  }
  var h;
  if (typeof Object.setPrototypeOf == "function")
    h = Object.setPrototypeOf;
  else {
    var b;
    e: {
      var u = { a: !0 }, Z = {};
      try {
        Z.__proto__ = u, b = Z.a;
        break e;
      } catch (m) {
      }
      b = !1;
    }
    h = b ? function(m, X) {
      if (m.__proto__ = X, m.__proto__ !== X)
        throw new TypeError(m + " is not extensible");
      return m;
    } : null;
  }
  var p = h;
  function G() {
    this.m = !1, this.j = null, this.v = void 0, this.h = 1, this.u = this.C = 0, this.l = null;
  }
  function f(m) {
    if (m.m)
      throw new TypeError("Generator is already running");
    m.m = !0;
  }
  G.prototype.o = function(m) {
    this.v = m;
  }, G.prototype.s = function(m) {
    this.l = { D: m, F: !0 }, this.h = this.C || this.u;
  }, G.prototype.return = function(m) {
    this.l = { return: m }, this.h = this.u;
  };
  function R(m, X) {
    return m.h = 3, { value: X };
  }
  function Y(m) {
    this.g = new G(), this.G = m;
  }
  Y.prototype.o = function(m) {
    return f(this.g), this.g.j ? g(this, this.g.j.next, m, this.g.o) : (this.g.o(m), J(this));
  };
  function S(m, X) {
    f(m.g);
    var y = m.g.j;
    return y ? g(m, "return" in y ? y.return : function(W) {
      return { value: W, done: !0 };
    }, X, m.g.return) : (m.g.return(X), J(m));
  }
  Y.prototype.s = function(m) {
    return f(this.g), this.g.j ? g(this, this.g.j.throw, m, this.g.o) : (this.g.s(m), J(this));
  };
  function g(m, X, y, W) {
    try {
      var T = X.call(m.g.j, y);
      if (!(T instanceof Object))
        throw new TypeError("Iterator result " + T + " is not an object");
      if (!T.done)
        return m.g.m = !1, T;
      var K = T.value;
    } catch (j) {
      return m.g.j = null, m.g.s(j), J(m);
    }
    return m.g.j = null, W.call(m.g, K), J(m);
  }
  function J(m) {
    for (; m.g.h; )
      try {
        var X = m.G(m.g);
        if (X)
          return m.g.m = !1, { value: X.value, done: !1 };
      } catch (y) {
        m.g.v = void 0, m.g.s(y);
      }
    if (m.g.m = !1, m.g.l) {
      if (X = m.g.l, m.g.l = null, X.F)
        throw X.D;
      return { value: X.return, done: !0 };
    }
    return { value: void 0, done: !0 };
  }
  function U(m) {
    this.next = function(X) {
      return m.o(X);
    }, this.throw = function(X) {
      return m.s(X);
    }, this.return = function(X) {
      return S(m, X);
    }, this[Symbol.iterator] = function() {
      return this;
    };
  }
  function L(m, X) {
    return X = new U(new Y(X)), p && m.prototype && p(X, m.prototype), X;
  }
  function P(m, X) {
    m instanceof String && (m += "");
    var y = 0, W = !1, T = { next: function() {
      if (!W && y < m.length) {
        var K = y++;
        return { value: X(K, m[K]), done: !1 };
      }
      return W = !0, { done: !0, value: void 0 };
    } };
    return T[Symbol.iterator] = function() {
      return T;
    }, T;
  }
  if (a("Array.prototype.entries", function(m) {
    return m || function() {
      return P(this, function(X, y) {
        return [X, y];
      });
    };
  }), typeof Blob != "undefined" && (typeof FormData == "undefined" || !FormData.prototype.keys)) {
    var C = function(m, X) {
      for (var y = 0; y < m.length; y++)
        X(m[y]);
    }, I = function(m) {
      return m.replace(/\r?\n|\r/g, `\r
`);
    }, N = function(m, X, y) {
      return X instanceof Blob ? (y = y !== void 0 ? y + "" : typeof X.name == "string" ? X.name : "blob", (X.name !== y || Object.prototype.toString.call(X) === "[object Blob]") && (X = new File([X], y)), [String(m), X]) : [String(m), String(X)];
    }, z = function(m, X) {
      if (m.length < X)
        throw new TypeError(X + " argument required, but only " + m.length + " present.");
    }, k = typeof globalThis == "object" ? globalThis : typeof window == "object" ? window : typeof self == "object" ? self : this, _ = k.FormData, q = k.XMLHttpRequest && k.XMLHttpRequest.prototype.send, D = k.Request && k.fetch, A = k.navigator && k.navigator.sendBeacon, w = k.Element && k.Element.prototype, H = k.Symbol && Symbol.toStringTag;
    H && (Blob.prototype[H] || (Blob.prototype[H] = "Blob"), "File" in k && !File.prototype[H] && (File.prototype[H] = "File"));
    try {
      new File([], "");
    } catch (m) {
      k.File = function(X, y, W) {
        return X = new Blob(X, W || {}), Object.defineProperties(X, { name: { value: y }, lastModified: { value: +(W && W.lastModified !== void 0 ? new Date(W.lastModified) : /* @__PURE__ */ new Date()) }, toString: { value: function() {
          return "[object File]";
        } } }), H && Object.defineProperty(X, H, { value: "File" }), X;
      };
    }
    var Q = function(m) {
      return m.replace(/\n/g, "%0A").replace(/\r/g, "%0D").replace(/"/g, "%22");
    }, E = function(m) {
      this.i = [];
      var X = this;
      m && C(m.elements, function(y) {
        if (y.name && !y.disabled && y.type !== "submit" && y.type !== "button" && !y.matches("form fieldset[disabled] *"))
          if (y.type === "file") {
            var W = y.files && y.files.length ? y.files : [new File([], "", { type: "application/octet-stream" })];
            C(W, function(T) {
              X.append(y.name, T);
            });
          } else
            y.type === "select-multiple" || y.type === "select-one" ? C(y.options, function(T) {
              !T.disabled && T.selected && X.append(y.name, T.value);
            }) : y.type === "checkbox" || y.type === "radio" ? y.checked && X.append(y.name, y.value) : (W = y.type === "textarea" ? I(y.value) : y.value, X.append(y.name, W));
      });
    };
    if (n = E.prototype, n.append = function(m, X, y) {
      z(arguments, 2), this.i.push(N(m, X, y));
    }, n.delete = function(m) {
      z(
        arguments,
        1
      );
      var X = [];
      m = String(m), C(this.i, function(y) {
        y[0] !== m && X.push(y);
      }), this.i = X;
    }, n.entries = function m() {
      var X, y = this;
      return L(m, function(W) {
        if (W.h == 1 && (X = 0), W.h != 3)
          return X < y.i.length ? W = R(W, y.i[X]) : (W.h = 0, W = void 0), W;
        X++, W.h = 2;
      });
    }, n.forEach = function(m, X) {
      z(arguments, 1);
      for (var y = o(this), W = y.next(); !W.done; W = y.next()) {
        var T = o(W.value);
        W = T.next().value, T = T.next().value, m.call(X, T, W, this);
      }
    }, n.get = function(m) {
      z(arguments, 1);
      var X = this.i;
      m = String(m);
      for (var y = 0; y < X.length; y++)
        if (X[y][0] === m)
          return X[y][1];
      return null;
    }, n.getAll = function(m) {
      z(arguments, 1);
      var X = [];
      return m = String(m), C(this.i, function(y) {
        y[0] === m && X.push(y[1]);
      }), X;
    }, n.has = function(m) {
      z(arguments, 1), m = String(m);
      for (var X = 0; X < this.i.length; X++)
        if (this.i[X][0] === m)
          return !0;
      return !1;
    }, n.keys = function m() {
      var X = this, y, W, T, K, j;
      return L(m, function(O) {
        if (O.h == 1 && (y = o(X), W = y.next()), O.h != 3) {
          if (W.done) {
            O.h = 0;
            return;
          }
          return T = W.value, K = o(T), j = K.next().value, R(O, j);
        }
        W = y.next(), O.h = 2;
      });
    }, n.set = function(m, X, y) {
      z(arguments, 2), m = String(m);
      var W = [], T = N(
        m,
        X,
        y
      ), K = !0;
      C(this.i, function(j) {
        j[0] === m ? K && (K = !W.push(T)) : W.push(j);
      }), K && W.push(T), this.i = W;
    }, n.values = function m() {
      var X = this, y, W, T, K, j;
      return L(m, function(O) {
        if (O.h == 1 && (y = o(X), W = y.next()), O.h != 3) {
          if (W.done) {
            O.h = 0;
            return;
          }
          return T = W.value, K = o(T), K.next(), j = K.next().value, R(O, j);
        }
        W = y.next(), O.h = 2;
      });
    }, E.prototype._asNative = function() {
      for (var m = new _(), X = o(this), y = X.next(); !y.done; y = X.next()) {
        var W = o(y.value);
        y = W.next().value, W = W.next().value, m.append(y, W);
      }
      return m;
    }, E.prototype._blob = function() {
      var m = "----formdata-polyfill-" + Math.random(), X = [], y = "--" + m + `\r
Content-Disposition: form-data; name="`;
      return this.forEach(function(W, T) {
        return typeof W == "string" ? X.push(y + Q(I(T)) + (`"\r
\r
` + I(W) + `\r
`)) : X.push(y + Q(I(T)) + ('"; filename="' + Q(W.name) + `"\r
Content-Type: ` + (W.type || "application/octet-stream") + `\r
\r
`), W, `\r
`);
      }), X.push("--" + m + "--"), new Blob(X, { type: "multipart/form-data; boundary=" + m });
    }, E.prototype[Symbol.iterator] = function() {
      return this.entries();
    }, E.prototype.toString = function() {
      return "[object FormData]";
    }, w && !w.matches && (w.matches = w.matchesSelector || w.mozMatchesSelector || w.msMatchesSelector || w.oMatchesSelector || w.webkitMatchesSelector || function(m) {
      m = (this.document || this.ownerDocument).querySelectorAll(m);
      for (var X = m.length; 0 <= --X && m.item(X) !== this; )
        ;
      return -1 < X;
    }), H && (E.prototype[H] = "FormData"), q) {
      var ee = k.XMLHttpRequest.prototype.setRequestHeader;
      k.XMLHttpRequest.prototype.setRequestHeader = function(m, X) {
        ee.call(this, m, X), m.toLowerCase() === "content-type" && (this.B = !0);
      }, k.XMLHttpRequest.prototype.send = function(m) {
        m instanceof E ? (m = m._blob(), this.B || this.setRequestHeader("Content-Type", m.type), q.call(this, m)) : q.call(this, m);
      };
    }
    D && (k.fetch = function(m, X) {
      return X && X.body && X.body instanceof E && (X.body = X.body._blob()), D.call(this, m, X);
    }), A && (k.navigator.sendBeacon = function(m, X) {
      return X instanceof E && (X = X._asNative()), A.call(this, m, X);
    }), k.FormData = E;
  }
})();
function createFormData() {
  return new FormData();
}
function isFormData(n) {
  return n instanceof FormData;
}
var check$1 = function(n) {
  return n && n.Math === Math && n;
}, globalThis_1 = (
  // eslint-disable-next-line es/no-global-this -- safe
  check$1(typeof globalThis == "object" && globalThis) || check$1(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  check$1(typeof self == "object" && self) || check$1(typeof commonjsGlobal == "object" && commonjsGlobal) || check$1(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
), objectGetOwnPropertyDescriptor = {}, fails$8 = function(n) {
  try {
    return !!n();
  } catch (l) {
    return !0;
  }
}, fails$7 = fails$8, descriptors = !fails$7(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), fails$6 = fails$8, functionBindNative = !fails$6(function() {
  var n = function() {
  }.bind();
  return typeof n != "function" || n.hasOwnProperty("prototype");
}), NATIVE_BIND$1 = functionBindNative, call$4 = Function.prototype.call, functionCall = NATIVE_BIND$1 ? call$4.bind(call$4) : function() {
  return call$4.apply(call$4, arguments);
}, objectPropertyIsEnumerable = {}, $propertyIsEnumerable = {}.propertyIsEnumerable, getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor, NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);
objectPropertyIsEnumerable.f = NASHORN_BUG ? function(l) {
  var t = getOwnPropertyDescriptor$1(this, l);
  return !!t && t.enumerable;
} : $propertyIsEnumerable;
var createPropertyDescriptor$2 = function(n, l) {
  return {
    enumerable: !(n & 1),
    configurable: !(n & 2),
    writable: !(n & 4),
    value: l
  };
}, NATIVE_BIND = functionBindNative, FunctionPrototype$1 = Function.prototype, call$3 = FunctionPrototype$1.call, uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$3, call$3), functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function(n) {
  return function() {
    return call$3.apply(n, arguments);
  };
}, uncurryThis$8 = functionUncurryThis, toString$2 = uncurryThis$8({}.toString), stringSlice$1 = uncurryThis$8("".slice), classofRaw = function(n) {
  return stringSlice$1(toString$2(n), 8, -1);
}, uncurryThis$7 = functionUncurryThis, fails$5 = fails$8, classof = classofRaw, $Object$2 = Object, split = uncurryThis$7("".split), indexedObject = fails$5(function() {
  return !$Object$2("z").propertyIsEnumerable(0);
}) ? function(n) {
  return classof(n) === "String" ? split(n, "") : $Object$2(n);
} : $Object$2, isNullOrUndefined$2 = function(n) {
  return n == null;
}, isNullOrUndefined$1 = isNullOrUndefined$2, $TypeError$5 = TypeError, requireObjectCoercible$2 = function(n) {
  if (isNullOrUndefined$1(n))
    throw new $TypeError$5("Can't call method on " + n);
  return n;
}, IndexedObject = indexedObject, requireObjectCoercible$1 = requireObjectCoercible$2, toIndexedObject$3 = function(n) {
  return IndexedObject(requireObjectCoercible$1(n));
}, documentAll = typeof document == "object" && document.all, isCallable$a = typeof documentAll == "undefined" && documentAll !== void 0 ? function(n) {
  return typeof n == "function" || n === documentAll;
} : function(n) {
  return typeof n == "function";
}, isCallable$9 = isCallable$a, isObject$7 = function(n) {
  return typeof n == "object" ? n !== null : isCallable$9(n);
}, globalThis$c = globalThis_1, isCallable$8 = isCallable$a, aFunction = function(n) {
  return isCallable$8(n) ? n : void 0;
}, getBuiltIn$2 = function(n, l) {
  return arguments.length < 2 ? aFunction(globalThis$c[n]) : globalThis$c[n] && globalThis$c[n][l];
}, uncurryThis$6 = functionUncurryThis, objectIsPrototypeOf = uncurryThis$6({}.isPrototypeOf), globalThis$b = globalThis_1, navigator = globalThis$b.navigator, userAgent$1 = navigator && navigator.userAgent, environmentUserAgent = userAgent$1 ? String(userAgent$1) : "", globalThis$a = globalThis_1, userAgent = environmentUserAgent, process$1 = globalThis$a.process, Deno = globalThis$a.Deno, versions = process$1 && process$1.versions || Deno && Deno.version, v8 = versions && versions.v8, match, version$1;
v8 && (match = v8.split("."), version$1 = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]));
!version$1 && userAgent && (match = userAgent.match(/Edge\/(\d+)/), (!match || match[1] >= 74) && (match = userAgent.match(/Chrome\/(\d+)/), match && (version$1 = +match[1])));
var environmentV8Version = version$1, V8_VERSION = environmentV8Version, fails$4 = fails$8, globalThis$9 = globalThis_1, $String$3 = globalThis$9.String, symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$4(function() {
  var n = Symbol("symbol detection");
  return !$String$3(n) || !(Object(n) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION && V8_VERSION < 41;
}), NATIVE_SYMBOL$1 = symbolConstructorDetection, useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol", getBuiltIn$1 = getBuiltIn$2, isCallable$7 = isCallable$a, isPrototypeOf = objectIsPrototypeOf, USE_SYMBOL_AS_UID$1 = useSymbolAsUid, $Object$1 = Object, isSymbol$3 = USE_SYMBOL_AS_UID$1 ? function(n) {
  return typeof n == "symbol";
} : function(n) {
  var l = getBuiltIn$1("Symbol");
  return isCallable$7(l) && isPrototypeOf(l.prototype, $Object$1(n));
}, $String$2 = String, tryToString$1 = function(n) {
  try {
    return $String$2(n);
  } catch (l) {
    return "Object";
  }
}, isCallable$6 = isCallable$a, tryToString = tryToString$1, $TypeError$4 = TypeError, aCallable$1 = function(n) {
  if (isCallable$6(n))
    return n;
  throw new $TypeError$4(tryToString(n) + " is not a function");
}, aCallable = aCallable$1, isNullOrUndefined = isNullOrUndefined$2, getMethod$2 = function(n, l) {
  var t = n[l];
  return isNullOrUndefined(t) ? void 0 : aCallable(t);
}, call$2 = functionCall, isCallable$5 = isCallable$a, isObject$6 = isObject$7, $TypeError$3 = TypeError, ordinaryToPrimitive$1 = function(n, l) {
  var t, s;
  if (l === "string" && isCallable$5(t = n.toString) && !isObject$6(s = call$2(t, n)) || isCallable$5(t = n.valueOf) && !isObject$6(s = call$2(t, n)) || l !== "string" && isCallable$5(t = n.toString) && !isObject$6(s = call$2(t, n)))
    return s;
  throw new $TypeError$3("Can't convert object to primitive value");
}, sharedStore = { exports: {} }, globalThis$8 = globalThis_1, defineProperty$1 = Object.defineProperty, defineGlobalProperty$3 = function(n, l) {
  try {
    defineProperty$1(globalThis$8, n, { value: l, configurable: !0, writable: !0 });
  } catch (t) {
    globalThis$8[n] = l;
  }
  return l;
}, globalThis$7 = globalThis_1, defineGlobalProperty$2 = defineGlobalProperty$3, SHARED = "__core-js_shared__", store$3 = sharedStore.exports = globalThis$7[SHARED] || defineGlobalProperty$2(SHARED, {});
(store$3.versions || (store$3.versions = [])).push({
  version: "3.38.1",
  mode: "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var sharedStoreExports = sharedStore.exports, store$2 = sharedStoreExports, shared$3 = function(n, l) {
  return store$2[n] || (store$2[n] = l || {});
}, requireObjectCoercible = requireObjectCoercible$2, $Object = Object, toObject$1 = function(n) {
  return $Object(requireObjectCoercible(n));
}, uncurryThis$5 = functionUncurryThis, toObject = toObject$1, hasOwnProperty = uncurryThis$5({}.hasOwnProperty), hasOwnProperty_1 = Object.hasOwn || function(l, t) {
  return hasOwnProperty(toObject(l), t);
}, uncurryThis$4 = functionUncurryThis, id = 0, postfix = Math.random(), toString$1 = uncurryThis$4(1 .toString), uid$2 = function(n) {
  return "Symbol(" + (n === void 0 ? "" : n) + ")_" + toString$1(++id + postfix, 36);
}, globalThis$6 = globalThis_1, shared$2 = shared$3, hasOwn$6 = hasOwnProperty_1, uid$1 = uid$2, NATIVE_SYMBOL = symbolConstructorDetection, USE_SYMBOL_AS_UID = useSymbolAsUid, Symbol$1 = globalThis$6.Symbol, WellKnownSymbolsStore = shared$2("wks"), createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1.for || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1, wellKnownSymbol$1 = function(n) {
  return hasOwn$6(WellKnownSymbolsStore, n) || (WellKnownSymbolsStore[n] = NATIVE_SYMBOL && hasOwn$6(Symbol$1, n) ? Symbol$1[n] : createWellKnownSymbol("Symbol." + n)), WellKnownSymbolsStore[n];
}, call$1 = functionCall, isObject$5 = isObject$7, isSymbol$2 = isSymbol$3, getMethod$1 = getMethod$2, ordinaryToPrimitive = ordinaryToPrimitive$1, wellKnownSymbol = wellKnownSymbol$1, $TypeError$2 = TypeError, TO_PRIMITIVE = wellKnownSymbol("toPrimitive"), toPrimitive$1 = function(n, l) {
  if (!isObject$5(n) || isSymbol$2(n))
    return n;
  var t = getMethod$1(n, TO_PRIMITIVE), s;
  if (t) {
    if (l === void 0 && (l = "default"), s = call$1(t, n, l), !isObject$5(s) || isSymbol$2(s))
      return s;
    throw new $TypeError$2("Can't convert object to primitive value");
  }
  return l === void 0 && (l = "number"), ordinaryToPrimitive(n, l);
}, toPrimitive = toPrimitive$1, isSymbol$1 = isSymbol$3, toPropertyKey$2 = function(n) {
  var l = toPrimitive(n, "string");
  return isSymbol$1(l) ? l : l + "";
}, globalThis$5 = globalThis_1, isObject$4 = isObject$7, document$1 = globalThis$5.document, EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement), documentCreateElement = function(n) {
  return EXISTS$1 ? document$1.createElement(n) : {};
}, DESCRIPTORS$6 = descriptors, fails$3 = fails$8, createElement = documentCreateElement, ie8DomDefine = !DESCRIPTORS$6 && !fails$3(function() {
  return Object.defineProperty(createElement("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), DESCRIPTORS$5 = descriptors, call = functionCall, propertyIsEnumerableModule = objectPropertyIsEnumerable, createPropertyDescriptor$1 = createPropertyDescriptor$2, toIndexedObject$2 = toIndexedObject$3, toPropertyKey$1 = toPropertyKey$2, hasOwn$5 = hasOwnProperty_1, IE8_DOM_DEFINE$1 = ie8DomDefine, $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor$1 : function(l, t) {
  if (l = toIndexedObject$2(l), t = toPropertyKey$1(t), IE8_DOM_DEFINE$1)
    try {
      return $getOwnPropertyDescriptor$1(l, t);
    } catch (s) {
    }
  if (hasOwn$5(l, t))
    return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, l, t), l[t]);
};
var objectDefineProperty = {}, DESCRIPTORS$4 = descriptors, fails$2 = fails$8, v8PrototypeDefineBug = DESCRIPTORS$4 && fails$2(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), isObject$3 = isObject$7, $String$1 = String, $TypeError$1 = TypeError, anObject$2 = function(n) {
  if (isObject$3(n))
    return n;
  throw new $TypeError$1($String$1(n) + " is not an object");
}, DESCRIPTORS$3 = descriptors, IE8_DOM_DEFINE = ie8DomDefine, V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug, anObject$1 = anObject$2, toPropertyKey = toPropertyKey$2, $TypeError = TypeError, $defineProperty = Object.defineProperty, $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, ENUMERABLE = "enumerable", CONFIGURABLE$1 = "configurable", WRITABLE = "writable";
objectDefineProperty.f = DESCRIPTORS$3 ? V8_PROTOTYPE_DEFINE_BUG ? function(l, t, s) {
  if (anObject$1(l), t = toPropertyKey(t), anObject$1(s), typeof l == "function" && t === "prototype" && "value" in s && WRITABLE in s && !s[WRITABLE]) {
    var c = $getOwnPropertyDescriptor(l, t);
    c && c[WRITABLE] && (l[t] = s.value, s = {
      configurable: CONFIGURABLE$1 in s ? s[CONFIGURABLE$1] : c[CONFIGURABLE$1],
      enumerable: ENUMERABLE in s ? s[ENUMERABLE] : c[ENUMERABLE],
      writable: !1
    });
  }
  return $defineProperty(l, t, s);
} : $defineProperty : function(l, t, s) {
  if (anObject$1(l), t = toPropertyKey(t), anObject$1(s), IE8_DOM_DEFINE)
    try {
      return $defineProperty(l, t, s);
    } catch (c) {
    }
  if ("get" in s || "set" in s)
    throw new $TypeError("Accessors not supported");
  return "value" in s && (l[t] = s.value), l;
};
var DESCRIPTORS$2 = descriptors, definePropertyModule$2 = objectDefineProperty, createPropertyDescriptor = createPropertyDescriptor$2, createNonEnumerableProperty$2 = DESCRIPTORS$2 ? function(n, l, t) {
  return definePropertyModule$2.f(n, l, createPropertyDescriptor(1, t));
} : function(n, l, t) {
  return n[l] = t, n;
}, makeBuiltIn$2 = { exports: {} }, DESCRIPTORS$1 = descriptors, hasOwn$4 = hasOwnProperty_1, FunctionPrototype = Function.prototype, getDescriptor = DESCRIPTORS$1 && Object.getOwnPropertyDescriptor, EXISTS = hasOwn$4(FunctionPrototype, "name"), PROPER = EXISTS && function() {
}.name === "something", CONFIGURABLE = EXISTS && (!DESCRIPTORS$1 || DESCRIPTORS$1 && getDescriptor(FunctionPrototype, "name").configurable), functionName = {
  EXISTS,
  PROPER,
  CONFIGURABLE
}, uncurryThis$3 = functionUncurryThis, isCallable$4 = isCallable$a, store$1 = sharedStoreExports, functionToString = uncurryThis$3(Function.toString);
isCallable$4(store$1.inspectSource) || (store$1.inspectSource = function(n) {
  return functionToString(n);
});
var inspectSource$1 = store$1.inspectSource, globalThis$4 = globalThis_1, isCallable$3 = isCallable$a, WeakMap$2 = globalThis$4.WeakMap, weakMapBasicDetection = isCallable$3(WeakMap$2) && /native code/.test(String(WeakMap$2)), shared$1 = shared$3, uid = uid$2, keys$1 = shared$1("keys"), sharedKey$1 = function(n) {
  return keys$1[n] || (keys$1[n] = uid(n));
}, hiddenKeys$3 = {}, NATIVE_WEAK_MAP = weakMapBasicDetection, globalThis$3 = globalThis_1, isObject$2 = isObject$7, createNonEnumerableProperty$1 = createNonEnumerableProperty$2, hasOwn$3 = hasOwnProperty_1, shared = sharedStoreExports, sharedKey = sharedKey$1, hiddenKeys$2 = hiddenKeys$3, OBJECT_ALREADY_INITIALIZED = "Object already initialized", TypeError$1 = globalThis$3.TypeError, WeakMap$1 = globalThis$3.WeakMap, set$1, get$1, has, enforce = function(n) {
  return has(n) ? get$1(n) : set$1(n, {});
}, getterFor = function(n) {
  return function(l) {
    var t;
    if (!isObject$2(l) || (t = get$1(l)).type !== n)
      throw new TypeError$1("Incompatible receiver, " + n + " required");
    return t;
  };
};
if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap$1());
  store.get = store.get, store.has = store.has, store.set = store.set, set$1 = function(n, l) {
    if (store.has(n))
      throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    return l.facade = n, store.set(n, l), l;
  }, get$1 = function(n) {
    return store.get(n) || {};
  }, has = function(n) {
    return store.has(n);
  };
} else {
  var STATE = sharedKey("state");
  hiddenKeys$2[STATE] = !0, set$1 = function(n, l) {
    if (hasOwn$3(n, STATE))
      throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    return l.facade = n, createNonEnumerableProperty$1(n, STATE, l), l;
  }, get$1 = function(n) {
    return hasOwn$3(n, STATE) ? n[STATE] : {};
  }, has = function(n) {
    return hasOwn$3(n, STATE);
  };
}
var internalState = {
  set: set$1,
  get: get$1,
  has,
  enforce,
  getterFor
}, uncurryThis$2 = functionUncurryThis, fails$1 = fails$8, isCallable$2 = isCallable$a, hasOwn$2 = hasOwnProperty_1, DESCRIPTORS = descriptors, CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE, inspectSource = inspectSource$1, InternalStateModule = internalState, enforceInternalState = InternalStateModule.enforce, getInternalState = InternalStateModule.get, $String = String, defineProperty = Object.defineProperty, stringSlice = uncurryThis$2("".slice), replace = uncurryThis$2("".replace), join = uncurryThis$2([].join), CONFIGURABLE_LENGTH = DESCRIPTORS && !fails$1(function() {
  return defineProperty(function() {
  }, "length", { value: 8 }).length !== 8;
}), TEMPLATE = String(String).split("String"), makeBuiltIn$1 = makeBuiltIn$2.exports = function(n, l, t) {
  stringSlice($String(l), 0, 7) === "Symbol(" && (l = "[" + replace($String(l), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), t && t.getter && (l = "get " + l), t && t.setter && (l = "set " + l), (!hasOwn$2(n, "name") || CONFIGURABLE_FUNCTION_NAME && n.name !== l) && (DESCRIPTORS ? defineProperty(n, "name", { value: l, configurable: !0 }) : n.name = l), CONFIGURABLE_LENGTH && t && hasOwn$2(t, "arity") && n.length !== t.arity && defineProperty(n, "length", { value: t.arity });
  try {
    t && hasOwn$2(t, "constructor") && t.constructor ? DESCRIPTORS && defineProperty(n, "prototype", { writable: !1 }) : n.prototype && (n.prototype = void 0);
  } catch (c) {
  }
  var s = enforceInternalState(n);
  return hasOwn$2(s, "source") || (s.source = join(TEMPLATE, typeof l == "string" ? l : "")), n;
};
Function.prototype.toString = makeBuiltIn$1(function() {
  return isCallable$2(this) && getInternalState(this).source || inspectSource(this);
}, "toString");
var makeBuiltInExports = makeBuiltIn$2.exports, isCallable$1 = isCallable$a, definePropertyModule$1 = objectDefineProperty, makeBuiltIn = makeBuiltInExports, defineGlobalProperty$1 = defineGlobalProperty$3, defineBuiltIn$1 = function(n, l, t, s) {
  s || (s = {});
  var c = s.enumerable, a = s.name !== void 0 ? s.name : l;
  if (isCallable$1(t) && makeBuiltIn(t, a, s), s.global)
    c ? n[l] = t : defineGlobalProperty$1(l, t);
  else {
    try {
      s.unsafe ? n[l] && (c = !0) : delete n[l];
    } catch (r) {
    }
    c ? n[l] = t : definePropertyModule$1.f(n, l, {
      value: t,
      enumerable: !1,
      configurable: !s.nonConfigurable,
      writable: !s.nonWritable
    });
  }
  return n;
}, objectGetOwnPropertyNames = {}, ceil = Math.ceil, floor = Math.floor, mathTrunc = Math.trunc || function(l) {
  var t = +l;
  return (t > 0 ? floor : ceil)(t);
}, trunc = mathTrunc, toIntegerOrInfinity$2 = function(n) {
  var l = +n;
  return l !== l || l === 0 ? 0 : trunc(l);
}, toIntegerOrInfinity$1 = toIntegerOrInfinity$2, max = Math.max, min$1 = Math.min, toAbsoluteIndex$1 = function(n, l) {
  var t = toIntegerOrInfinity$1(n);
  return t < 0 ? max(t + l, 0) : min$1(t, l);
}, toIntegerOrInfinity = toIntegerOrInfinity$2, min = Math.min, toLength$1 = function(n) {
  var l = toIntegerOrInfinity(n);
  return l > 0 ? min(l, 9007199254740991) : 0;
}, toLength = toLength$1, lengthOfArrayLike$1 = function(n) {
  return toLength(n.length);
}, toIndexedObject$1 = toIndexedObject$3, toAbsoluteIndex = toAbsoluteIndex$1, lengthOfArrayLike = lengthOfArrayLike$1, createMethod = function(n) {
  return function(l, t, s) {
    var c = toIndexedObject$1(l), a = lengthOfArrayLike(c);
    if (a === 0)
      return !n && -1;
    var r = toAbsoluteIndex(s, a), o;
    if (n && t !== t) {
      for (; a > r; )
        if (o = c[r++], o !== o)
          return !0;
    } else
      for (; a > r; r++)
        if ((n || r in c) && c[r] === t)
          return n || r || 0;
    return !n && -1;
  };
}, arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(!1)
}, uncurryThis$1 = functionUncurryThis, hasOwn$1 = hasOwnProperty_1, toIndexedObject = toIndexedObject$3, indexOf = arrayIncludes.indexOf, hiddenKeys$1 = hiddenKeys$3, push = uncurryThis$1([].push), objectKeysInternal = function(n, l) {
  var t = toIndexedObject(n), s = 0, c = [], a;
  for (a in t)
    !hasOwn$1(hiddenKeys$1, a) && hasOwn$1(t, a) && push(c, a);
  for (; l.length > s; )
    hasOwn$1(t, a = l[s++]) && (~indexOf(c, a) || push(c, a));
  return c;
}, enumBugKeys$1 = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], internalObjectKeys = objectKeysInternal, enumBugKeys = enumBugKeys$1, hiddenKeys = enumBugKeys.concat("length", "prototype");
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function(l) {
  return internalObjectKeys(l, hiddenKeys);
};
var objectGetOwnPropertySymbols = {};
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn = getBuiltIn$2, uncurryThis = functionUncurryThis, getOwnPropertyNamesModule = objectGetOwnPropertyNames, getOwnPropertySymbolsModule = objectGetOwnPropertySymbols, anObject = anObject$2, concat = uncurryThis([].concat), ownKeys$1 = getBuiltIn("Reflect", "ownKeys") || function(l) {
  var t = getOwnPropertyNamesModule.f(anObject(l)), s = getOwnPropertySymbolsModule.f;
  return s ? concat(t, s(l)) : t;
}, hasOwn = hasOwnProperty_1, ownKeys = ownKeys$1, getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor, definePropertyModule = objectDefineProperty, copyConstructorProperties$1 = function(n, l, t) {
  for (var s = ownKeys(l), c = definePropertyModule.f, a = getOwnPropertyDescriptorModule.f, r = 0; r < s.length; r++) {
    var o = s[r];
    !hasOwn(n, o) && !(t && hasOwn(t, o)) && c(n, o, a(l, o));
  }
}, fails = fails$8, isCallable = isCallable$a, replacement = /#|\.prototype\./, isForced$1 = function(n, l) {
  var t = data[normalize(n)];
  return t === POLYFILL ? !0 : t === NATIVE ? !1 : isCallable(l) ? fails(l) : !!l;
}, normalize = isForced$1.normalize = function(n) {
  return String(n).replace(replacement, ".").toLowerCase();
}, data = isForced$1.data = {}, NATIVE = isForced$1.NATIVE = "N", POLYFILL = isForced$1.POLYFILL = "P", isForced_1 = isForced$1, globalThis$2 = globalThis_1, getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f, createNonEnumerableProperty = createNonEnumerableProperty$2, defineBuiltIn = defineBuiltIn$1, defineGlobalProperty = defineGlobalProperty$3, copyConstructorProperties = copyConstructorProperties$1, isForced = isForced_1, _export = function(n, l) {
  var t = n.target, s = n.global, c = n.stat, a, r, o, h, b, u;
  if (s ? r = globalThis$2 : c ? r = globalThis$2[t] || defineGlobalProperty(t, {}) : r = globalThis$2[t] && globalThis$2[t].prototype, r)
    for (o in l) {
      if (b = l[o], n.dontCallGetSet ? (u = getOwnPropertyDescriptor(r, o), h = u && u.value) : h = r[o], a = isForced(s ? o : t + (c ? "." : "#") + o, n.forced), !a && h !== void 0) {
        if (typeof b == typeof h)
          continue;
        copyConstructorProperties(b, h);
      }
      (n.sham || h && h.sham) && createNonEnumerableProperty(b, "sham", !0), defineBuiltIn(r, o, b, n);
    }
}, $ = _export, globalThis$1 = globalThis_1;
$({ global: !0, forced: globalThis$1.globalThis !== globalThis$1 }, {
  globalThis: globalThis$1
});
function includes(n, l) {
  return n == null ? !1 : n.indexOf(l) !== -1;
}
function isFunction$1(n) {
  return typeof n == "function";
}
function isFetchRequest(n) {
  return n instanceof Request;
}
function isFetchHeaders(n) {
  return n instanceof Headers;
}
function isObject$1(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function isString(n) {
  return typeof n == "string" || n instanceof String;
}
function isSymbol(n) {
  return typeof n == "symbol";
}
function isEmptyString(n) {
  return n.trim() === "";
}
function isPlainObject(n) {
  if (!isObject$1(n))
    return !1;
  let l = n;
  for (; Object.getPrototypeOf(l) !== null; )
    l = Object.getPrototypeOf(l);
  return Object.getPrototypeOf(n) === l || Object.getPrototypeOf(n) === null;
}
function performanceObserver() {
  return !!globalThis.PerformanceObserver;
}
function performance$1() {
  return !!globalThis.performance;
}
function performanceNow() {
  var n;
  return isFunction$1((n = globalThis.performance) == null ? void 0 : n.now);
}
function compressionStream() {
  return isFunction$1(globalThis.CompressionStream);
}
function structuredClone$1() {
  return isFunction$1(globalThis.structuredClone);
}
function webWorkers() {
  return !!globalThis.Worker;
}
function webSockets() {
  return !!globalThis.WebSocket;
}
function fetch$1(n) {
  var l;
  return isFunction$1((l = n != null ? n : globalThis) == null ? void 0 : l.fetch);
}
const ciu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compressionStream,
  fetch: fetch$1,
  performance: performance$1,
  performanceNow,
  performanceObserver,
  structuredClone: structuredClone$1,
  webSockets,
  webWorkers
}, Symbol.toStringTag, { value: "Module" })), VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env$1 = typeof self == "object" ? self : globalThis, deserializer = (n, l) => {
  const t = (c, a) => (n.set(a, c), c), s = (c) => {
    if (n.has(c))
      return n.get(c);
    const [a, r] = l[c];
    switch (a) {
      case PRIMITIVE:
      case VOID:
        return t(r, c);
      case ARRAY: {
        const o = t([], c);
        for (const h of r)
          o.push(s(h));
        return o;
      }
      case OBJECT: {
        const o = t({}, c);
        for (const [h, b] of r)
          o[s(h)] = s(b);
        return o;
      }
      case DATE:
        return t(new Date(r), c);
      case REGEXP: {
        const { source: o, flags: h } = r;
        return t(new RegExp(o, h), c);
      }
      case MAP: {
        const o = t(/* @__PURE__ */ new Map(), c);
        for (const [h, b] of r)
          o.set(s(h), s(b));
        return o;
      }
      case SET: {
        const o = t(/* @__PURE__ */ new Set(), c);
        for (const h of r)
          o.add(s(h));
        return o;
      }
      case ERROR: {
        const { name: o, message: h } = r;
        return t(new env$1[o](h), c);
      }
      case BIGINT:
        return t(BigInt(r), c);
      case "BigInt":
        return t(Object(BigInt(r)), c);
    }
    return t(new env$1[a](r), c);
  };
  return s;
}, deserialize$1 = (n) => deserializer(/* @__PURE__ */ new Map(), n)(0), EMPTY$1 = "", { toString } = {}, { keys } = Object, typeOf = (n) => {
  const l = typeof n;
  if (l !== "object" || !n)
    return [PRIMITIVE, l];
  const t = toString.call(n).slice(8, -1);
  switch (t) {
    case "Array":
      return [ARRAY, EMPTY$1];
    case "Object":
      return [OBJECT, EMPTY$1];
    case "Date":
      return [DATE, EMPTY$1];
    case "RegExp":
      return [REGEXP, EMPTY$1];
    case "Map":
      return [MAP, EMPTY$1];
    case "Set":
      return [SET, EMPTY$1];
  }
  return t.includes("Array") ? [ARRAY, t] : t.includes("Error") ? [ERROR, t] : [OBJECT, t];
}, shouldSkip = ([n, l]) => n === PRIMITIVE && (l === "function" || l === "symbol"), serializer = (n, l, t, s) => {
  const c = (r, o) => {
    const h = s.push(r) - 1;
    return t.set(o, h), h;
  }, a = (r) => {
    if (t.has(r))
      return t.get(r);
    let [o, h] = typeOf(r);
    switch (o) {
      case PRIMITIVE: {
        let u = r;
        switch (h) {
          case "bigint":
            o = BIGINT, u = r.toString();
            break;
          case "function":
          case "symbol":
            if (n)
              throw new TypeError("unable to serialize " + h);
            u = null;
            break;
          case "undefined":
            return c([VOID], r);
        }
        return c([o, u], r);
      }
      case ARRAY: {
        if (h)
          return c([h, [...r]], r);
        const u = [], Z = c([o, u], r);
        for (const p of r)
          u.push(a(p));
        return Z;
      }
      case OBJECT: {
        if (h)
          switch (h) {
            case "BigInt":
              return c([h, r.toString()], r);
            case "Boolean":
            case "Number":
            case "String":
              return c([h, r.valueOf()], r);
          }
        if (l && "toJSON" in r)
          return a(r.toJSON());
        const u = [], Z = c([o, u], r);
        for (const p of keys(r))
          (n || !shouldSkip(typeOf(r[p]))) && u.push([a(p), a(r[p])]);
        return Z;
      }
      case DATE:
        return c([o, r.toISOString()], r);
      case REGEXP: {
        const { source: u, flags: Z } = r;
        return c([o, { source: u, flags: Z }], r);
      }
      case MAP: {
        const u = [], Z = c([o, u], r);
        for (const [p, G] of r)
          (n || !(shouldSkip(typeOf(p)) || shouldSkip(typeOf(G)))) && u.push([a(p), a(G)]);
        return Z;
      }
      case SET: {
        const u = [], Z = c([o, u], r);
        for (const p of r)
          (n || !shouldSkip(typeOf(p))) && u.push(a(p));
        return Z;
      }
    }
    const { message: b } = r;
    return c([o, { name: h, message: b }], r);
  };
  return a;
}, serialize$1 = (n, { json: l, lossy: t } = {}) => {
  const s = [];
  return serializer(!(l || t), !!l, /* @__PURE__ */ new Map(), s)(n), s;
}, _structuredClone = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (n, l) => l && ("json" in l || "lossy" in l) ? deserialize$1(serialize$1(n, l)) : structuredClone(n)
) : (n, l) => deserialize$1(serialize$1(n, l)), clone$1 = structuredClone$1() ? globalThis.structuredClone : _structuredClone;
function deepClone(n) {
  return clone$1(n);
}
var VMutationType;
(function(n) {
  n[n.AddNode = 1] = "AddNode", n[n.RemoveNode = 2] = "RemoveNode", n[n.ChangeAttributes = 3] = "ChangeAttributes", n[n.CharacterData = 4] = "CharacterData", n[n.Document = 10] = "Document", n[n.StyleSheetRule = 20] = "StyleSheetRule", n[n.StyleSheetAdopted = 21] = "StyleSheetAdopted";
})(VMutationType || (VMutationType = {}));
var VNodeType;
(function(n) {
  n[n.ElementNode = 1] = "ElementNode", n[n.TextNode = 3] = "TextNode", n[n.CommentNode = 8] = "CommentNode", n[n.DocumentNode = 9] = "DocumentNode", n[n.HTMLNode = 10] = "HTMLNode", n[n.DocumentFragmentNode = 11] = "DocumentFragmentNode";
})(VNodeType || (VNodeType = {}));
function isHTMLStyleElement(n) {
  return n.tagName === "STYLE";
}
function isHTMLInputElement(n) {
  return n.tagName === "INPUT";
}
function isHTMLOptionElement(n) {
  return n.tagName === "OPTION";
}
function isHTMLScriptElement(n) {
  return n.tagName === "SCRIPT";
}
function isHTMLSelectElement(n) {
  return n.tagName === "SELECT";
}
function isHTMLTextAreaElement(n) {
  return n.tagName === "TEXTAREA";
}
function isWindow(n) {
  return typeof n == "object" && !!n && "window" in n && n.window === n;
}
function isHTMLElement(n) {
  return n.nodeType === Node.ELEMENT_NODE;
}
function isVNode(n) {
  return n != null && n.id != null && n.type != null && !(n instanceof Node);
}
function isVParentNode(n) {
  return "children" in n;
}
function isVElement(n) {
  return n.type === VNodeType.ElementNode;
}
function isVStyleElement(n) {
  return isVElement(n) && n.tag === "STYLE";
}
function isVTextNode(n) {
  return n.type === VNodeType.TextNode;
}
function isReactRef(n) {
  return n !== null && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current");
}
function parseHeaders(n) {
  let l = {};
  return n != null && (isFetchHeaders(n) ? n.forEach((t, s) => {
    l[s] = t;
  }) : Array.isArray(n) ? n.forEach(([t, s]) => {
    l[t] = s;
  }) : isString(n) ? n.trim().split(/[\r\n]+/).forEach((s) => {
    const c = s.split(": "), a = c[0];
    a != null && a.trim() !== "" && (l[a] = c[1]);
  }) : l = v({}, n)), l;
}
function flattenFormData(n) {
  const l = {};
  return n.forEach((t, s) => {
    t instanceof File ? l[s] = "[object File]" : l[s] = t;
  }), l;
}
function generateUUID$1() {
  return typeof crypto.randomUUID == "function" ? crypto.randomUUID() : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (n) => (n ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> n / 4).toString(16));
}
const caniuse = ciu;
function now() {
  return caniuse.performanceNow() ? globalThis.performance.now() : Date.now();
}
const time = {
  offset: 0,
  now() {
    return now() + time.offset;
  },
  sync(n) {
    time.offset = n - now();
  }
};
function convertDOMHighResTimeStamp2AbsoluteTime(n) {
  return performance.timeOrigin + n;
}
let ric = globalThis.requestIdleCallback;
ric || (ric = function(t, s) {
  const c = now();
  return setTimeout(() => {
    var r;
    const a = now() - c;
    t({
      didTimeout: (r = (s == null ? void 0 : s.timeout) != null && a > s.timeout) != null ? r : !1,
      timeRemaining() {
        return Math.max(0, 7 - a);
      }
    });
  });
});
class APIError extends ServerError {
  constructor(t, s, c, a) {
    super(`Error occurs when invoking API "${t}": ${c}`, M(v({}, a != null ? a : {}), { code: s }));
    d(this, "path");
    this.path = t, this.name = "bytereplay.core.APIError";
  }
}
const FETCH_FLAG = "bytereplay";
class APIClient {
  constructor(n) {
    d(this, "_env");
    d(this, "_requestInterceptor");
    this._env = n;
  }
  get apiURL() {
    return `${this._env.baseURL}${this._env.apiPrefix}`;
  }
  get env() {
    return this._env;
  }
  set requestInterceptor(value) {
    isString(value) ? this._requestInterceptor = eval(value) : this._requestInterceptor = value;
  }
  get(n, l, t) {
    return V(this, null, function* () {
      return this._request("GET", n, l, t);
    });
  }
  post(n, l, t) {
    return V(this, null, function* () {
      return this._request("POST", n, l, t);
    });
  }
  _request(n, l, t, s) {
    return V(this, null, function* () {
      let c = { path: l, headers: s };
      if (this._requestInterceptor)
        try {
          c = this._requestInterceptor(l, s);
        } catch (u) {
        }
      const a = n === "POST", r = this._makeURL(c.path);
      if (n === "GET" && t) {
        for (const [u, Z] of Object.entries(t))
          if (Z != null) {
            let p;
            Z instanceof Date ? p = Z.toISOString() : p = Z.toString(), r.searchParams.set(u, p);
          }
      }
      const o = {};
      let h;
      a && (isFormData(t) ? h = t : (h = JSON.stringify(t), o["Content-Type"] = "application/json"));
      const b = fetch(r.href, {
        method: n,
        mode: "cors",
        body: h,
        headers: v(v(v({}, o), this._env.headers || {}), c.headers || {}),
        [FETCH_FLAG]: !0
      });
      return this._dealWithResponse(c.path, b);
    });
  }
  _dealWithResponse(n, l) {
    return V(this, null, function* () {
      let t;
      try {
        t = yield l;
      } catch (c) {
        throw new ServerError(`Error occurs when invoking API "${n}": ${c.message}`, { cause: c });
      }
      let s;
      try {
        s = yield t.json();
      } catch (c) {
        throw new ServerError(`Response of API "${n}" can not be parsed into JSON.`, { cause: c });
      }
      if (s.success)
        return s.data;
      throw new APIError(n, s.code, s.message);
    });
  }
  _makeURL(n) {
    return new URL(n, this.apiURL);
  }
}
class AbstractRecordingStorage {
}
const instanceOfAny = (n, l) => l.some((t) => n instanceof t);
let idbProxyableTypes, cursorAdvanceMethods;
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const transactionDoneMap = /* @__PURE__ */ new WeakMap(), transformCache = /* @__PURE__ */ new WeakMap(), reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(n) {
  const l = new Promise((t, s) => {
    const c = () => {
      n.removeEventListener("success", a), n.removeEventListener("error", r);
    }, a = () => {
      t(wrap$1(n.result)), c();
    }, r = () => {
      s(n.error), c();
    };
    n.addEventListener("success", a), n.addEventListener("error", r);
  });
  return reverseTransformCache.set(l, n), l;
}
function cacheDonePromiseForTransaction(n) {
  if (transactionDoneMap.has(n))
    return;
  const l = new Promise((t, s) => {
    const c = () => {
      n.removeEventListener("complete", a), n.removeEventListener("error", r), n.removeEventListener("abort", r);
    }, a = () => {
      t(), c();
    }, r = () => {
      s(n.error || new DOMException("AbortError", "AbortError")), c();
    };
    n.addEventListener("complete", a), n.addEventListener("error", r), n.addEventListener("abort", r);
  });
  transactionDoneMap.set(n, l);
}
let idbProxyTraps = {
  get(n, l, t) {
    if (n instanceof IDBTransaction) {
      if (l === "done")
        return transactionDoneMap.get(n);
      if (l === "store")
        return t.objectStoreNames[1] ? void 0 : t.objectStore(t.objectStoreNames[0]);
    }
    return wrap$1(n[l]);
  },
  set(n, l, t) {
    return n[l] = t, !0;
  },
  has(n, l) {
    return n instanceof IDBTransaction && (l === "done" || l === "store") ? !0 : l in n;
  }
};
function replaceTraps(n) {
  idbProxyTraps = n(idbProxyTraps);
}
function wrapFunction(n) {
  return getCursorAdvanceMethods().includes(n) ? function(...l) {
    return n.apply(unwrap(this), l), wrap$1(this.request);
  } : function(...l) {
    return wrap$1(n.apply(unwrap(this), l));
  };
}
function transformCachableValue(n) {
  return typeof n == "function" ? wrapFunction(n) : (n instanceof IDBTransaction && cacheDonePromiseForTransaction(n), instanceOfAny(n, getIdbProxyableTypes()) ? new Proxy(n, idbProxyTraps) : n);
}
function wrap$1(n) {
  if (n instanceof IDBRequest)
    return promisifyRequest(n);
  if (transformCache.has(n))
    return transformCache.get(n);
  const l = transformCachableValue(n);
  return l !== n && (transformCache.set(n, l), reverseTransformCache.set(l, n)), l;
}
const unwrap = (n) => reverseTransformCache.get(n);
function openDB(n, l, { blocked: t, upgrade: s, blocking: c, terminated: a } = {}) {
  const r = indexedDB.open(n, l), o = wrap$1(r);
  return s && r.addEventListener("upgradeneeded", (h) => {
    s(wrap$1(r.result), h.oldVersion, h.newVersion, wrap$1(r.transaction), h);
  }), t && r.addEventListener("blocked", (h) => t(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    h.oldVersion,
    h.newVersion,
    h
  )), o.then((h) => {
    a && h.addEventListener("close", () => a()), c && h.addEventListener("versionchange", (b) => c(b.oldVersion, b.newVersion, b));
  }).catch(() => {
  }), o;
}
const readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"], writeMethods = ["put", "add", "delete", "clear"], cachedMethods = /* @__PURE__ */ new Map();
function getMethod(n, l) {
  if (!(n instanceof IDBDatabase && !(l in n) && typeof l == "string"))
    return;
  if (cachedMethods.get(l))
    return cachedMethods.get(l);
  const t = l.replace(/FromIndex$/, ""), s = l !== t, c = writeMethods.includes(t);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(t in (s ? IDBIndex : IDBObjectStore).prototype) || !(c || readMethods.includes(t))
  )
    return;
  const a = function(r, ...o) {
    return V(this, null, function* () {
      const h = this.transaction(r, c ? "readwrite" : "readonly");
      let b = h.store;
      return s && (b = b.index(o.shift())), (yield Promise.all([
        b[t](...o),
        c && h.done
      ]))[0];
    });
  };
  return cachedMethods.set(l, a), a;
}
replaceTraps((n) => M(v({}, n), {
  get: (l, t, s) => getMethod(l, t) || n.get(l, t, s),
  has: (l, t) => !!getMethod(l, t) || n.has(l, t)
}));
const advanceMethodProps = ["continue", "continuePrimaryKey", "advance"], methodMap = {}, advanceResults = /* @__PURE__ */ new WeakMap(), ittrProxiedCursorToOriginalProxy = /* @__PURE__ */ new WeakMap(), cursorIteratorTraps = {
  get(n, l) {
    if (!advanceMethodProps.includes(l))
      return n[l];
    let t = methodMap[l];
    return t || (t = methodMap[l] = function(...s) {
      advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[l](...s));
    }), t;
  }
};
function iterate(...n) {
  return ye(this, null, function* () {
    let l = this;
    if (l instanceof IDBCursor || (l = yield new ne(l.openCursor(...n))), !l)
      return;
    l = l;
    const t = new Proxy(l, cursorIteratorTraps);
    for (ittrProxiedCursorToOriginalProxy.set(t, l), reverseTransformCache.set(t, unwrap(l)); l; )
      yield t, l = yield new ne(advanceResults.get(t) || l.continue()), advanceResults.delete(t);
  });
}
function isIteratorProp(n, l) {
  return l === Symbol.asyncIterator && instanceOfAny(n, [IDBIndex, IDBObjectStore, IDBCursor]) || l === "iterate" && instanceOfAny(n, [IDBIndex, IDBObjectStore]);
}
replaceTraps((n) => M(v({}, n), {
  get(l, t, s) {
    return isIteratorProp(l, t) ? iterate : n.get(l, t, s);
  },
  has(l, t) {
    return isIteratorProp(l, t) || n.has(l, t);
  }
}));
const DATABASE_NAME = "bytereplay-database", TABLE_NAME = "recordings";
class IndexedDBRecordingStorage extends AbstractRecordingStorage {
  constructor() {
    super(...arguments);
    d(this, "_db");
    d(this, "_openLock");
  }
  getRecordings() {
    return V(this, null, function* () {
      return (yield this._getDatabase()).getAll(TABLE_NAME);
    });
  }
  putRecordings(t, s) {
    return V(this, null, function* () {
      if (t.length > 0) {
        const r = (yield this._getDatabase()).transaction(TABLE_NAME, "readwrite");
        if (yield Promise.all(t.map((o) => r.store.put(o))), s != null) {
          let o = (yield r.store.count()) - s;
          if (o > 0) {
            let h = yield r.store.openCursor();
            for (; o > 0 && h; )
              o--, yield h.delete(), h = yield h.continue();
          }
        }
        yield r.done;
      }
    });
  }
  deleteRecordings(...t) {
    return V(this, null, function* () {
      if (t.length > 0) {
        const s = t.map((r) => r.id);
        let a = yield (yield this._getDatabase()).transaction(TABLE_NAME, "readwrite").store.openCursor();
        for (; a; )
          s.some((r) => (a == null ? void 0 : a.value.id) === r) && (yield a.delete(), a = yield a.continue());
      }
    });
  }
  _getDatabase() {
    return V(this, null, function* () {
      return this._db != null ? this._db : (this._openLock == null && (this._openLock = openDB(DATABASE_NAME, 1, {
        upgrade(t) {
          t.createObjectStore("recordings", { autoIncrement: !0 });
        }
      }).then((t) => (this._db = t, t))), this._openLock);
    });
  }
}
class IndexedDBRecordingStorageProvider {
  constructor() {
    d(this, "_storage");
  }
  getStorage() {
    return this._storage || (this._storage = new IndexedDBRecordingStorage()), this._storage;
  }
}
class Queue {
  constructor() {
    d(this, "_queue", []);
  }
  get length() {
    return this._queue.length;
  }
  clear() {
    this._queue.length = 0;
  }
  dequeue() {
    return this._queue.shift();
  }
  dump() {
    const l = this.toArray();
    return this._queue.splice(0, l.length), l;
  }
  enqueue(...l) {
    return this._queue.push(...l);
  }
  find(l, t) {
    return this._queue.find(l, t);
  }
  findIndex(l, t) {
    return this._queue.findIndex(l, t);
  }
  forEach(l, t) {
    this._queue.forEach(l, t || this);
  }
  map(l, t) {
    return this._queue.map(l, t || this);
  }
  peek() {
    return this._queue[0];
  }
  remove(l) {
    return this._queue.splice(l, 1)[0];
  }
  slice(l, t) {
    return this._queue.slice(l, t);
  }
  toArray() {
    return [...this._queue];
  }
}
const se = class se {
  constructor(l) {
    d(this, "_options");
    this._options = this._normalize(l);
  }
  attempt(l, t) {
    return V(this, null, function* () {
      return typeof l != "function" ? Promise.reject(new Error("executor is not function")) : this._attempt(l, this._normalize(t, this._options));
    });
  }
  _attempt(l, t, s = 1) {
    return V(this, null, function* () {
      return l().catch((c) => {
        if (t.shouldRetry && !t.shouldRetry(c))
          throw c;
        if (s < t.retries)
          return this._delay(this._randomTimeout(s, t)).then(() => this._attempt(l, t, s + 1));
        throw c;
      });
    });
  }
  _normalize(l, t = se.DEFAULT_OPTIONS) {
    const s = v({}, t);
    if (l) {
      const { retries: c, initialTimeout: a, maxTimeout: r, randomize: o } = l;
      c != null && c >= 0 && (s.retries = c), a != null && a >= 0 && (s.initialTimeout = a), r != null && r >= s.initialTimeout && (s.maxTimeout = r), o != null && o >= 1 && o <= 2 && (o < 1 ? s.randomize = 1 : o > 2 ? s.randomize = 2 : s.randomize = o), l != null && l.shouldRetry && (s.shouldRetry = l.shouldRetry);
    }
    return s;
  }
  _delay(l) {
    return new Promise((t) => {
      setTimeout(() => {
        t();
      }, l);
    });
  }
  _randomTimeout(l, t) {
    const { randomize: s, initialTimeout: c, maxTimeout: a, factor: r } = t;
    return Math.min(s * c * he(r, l), a);
  }
};
d(se, "DEFAULT_OPTIONS", {
  retries: 3,
  initialTimeout: 1e3,
  maxTimeout: 1 / 0,
  randomize: 1.5,
  factor: 1.5,
  shouldRetry: () => !0
});
let Retry = se;
var eventemitter3 = { exports: {} };
(function(n) {
  var l = Object.prototype.hasOwnProperty, t = "~";
  function s() {
  }
  Object.create && (s.prototype = /* @__PURE__ */ Object.create(null), new s().__proto__ || (t = !1));
  function c(h, b, u) {
    this.fn = h, this.context = b, this.once = u || !1;
  }
  function a(h, b, u, Z, p) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var G = new c(u, Z || h, p), f = t ? t + b : b;
    return h._events[f] ? h._events[f].fn ? h._events[f] = [h._events[f], G] : h._events[f].push(G) : (h._events[f] = G, h._eventsCount++), h;
  }
  function r(h, b) {
    --h._eventsCount === 0 ? h._events = new s() : delete h._events[b];
  }
  function o() {
    this._events = new s(), this._eventsCount = 0;
  }
  o.prototype.eventNames = function() {
    var b = [], u, Z;
    if (this._eventsCount === 0)
      return b;
    for (Z in u = this._events)
      l.call(u, Z) && b.push(t ? Z.slice(1) : Z);
    return Object.getOwnPropertySymbols ? b.concat(Object.getOwnPropertySymbols(u)) : b;
  }, o.prototype.listeners = function(b) {
    var u = t ? t + b : b, Z = this._events[u];
    if (!Z)
      return [];
    if (Z.fn)
      return [Z.fn];
    for (var p = 0, G = Z.length, f = new Array(G); p < G; p++)
      f[p] = Z[p].fn;
    return f;
  }, o.prototype.listenerCount = function(b) {
    var u = t ? t + b : b, Z = this._events[u];
    return Z ? Z.fn ? 1 : Z.length : 0;
  }, o.prototype.emit = function(b, u, Z, p, G, f) {
    var R = t ? t + b : b;
    if (!this._events[R])
      return !1;
    var Y = this._events[R], S = arguments.length, g, J;
    if (Y.fn) {
      switch (Y.once && this.removeListener(b, Y.fn, void 0, !0), S) {
        case 1:
          return Y.fn.call(Y.context), !0;
        case 2:
          return Y.fn.call(Y.context, u), !0;
        case 3:
          return Y.fn.call(Y.context, u, Z), !0;
        case 4:
          return Y.fn.call(Y.context, u, Z, p), !0;
        case 5:
          return Y.fn.call(Y.context, u, Z, p, G), !0;
        case 6:
          return Y.fn.call(Y.context, u, Z, p, G, f), !0;
      }
      for (J = 1, g = new Array(S - 1); J < S; J++)
        g[J - 1] = arguments[J];
      Y.fn.apply(Y.context, g);
    } else {
      var U = Y.length, L;
      for (J = 0; J < U; J++)
        switch (Y[J].once && this.removeListener(b, Y[J].fn, void 0, !0), S) {
          case 1:
            Y[J].fn.call(Y[J].context);
            break;
          case 2:
            Y[J].fn.call(Y[J].context, u);
            break;
          case 3:
            Y[J].fn.call(Y[J].context, u, Z);
            break;
          case 4:
            Y[J].fn.call(Y[J].context, u, Z, p);
            break;
          default:
            if (!g)
              for (L = 1, g = new Array(S - 1); L < S; L++)
                g[L - 1] = arguments[L];
            Y[J].fn.apply(Y[J].context, g);
        }
    }
    return !0;
  }, o.prototype.on = function(b, u, Z) {
    return a(this, b, u, Z, !1);
  }, o.prototype.once = function(b, u, Z) {
    return a(this, b, u, Z, !0);
  }, o.prototype.removeListener = function(b, u, Z, p) {
    var G = t ? t + b : b;
    if (!this._events[G])
      return this;
    if (!u)
      return r(this, G), this;
    var f = this._events[G];
    if (f.fn)
      f.fn === u && (!p || f.once) && (!Z || f.context === Z) && r(this, G);
    else {
      for (var R = 0, Y = [], S = f.length; R < S; R++)
        (f[R].fn !== u || p && !f[R].once || Z && f[R].context !== Z) && Y.push(f[R]);
      Y.length ? this._events[G] = Y.length === 1 ? Y[0] : Y : r(this, G);
    }
    return this;
  }, o.prototype.removeAllListeners = function(b) {
    var u;
    return b ? (u = t ? t + b : b, this._events[u] && r(this, u)) : (this._events = new s(), this._eventsCount = 0), this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = t, o.EventEmitter = o, n.exports = o;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
class RotatingQueue extends Queue {
  constructor(t) {
    super();
    d(this, "_size");
    d(this, "_emitter");
    this._size = Math.max(t, 1), this._emitter = new EventEmitter();
  }
  get isFull() {
    return this._size === this.length;
  }
  enqueue(...t) {
    let s = 0, c = !1;
    const a = t.length, r = this.length + a - this._size;
    r > 0 && (c = !0, this._queue.splice(0, r));
    const o = a - this._size;
    return o > 0 ? (c = !0, s = super.enqueue(...t.slice(o))) : s = super.enqueue(...t), c && this._emitter.emit("rotated"), s;
  }
  on(t, s) {
    return this._emitter.on(t, s), this;
  }
  off(t, s) {
    return this._emitter.off(t, s), this;
  }
}
const DATA_MASK = "data-bytereplay-mask", DATA_MASK_EMPTY = ["", "true"], DATA_MASK_MAP = {
  ignore: "ignore",
  name: "name"
};
class AbstractDataMask {
  constructor(l, t = "*") {
    d(this, "_searchCondition");
    d(this, "_maskingCharacter");
    this._searchCondition = l, this._maskingCharacter = t;
  }
  mask(l) {
    return l.replace(this._searchCondition, (t) => this.maskSubstring(t, this._maskingCharacter));
  }
}
class CombinedDataMask {
  constructor(...l) {
    d(this, "_masks");
    this._masks = l;
  }
  mask(l) {
    return this._masks.reduce((t, s) => s.mask(t), l);
  }
}
var DataMaskingLevel;
(function(n) {
  n.BALANCE = "BALANCE", n.STRICT = "STRICT";
})(DataMaskingLevel || (DataMaskingLevel = {}));
class BankAccountDataMask extends AbstractDataMask {
  constructor() {
    super(/\b[1-9](?:\d{18}|\d{17}|\d{16}|\d{15}|\d{11})\b/gm);
  }
  maskSubstring(l, t) {
    return `${l.slice(0, -4).replace(/\S/g, t)}${l.slice(-4)}`;
  }
}
class ChineseNameDataMask extends AbstractDataMask {
  constructor() {
    super(/[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*/gm);
  }
  maskSubstring(l, t) {
    const s = l.length <= 3 ? 1 : 2;
    return `${l.slice(0, s).replace(/\S/g, t)}${l.slice(s)}`;
  }
}
class EmailDataMask extends AbstractDataMask {
  constructor() {
    super(/[A-Za-z0-9.\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)+/gim);
  }
  maskSubstring(l, t) {
    const s = l.indexOf("@");
    return `${l.slice(0, s).slice(0, 3)}${t.repeat(3)}${l.slice(s)}`;
  }
}
class EnglishNameDataMask extends AbstractDataMask {
  constructor() {
    super(/(?:[a-zA-Z']{2,} ?)+/gm);
  }
  maskSubstring(l, t) {
    const s = l.indexOf(" ");
    return s === -1 ? `${l.slice(0, 1)}${l.slice(1).replace(/\S/g, t)}` : `${l.slice(0, s).replace(/\S/g, t)}${l.slice(s)}`;
  }
}
class IDCardDataMask extends AbstractDataMask {
  constructor() {
    super(/([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx])/gm);
  }
  maskSubstring(l, t) {
    return `${l.slice(0, 1)}${l.slice(1, -1).replace(/\S/g, t)}${l.slice(-1)}`;
  }
}
class IPAddressDataMask extends AbstractDataMask {
  constructor() {
    super(/((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/gm);
  }
  maskSubstring(l, t) {
    const s = l.indexOf(".") + 1;
    return `${l.slice(0, s)}${l.slice(s).replace(/[^.]/g, t)}`;
  }
}
class LicensePlateDataMask extends AbstractDataMask {
  constructor() {
    super(/([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])/gm);
  }
  maskSubstring(l, t) {
    return `${l.slice(0, 2)}${l.slice(2, -3).replace(/\S/g, t)}${l.slice(-3)}`;
  }
}
class MACAddressDataMask extends AbstractDataMask {
  constructor() {
    super(/(([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2}))|(([0-9A-Fa-f]{2}-){5}([0-9A-Fa-f]{2}))/gm);
  }
  maskSubstring(l, t) {
    const s = l.indexOf(":") + 1, c = l.indexOf("-") + 1, a = s === 0 ? c : s;
    return `${l.slice(0, a)}${l.slice(a).replace(/[^:]/g, t)}`;
  }
}
class MobilePhoneDataMask extends AbstractDataMask {
  constructor() {
    super(/\b(?:(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[0-35-9]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|6[2567]\d{2}|4(?:(?:10|4[01])\d{3}|[68]\d{4}|[579]\d{2}))\d{6})|(0?(?:10|(?:2|3[1,5,7]|4[1,5,7]|5[1,3,5,7]|7[1,3,5,7,9]|8[1,3,7,9])[0-9]|91[0-7,9]|(?:43|59|85)[1-9]|39[1-8]|54[3,6]|(?:701|580|349|335)|54[3,6]|69[1-2]|44[0,8]|48[2,3]|46[4,7,8,9]|52[0,3,7]|42[1,7,9]|56[1-6]|63[1-5]|66[0-3,8]|72[2,4,8]|74[3-6]|76[0,2,3,5,6,8,9]|82[5-7]|88[1,3,6-8]|90[1-3,6,8,9])\-?\d{7,8})\b/gm);
    d(this, "_regexCountryCode", /^\+?86/);
  }
  maskSubstring(t, s) {
    let c = "", a = t;
    const r = this._regexCountryCode.exec(t);
    return r && (c = r[0], a = t.slice(c.length)), `${c}${a.slice(0, 3)}${a.slice(3, -2).replace(/\S/g, s)}${a.slice(-2)}`;
  }
}
class TextDataMask extends AbstractDataMask {
  constructor() {
    super(/\S+/gm);
  }
  maskSubstring(l, t) {
    return t.repeat(l.length);
  }
}
class VINDataMask extends AbstractDataMask {
  constructor() {
    super(/\b[A-HJ-NPR-Z\d]{17}\b/gm);
  }
  maskSubstring(l, t) {
    return `${l.slice(0, 3)}${l.slice(3, -3).replace(/\S/g, t)}${l.slice(-3)}`;
  }
}
function shouldIgnore(n) {
  return !!(n && isHTMLElement(n) && n.getAttribute(DATA_MASK) === DATA_MASK_MAP.ignore);
}
const AVAILABLE_ENV_TYPE = [
  "BOE",
  "DEV",
  "PROD-INTERNAL",
  "PROD-PUBLIC",
  "PROD-SG",
  "PROD-PUBLIC-SG",
  "PROD-PUBLIC-SG-TT",
  "PROD-VA",
  "PROD-PUBLIC-VA",
  "PROD-PUBLIC-VA-TT",
  "PROD-US-TTP",
  "PROD-PUBLIC-US-TTP"
], DEFAULT_ENV = "PROD-INTERNAL";
let _currentEnv = DEFAULT_ENV;
function set(n) {
  const l = parse(n);
  if (l) {
    _currentEnv = l;
    return;
  }
  throw new Error(`Invalid environment type, it must be one of the following: ${AVAILABLE_ENV_TYPE.join(", ")}.`);
}
function get() {
  return _currentEnv;
}
function parse(n) {
  if (isString(n)) {
    const l = n.trim().toUpperCase();
    if (includes(AVAILABLE_ENV_TYPE, l))
      return l;
  }
}
const e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get,
  set
}, Symbol.toStringTag, { value: "Module" }));
class Environment {
  constructor(l) {
    d(this, "_domains", ["bytedance", "zijieapi", "tiktok-row", "byteintl", "tiktok-usts", "tiktokw", "tiktok"]);
    d(this, "DEFAULT_ENV_TYPE", "PROD-INTERNAL");
    d(this, "_type", this.DEFAULT_ENV_TYPE);
    d(this, "_baseURL");
    d(this, "_apiPrefix");
    d(this, "_headers");
    var t;
    this.baseURL = l == null ? void 0 : l.baseURL, this.type = (t = l == null ? void 0 : l.type) != null ? t : get(), this.apiPrefix = l == null ? void 0 : l.apiPrefix, this.headers = l == null ? void 0 : l.headers;
  }
  set type(l) {
    if (l != null) {
      const t = this.parse(l);
      if (t) {
        this._type = t;
        return;
      }
      throw new Error(`Invalid environment type, it must be one of the following: ${AVAILABLE_ENV_TYPE.join(", ")}.`);
    }
  }
  get type() {
    return this._type;
  }
  set baseURL(l) {
    if (l == null || isEmptyString(l))
      this._baseURL = void 0;
    else
      try {
        this._baseURL = new URL(l).href;
      } catch (t) {
        throw new RuntimeError("Invalid base URL: " + l);
      }
  }
  set apiPrefix(l) {
    l && (l.startsWith("/") && (l = l.slice(1)), l.endsWith("/") || (l += "/")), this._apiPrefix = l != null ? l : "api/";
  }
  get apiPrefix() {
    return this._apiPrefix;
  }
  set headers(l) {
    this._headers = l;
  }
  get headers() {
    return this._headers;
  }
  get baseURL() {
    return this._baseURL != null ? this._baseURL.startsWith("//") ? location.protocol + ":" + this._baseURL : this._baseURL : this.isBOE() ? `https://bytereplay-boe.${this._domains[0]}.net/` : this.isDev() ? "http://localhost:6789/" : this.isProdPublic() ? "https://bytereplay." + this._domains[1] + ".com/" : this.isProdSG() ? "https://bytereplay-sg." + this._domains[2] + ".net/" : this.isProdPublicSG() ? "https://bytereplay-sg." + this._domains[3] + "api.com/" : this.isProdVA() ? "https://bytereplay-va." + this._domains[2] + ".net/" : this.isProdPublicVA() ? "https://bytereplay-va." + this._domains[3] + "api.com/" : this.isProdUS_TTP() ? "https://bytereplay." + this._domains[4] + ".net/" : this.isProdPublicUS_TTP() ? "https://bytereplay." + this._domains[5] + ".us/" : this.isProdPublicSGForTT() ? "https://tsr16-normal-alisg." + this._domains[6] + ".com/" : this.isProdPublicVATForTT() ? "https://tsr16-normal-useast1a." + this._domains[6] + ".com/" : `https://bytereplay.${this._domains[0]}.net/`;
  }
  getFullUrl(l, t = !1) {
    if (/^(wss?:\/\/|https?:\/\/|\/\/)/.test(l))
      return l;
    const s = this.baseURL.replace(/^https?:\/\/|\/+$/g, ""), c = l.replace(/^\/+/, "");
    return `${this._getProtocol(t)}://${s}/${this.apiPrefix}${c}`;
  }
  parse(l) {
    if (isString(l)) {
      const t = l.trim().toUpperCase();
      if (includes(AVAILABLE_ENV_TYPE, t))
        return t;
    }
  }
  isBOE() {
    return this._type === "BOE";
  }
  isDev() {
    return this._type === "DEV";
  }
  isProdInternal() {
    return this._type === "PROD-INTERNAL";
  }
  isProdPublic() {
    return this._type === "PROD-PUBLIC";
  }
  isProdSG() {
    return this._type === "PROD-SG";
  }
  isProdPublicSG() {
    return this._type === "PROD-PUBLIC-SG";
  }
  isProdPublicSGForTT() {
    return this._type === "PROD-PUBLIC-SG-TT";
  }
  isProdVA() {
    return this._type === "PROD-VA";
  }
  isProdPublicVA() {
    return this._type === "PROD-PUBLIC-VA";
  }
  isProdPublicVATForTT() {
    return this._type === "PROD-PUBLIC-VA-TT";
  }
  isProdUS_TTP() {
    return this._type === "PROD-US-TTP";
  }
  isProdPublicUS_TTP() {
    return this.type === "PROD-PUBLIC-US-TTP";
  }
  toOptions() {
    return {
      type: this.type,
      baseURL: this.baseURL,
      apiPrefix: this.apiPrefix,
      headers: this.headers
    };
  }
  _getProtocol(l = !1) {
    return this.baseURL.startsWith("http:") ? l ? "ws" : "http" : l ? "wss" : "https";
  }
}
const version = "1.0.14.34", env = e;
class IOError extends RuntimeError {
  constructor(l, t) {
    super(l, t), this.name = "bytereplay.core.IOError";
  }
}
function createReadableStreamFromUint8Array(n) {
  return new ReadableStream({
    start(t) {
      return t.enqueue(n), t.close(), Promise.resolve();
    }
  });
}
function mergeUint8Arrays(n, l) {
  const t = l === void 0 ? n.reduce((a, r) => a + r.length, 0) : l, s = new Uint8Array(t);
  let c = 0;
  for (const a of n)
    s.set(a, c), c += a.length;
  return s;
}
function readAllFromStream(n) {
  return V(this, null, function* () {
    const l = n.getReader();
    return readAllFromReader(l);
  });
}
function readAllFromReader(n) {
  return V(this, null, function* () {
    let l;
    const t = [];
    for (; !(l = yield n.read()).done; )
      t.push(l.value);
    return mergeUint8Arrays(t);
  });
}
var ConnectionCloseReason;
(function(n) {
  n.ClosedByClient = "ClosedByClient", n.ClosedByServer = "ClosedByServer", n.HeartbeatTimeout = "HeartbeatTimeout", n.Unknown = "unknown";
})(ConnectionCloseReason || (ConnectionCloseReason = {}));
function GetCloseReasonByServerCode(n) {
  return n === 1e3 ? ConnectionCloseReason.ClosedByClient : n === 3001 ? ConnectionCloseReason.HeartbeatTimeout : n >= 3e3 ? ConnectionCloseReason.ClosedByServer : ConnectionCloseReason.Unknown;
}
var HeartbeatSignal;
(function(n) {
  n.Ping = "ping", n.Pong = "pong";
})(HeartbeatSignal || (HeartbeatSignal = {}));
const ie = class ie extends EventEmitter {
  constructor(t, s) {
    super();
    d(this, "connection");
    d(this, "_options");
    d(this, "_timer");
    d(this, "_handleMessage", (t) => {
      t === HeartbeatSignal.Ping && (this._pong(), this._resetTimeout());
    });
    d(this, "_handleTimeout", () => {
      this.stop(), this.emit("timeout");
    });
    this.connection = t, this._options = v(v({}, ie.DEFAULT_OPTIONS), s);
  }
  start() {
    this.connection.on("message", this._handleMessage), this._startTimeout();
  }
  stop() {
    this._clearTimeout(), this.connection.off("message", this._handleMessage);
  }
  _pong() {
    this.connection.isReady && this.connection.send(HeartbeatSignal.Pong);
  }
  _startTimeout() {
    this._resetTimeout();
  }
  _resetTimeout() {
    this._clearTimeout(), this._timer = setTimeout(this._handleTimeout, this._options.timeout);
  }
  _clearTimeout() {
    clearTimeout(this._timer), this._timer = void 0;
  }
};
d(ie, "DEFAULT_OPTIONS", {
  timeout: 12e3
});
let Heartbeat = ie;
class NetworkError extends RuntimeError {
  constructor(l, t) {
    super(l, t), this.name = "bytereplay.core.NetworkError";
  }
}
var WebSocketMessageType;
(function(n) {
  n[n.ACK = 0] = "ACK", n[n.Chunk = 1] = "Chunk", n[n.Command = 10] = "Command";
})(WebSocketMessageType || (WebSocketMessageType = {}));
function NewCommand(n) {
  return {
    type: WebSocketMessageType.Command,
    data: n
  };
}
var WebSocketConnectionEvent;
(function(n) {
  n.Open = "open", n.Send = "send", n.Message = "message", n.Closed = "closed";
})(WebSocketConnectionEvent || (WebSocketConnectionEvent = {}));
class WebSocketConnection {
  constructor(l, t) {
    d(this, "_url");
    d(this, "_emitter");
    d(this, "_heartbeat");
    d(this, "_retry");
    d(this, "_ws");
    d(this, "_opening");
    d(this, "_closing");
    d(this, "_closeReason");
    d(this, "_handleClose", (l) => {
      this._unsubscribe(this._ws), this._closeReason === void 0 && (this._closeReason = GetCloseReasonByServerCode(l.code)), this._heartbeat.stop(), this._closeReason === ConnectionCloseReason.ClosedByClient ? this._emitter.emit(WebSocketConnectionEvent.Closed) : this._closeReason === ConnectionCloseReason.ClosedByServer ? this._emitter.emit(WebSocketConnectionEvent.Closed) : this._reopen();
    });
    d(this, "_handleMessage", (l) => {
      const { data: t } = l;
      if (isString(t) && t !== HeartbeatSignal.Pong && t !== HeartbeatSignal.Ping)
        try {
          this._emitter.emit(WebSocketConnectionEvent.Message, JSON.parse(l.data));
        } catch (s) {
        }
      else
        this._emitter.emit(WebSocketConnectionEvent.Message, t);
    });
    d(this, "_handleHeartbeatTimeout", () => {
      this._closeReason === void 0 && (this._close(ConnectionCloseReason.HeartbeatTimeout), this._reopen());
    });
    this._url = l, this._emitter = new EventEmitter(), this._heartbeat = new Heartbeat(this, t == null ? void 0 : t.heartbeat), this._heartbeat.on("timeout", this._handleHeartbeatTimeout), this._retry = new Retry(t == null ? void 0 : t.retry);
  }
  get isReady() {
    var l;
    return ((l = this._ws) == null ? void 0 : l.readyState) === WebSocket.OPEN;
  }
  on(l, t, s) {
    return this._emitter.on(l, t, s), this;
  }
  off(l, t, s) {
    return this._emitter.off(l, t, s), this;
  }
  open() {
    return V(this, null, function* () {
      return this._opening || (this._opening = new Promise((l, t) => {
        this._unsubscribe(this._ws), this._ws = new WebSocket(this._url);
        const s = () => {
          var a, r;
          (a = this._ws) == null || a.removeEventListener("open", s), (r = this._ws) == null || r.removeEventListener("close", c), this._subscribe(this._ws), this._emitter.emit(WebSocketConnectionEvent.Open), this._heartbeat.start(), this._opening = void 0, l();
        }, c = () => {
          var a, r;
          (a = this._ws) == null || a.removeEventListener("open", s), (r = this._ws) == null || r.removeEventListener("close", c), this._opening = void 0, t(new NetworkError(`Failed to connect to "${this._url}"`));
        };
        this._ws.addEventListener("open", s), this._ws.addEventListener("close", c), this._ws.onerror = (a) => {
          console.error(a);
        };
      })), this._closeReason = void 0, this._opening;
    });
  }
  sendChunk(l) {
    this._emitter.emit(WebSocketConnectionEvent.Send, l), this.send(l.data);
  }
  send(l) {
    var t;
    this.isReady && ((t = this._ws) == null || t.send(l));
  }
  close() {
    return this._close(ConnectionCloseReason.ClosedByClient);
  }
  _subscribe(l) {
    l == null || l.addEventListener("close", this._handleClose), l == null || l.addEventListener("message", this._handleMessage);
  }
  _unsubscribe(l) {
    l == null || l.removeEventListener("close", this._handleClose), l == null || l.removeEventListener("message", this._handleMessage);
  }
  _close(l) {
    return V(this, null, function* () {
      var t, s;
      if (this._ws)
        return this._closeReason = l, ((t = this._ws) == null ? void 0 : t.readyState) === WebSocket.CLOSED || ((s = this._ws) == null ? void 0 : s.readyState) === WebSocket.CLOSING ? void 0 : (this._closing || (this._closing = new Promise((c) => {
          var r, o;
          const a = () => {
            var h;
            (h = this._ws) == null || h.removeEventListener("close", a), this._closing = void 0, c();
          };
          (r = this._ws) == null || r.addEventListener("close", a), (o = this._ws) == null || o.close(1e3);
        })), this._closing);
    });
  }
  _reopen() {
    this._retry.attempt(() => this.open()).catch((l) => {
      this._emitter.emit(WebSocketConnectionEvent.Closed, l);
    });
  }
}
function getEnvironmentMeta(n = document, l = window) {
  return {
    device: {
      appCodeName: l.navigator.appCodeName,
      appName: l.navigator.appName,
      appVersion: l.navigator.appVersion,
      deviceMemory: l.navigator.deviceMemory,
      hardwareConcurrency: l.navigator.hardwareConcurrency,
      language: l.navigator.language,
      languages: [...l.navigator.languages],
      platform: l.navigator.platform,
      userAgent: l.navigator.userAgent
    },
    screen: [l.screen.width, l.screen.height],
    window: {
      location: l.location.href,
      size: [l.innerWidth, l.innerHeight]
    },
    document: {
      title: n.title,
      size: [n.body.scrollWidth, n.body.scrollHeight]
    },
    version
  };
}
let Sampler$1 = class {
  constructor(l = 1, t) {
    d(this, "samplingFrequency");
    d(this, "callback");
    d(this, "_data", /* @__PURE__ */ new Map());
    d(this, "_lastTick", 0);
    d(this, "_isStopped", !0);
    d(this, "_handleFrameCallback", (l) => {
      if (l.timeRemaining() <= 0) {
        this._nextFrame();
        return;
      }
      (this._lastTick === 0 || now() - this._lastTick >= 1e3 / this.samplingFrequency) && this._tick(), this._data.size > 0 ? this._nextFrame() : this.stop();
    });
    this.samplingFrequency = l, this.callback = t;
  }
  get isStopped() {
    return this._isStopped;
  }
  sample(l, t) {
    this._data.set(l, t), this._isStopped && this.start();
  }
  start() {
    this._lastTick = 0, this._isStopped = !1, this._nextFrame();
  }
  stop() {
    this._isStopped = !0, this.flush();
  }
  flush() {
    if (this._data.size) {
      for (const [l, t] of this._data.entries())
        this.callback(l, t);
      this._data.clear();
    }
  }
  _tick() {
    this._lastTick = now(), this.flush();
  }
  _nextFrame() {
    ric(this._handleFrameCallback, { timeout: 1e3 / this.samplingFrequency });
  }
};
const DEFAULT_STRINGIFY_OPTIONS = {
  maxDepth: 5,
  maxKeys: 50
};
function stringify(n, l) {
  const t = [], s = [], c = v(v({}, DEFAULT_STRINGIFY_OPTIONS), l);
  return JSON.stringify(n, function(a, r) {
    if (t.length > 0) {
      const o = t.indexOf(this);
      ~o ? t.splice(o + 1) : t.push(this), ~o ? s.splice(o, 1 / 0, a) : s.push(a), ~t.indexOf(r) && (t[0] === r ? r = "[Circular ~]" : r = "[Circular ~." + s.slice(0, t.indexOf(r)).join(".") + "]");
    } else
      t.push(r);
    return r === null ? r : r === void 0 ? "undefined" : _shouldIgnore(r, c) ? String(r) : r;
  });
}
function exceedMaxKeys(n, l) {
  return l <= 0 ? !1 : Object.keys(n).length > l;
}
function exceedMaxDepth(n, l) {
  return l <= 0 ? !1 : _exceedMaxDepth(n, l);
}
function _exceedMaxDepth(n, l) {
  if (l === 0)
    return !0;
  for (const t of Object.values(n))
    if (isObject$1(t) && _exceedMaxDepth(t, l - 1))
      return !0;
  return !1;
}
function _shouldIgnore(n, l) {
  return !!(n instanceof Blob || n instanceof Error || n instanceof Event || n instanceof EventTarget || isFormData(n) || isFunction$1(n) || isSymbol(n) || isReactRef(n) || isObject$1(n) && (exceedMaxKeys(n, l.maxKeys) || exceedMaxDepth(n, l.maxDepth)));
}
var extendStatics = function(n, l) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, s) {
    t.__proto__ = s;
  } || function(t, s) {
    for (var c in s)
      Object.prototype.hasOwnProperty.call(s, c) && (t[c] = s[c]);
  }, extendStatics(n, l);
};
function __extends(n, l) {
  if (typeof l != "function" && l !== null)
    throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
  extendStatics(n, l);
  function t() {
    this.constructor = n;
  }
  n.prototype = l === null ? Object.create(l) : (t.prototype = l.prototype, new t());
}
function __awaiter(n, l, t, s) {
  function c(a) {
    return a instanceof t ? a : new t(function(r) {
      r(a);
    });
  }
  return new (t || (t = Promise))(function(a, r) {
    function o(u) {
      try {
        b(s.next(u));
      } catch (Z) {
        r(Z);
      }
    }
    function h(u) {
      try {
        b(s.throw(u));
      } catch (Z) {
        r(Z);
      }
    }
    function b(u) {
      u.done ? a(u.value) : c(u.value).then(o, h);
    }
    b((s = s.apply(n, l || [])).next());
  });
}
function __generator(n, l) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, s, c, a, r;
  return r = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (r[Symbol.iterator] = function() {
    return this;
  }), r;
  function o(b) {
    return function(u) {
      return h([b, u]);
    };
  }
  function h(b) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; r && (r = 0, b[0] && (t = 0)), t; )
      try {
        if (s = 1, c && (a = b[0] & 2 ? c.return : b[0] ? c.throw || ((a = c.return) && a.call(c), 0) : c.next) && !(a = a.call(c, b[1])).done)
          return a;
        switch (c = 0, a && (b = [b[0] & 2, a.value]), b[0]) {
          case 0:
          case 1:
            a = b;
            break;
          case 4:
            return t.label++, { value: b[1], done: !1 };
          case 5:
            t.label++, c = b[1], b = [0];
            continue;
          case 7:
            b = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (b[0] === 6 || b[0] === 2)) {
              t = 0;
              continue;
            }
            if (b[0] === 3 && (!a || b[1] > a[0] && b[1] < a[3])) {
              t.label = b[1];
              break;
            }
            if (b[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = b;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(b);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        b = l.call(n, t);
      } catch (u) {
        b = [6, u], c = 0;
      } finally {
        s = a = 0;
      }
    if (b[0] & 5)
      throw b[1];
    return { value: b[0] ? b[1] : void 0, done: !0 };
  }
}
function __values(n) {
  var l = typeof Symbol == "function" && Symbol.iterator, t = l && n[l], s = 0;
  if (t)
    return t.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && s >= n.length && (n = void 0), { value: n && n[s++], done: !n };
      }
    };
  throw new TypeError(l ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(n, l) {
  var t = typeof Symbol == "function" && n[Symbol.iterator];
  if (!t)
    return n;
  var s = t.call(n), c, a = [], r;
  try {
    for (; (l === void 0 || l-- > 0) && !(c = s.next()).done; )
      a.push(c.value);
  } catch (o) {
    r = { error: o };
  } finally {
    try {
      c && !c.done && (t = s.return) && t.call(s);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return a;
}
function __spreadArray(n, l, t) {
  if (t || arguments.length === 2)
    for (var s = 0, c = l.length, a; s < c; s++)
      (a || !(s in l)) && (a || (a = Array.prototype.slice.call(l, 0, s)), a[s] = l[s]);
  return n.concat(a || Array.prototype.slice.call(l));
}
function __await(n) {
  return this instanceof __await ? (this.v = n, this) : new __await(n);
}
function __asyncGenerator(n, l, t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var s = t.apply(n, l || []), c, a = [];
  return c = {}, r("next"), r("throw"), r("return"), c[Symbol.asyncIterator] = function() {
    return this;
  }, c;
  function r(p) {
    s[p] && (c[p] = function(G) {
      return new Promise(function(f, R) {
        a.push([p, G, f, R]) > 1 || o(p, G);
      });
    });
  }
  function o(p, G) {
    try {
      h(s[p](G));
    } catch (f) {
      Z(a[0][3], f);
    }
  }
  function h(p) {
    p.value instanceof __await ? Promise.resolve(p.value.v).then(b, u) : Z(a[0][2], p);
  }
  function b(p) {
    o("next", p);
  }
  function u(p) {
    o("throw", p);
  }
  function Z(p, G) {
    p(G), a.shift(), a.length && o(a[0][0], a[0][1]);
  }
}
function __asyncValues(n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var l = n[Symbol.asyncIterator], t;
  return l ? l.call(n) : (n = typeof __values == "function" ? __values(n) : n[Symbol.iterator](), t = {}, s("next"), s("throw"), s("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function s(a) {
    t[a] = n[a] && function(r) {
      return new Promise(function(o, h) {
        r = n[a](r), c(o, h, r.done, r.value);
      });
    };
  }
  function c(a, r, o, h) {
    Promise.resolve(h).then(function(b) {
      a({ value: b, done: o });
    }, r);
  }
}
typeof SuppressedError == "function" && SuppressedError;
function isFunction(n) {
  return typeof n == "function";
}
function createErrorClass(n) {
  var l = function(s) {
    Error.call(s), s.stack = new Error().stack;
  }, t = n(l);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var UnsubscriptionError = createErrorClass(function(n) {
  return function(t) {
    n(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(s, c) {
      return c + 1 + ") " + s.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function arrRemove(n, l) {
  if (n) {
    var t = n.indexOf(l);
    0 <= t && n.splice(t, 1);
  }
}
var Subscription = function() {
  function n(l) {
    this.initialTeardown = l, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return n.prototype.unsubscribe = function() {
    var l, t, s, c, a;
    if (!this.closed) {
      this.closed = !0;
      var r = this._parentage;
      if (r)
        if (this._parentage = null, Array.isArray(r))
          try {
            for (var o = __values(r), h = o.next(); !h.done; h = o.next()) {
              var b = h.value;
              b.remove(this);
            }
          } catch (R) {
            l = { error: R };
          } finally {
            try {
              h && !h.done && (t = o.return) && t.call(o);
            } finally {
              if (l)
                throw l.error;
            }
          }
        else
          r.remove(this);
      var u = this.initialTeardown;
      if (isFunction(u))
        try {
          u();
        } catch (R) {
          a = R instanceof UnsubscriptionError ? R.errors : [R];
        }
      var Z = this._finalizers;
      if (Z) {
        this._finalizers = null;
        try {
          for (var p = __values(Z), G = p.next(); !G.done; G = p.next()) {
            var f = G.value;
            try {
              execFinalizer(f);
            } catch (R) {
              a = a != null ? a : [], R instanceof UnsubscriptionError ? a = __spreadArray(__spreadArray([], __read(a)), __read(R.errors)) : a.push(R);
            }
          }
        } catch (R) {
          s = { error: R };
        } finally {
          try {
            G && !G.done && (c = p.return) && c.call(p);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      if (a)
        throw new UnsubscriptionError(a);
    }
  }, n.prototype.add = function(l) {
    var t;
    if (l && l !== this)
      if (this.closed)
        execFinalizer(l);
      else {
        if (l instanceof n) {
          if (l.closed || l._hasParent(this))
            return;
          l._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(l);
      }
  }, n.prototype._hasParent = function(l) {
    var t = this._parentage;
    return t === l || Array.isArray(t) && t.includes(l);
  }, n.prototype._addParent = function(l) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(l), t) : t ? [t, l] : l;
  }, n.prototype._removeParent = function(l) {
    var t = this._parentage;
    t === l ? this._parentage = null : Array.isArray(t) && arrRemove(t, l);
  }, n.prototype.remove = function(l) {
    var t = this._finalizers;
    t && arrRemove(t, l), l instanceof n && l._removeParent(this);
  }, n.EMPTY = function() {
    var l = new n();
    return l.closed = !0, l;
  }(), n;
}(), EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(n) {
  return n instanceof Subscription || n && "closed" in n && isFunction(n.remove) && isFunction(n.add) && isFunction(n.unsubscribe);
}
function execFinalizer(n) {
  isFunction(n) ? n() : n.unsubscribe();
}
var config = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, timeoutProvider = {
  setTimeout: function(n, l) {
    for (var t = [], s = 2; s < arguments.length; s++)
      t[s - 2] = arguments[s];
    var c = timeoutProvider.delegate;
    return c != null && c.setTimeout ? c.setTimeout.apply(c, __spreadArray([n, l], __read(t))) : setTimeout.apply(void 0, __spreadArray([n, l], __read(t)));
  },
  clearTimeout: function(n) {
    var l = timeoutProvider.delegate;
    return ((l == null ? void 0 : l.clearTimeout) || clearTimeout)(n);
  },
  delegate: void 0
};
function reportUnhandledError(n) {
  timeoutProvider.setTimeout(function() {
    throw n;
  });
}
function noop() {
}
function errorContext(n) {
  n();
}
var Subscriber = function(n) {
  __extends(l, n);
  function l(t) {
    var s = n.call(this) || this;
    return s.isStopped = !1, t ? (s.destination = t, isSubscription(t) && t.add(s)) : s.destination = EMPTY_OBSERVER, s;
  }
  return l.create = function(t, s, c) {
    return new SafeSubscriber(t, s, c);
  }, l.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, l.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, l.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, l.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, n.prototype.unsubscribe.call(this), this.destination = null);
  }, l.prototype._next = function(t) {
    this.destination.next(t);
  }, l.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, l.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, l;
}(Subscription), _bind = Function.prototype.bind;
function bind(n, l) {
  return _bind.call(n, l);
}
var ConsumerObserver = function() {
  function n(l) {
    this.partialObserver = l;
  }
  return n.prototype.next = function(l) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(l);
      } catch (s) {
        handleUnhandledError(s);
      }
  }, n.prototype.error = function(l) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(l);
      } catch (s) {
        handleUnhandledError(s);
      }
    else
      handleUnhandledError(l);
  }, n.prototype.complete = function() {
    var l = this.partialObserver;
    if (l.complete)
      try {
        l.complete();
      } catch (t) {
        handleUnhandledError(t);
      }
  }, n;
}(), SafeSubscriber = function(n) {
  __extends(l, n);
  function l(t, s, c) {
    var a = n.call(this) || this, r;
    if (isFunction(t) || !t)
      r = {
        next: t != null ? t : void 0,
        error: s != null ? s : void 0,
        complete: c != null ? c : void 0
      };
    else {
      var o;
      a && config.useDeprecatedNextContext ? (o = Object.create(t), o.unsubscribe = function() {
        return a.unsubscribe();
      }, r = {
        next: t.next && bind(t.next, o),
        error: t.error && bind(t.error, o),
        complete: t.complete && bind(t.complete, o)
      }) : r = t;
    }
    return a.destination = new ConsumerObserver(r), a;
  }
  return l;
}(Subscriber);
function handleUnhandledError(n) {
  reportUnhandledError(n);
}
function defaultErrorHandler(n) {
  throw n;
}
var EMPTY_OBSERVER = {
  closed: !0,
  next: noop,
  error: defaultErrorHandler,
  complete: noop
}, observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function identity(n) {
  return n;
}
function pipeFromArray(n) {
  return n.length === 0 ? identity : n.length === 1 ? n[0] : function(t) {
    return n.reduce(function(s, c) {
      return c(s);
    }, t);
  };
}
var Observable = function() {
  function n(l) {
    l && (this._subscribe = l);
  }
  return n.prototype.lift = function(l) {
    var t = new n();
    return t.source = this, t.operator = l, t;
  }, n.prototype.subscribe = function(l, t, s) {
    var c = this, a = isSubscriber(l) ? l : new SafeSubscriber(l, t, s);
    return errorContext(function() {
      var r = c, o = r.operator, h = r.source;
      a.add(o ? o.call(a, h) : h ? c._subscribe(a) : c._trySubscribe(a));
    }), a;
  }, n.prototype._trySubscribe = function(l) {
    try {
      return this._subscribe(l);
    } catch (t) {
      l.error(t);
    }
  }, n.prototype.forEach = function(l, t) {
    var s = this;
    return t = getPromiseCtor(t), new t(function(c, a) {
      var r = new SafeSubscriber({
        next: function(o) {
          try {
            l(o);
          } catch (h) {
            a(h), r.unsubscribe();
          }
        },
        error: a,
        complete: c
      });
      s.subscribe(r);
    });
  }, n.prototype._subscribe = function(l) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(l);
  }, n.prototype[observable] = function() {
    return this;
  }, n.prototype.pipe = function() {
    for (var l = [], t = 0; t < arguments.length; t++)
      l[t] = arguments[t];
    return pipeFromArray(l)(this);
  }, n.prototype.toPromise = function(l) {
    var t = this;
    return l = getPromiseCtor(l), new l(function(s, c) {
      var a;
      t.subscribe(function(r) {
        return a = r;
      }, function(r) {
        return c(r);
      }, function() {
        return s(a);
      });
    });
  }, n.create = function(l) {
    return new n(l);
  }, n;
}();
function getPromiseCtor(n) {
  var l;
  return (l = n != null ? n : config.Promise) !== null && l !== void 0 ? l : Promise;
}
function isObserver(n) {
  return n && isFunction(n.next) && isFunction(n.error) && isFunction(n.complete);
}
function isSubscriber(n) {
  return n && n instanceof Subscriber || isObserver(n) && isSubscription(n);
}
function hasLift(n) {
  return isFunction(n == null ? void 0 : n.lift);
}
function operate(n) {
  return function(l) {
    if (hasLift(l))
      return l.lift(function(t) {
        try {
          return n(t, this);
        } catch (s) {
          this.error(s);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function createOperatorSubscriber(n, l, t, s, c) {
  return new OperatorSubscriber(n, l, t, s, c);
}
var OperatorSubscriber = function(n) {
  __extends(l, n);
  function l(t, s, c, a, r, o) {
    var h = n.call(this, t) || this;
    return h.onFinalize = r, h.shouldUnsubscribe = o, h._next = s ? function(b) {
      try {
        s(b);
      } catch (u) {
        t.error(u);
      }
    } : n.prototype._next, h._error = a ? function(b) {
      try {
        a(b);
      } catch (u) {
        t.error(u);
      } finally {
        this.unsubscribe();
      }
    } : n.prototype._error, h._complete = c ? function() {
      try {
        c();
      } catch (b) {
        t.error(b);
      } finally {
        this.unsubscribe();
      }
    } : n.prototype._complete, h;
  }
  return l.prototype.unsubscribe = function() {
    var t;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var s = this.closed;
      n.prototype.unsubscribe.call(this), !s && ((t = this.onFinalize) === null || t === void 0 || t.call(this));
    }
  }, l;
}(Subscriber), ObjectUnsubscribedError = createErrorClass(function(n) {
  return function() {
    n(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Subject = function(n) {
  __extends(l, n);
  function l() {
    var t = n.call(this) || this;
    return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
  }
  return l.prototype.lift = function(t) {
    var s = new AnonymousSubject(this, this);
    return s.operator = t, s;
  }, l.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new ObjectUnsubscribedError();
  }, l.prototype.next = function(t) {
    var s = this;
    errorContext(function() {
      var c, a;
      if (s._throwIfClosed(), !s.isStopped) {
        s.currentObservers || (s.currentObservers = Array.from(s.observers));
        try {
          for (var r = __values(s.currentObservers), o = r.next(); !o.done; o = r.next()) {
            var h = o.value;
            h.next(t);
          }
        } catch (b) {
          c = { error: b };
        } finally {
          try {
            o && !o.done && (a = r.return) && a.call(r);
          } finally {
            if (c)
              throw c.error;
          }
        }
      }
    });
  }, l.prototype.error = function(t) {
    var s = this;
    errorContext(function() {
      if (s._throwIfClosed(), !s.isStopped) {
        s.hasError = s.isStopped = !0, s.thrownError = t;
        for (var c = s.observers; c.length; )
          c.shift().error(t);
      }
    });
  }, l.prototype.complete = function() {
    var t = this;
    errorContext(function() {
      if (t._throwIfClosed(), !t.isStopped) {
        t.isStopped = !0;
        for (var s = t.observers; s.length; )
          s.shift().complete();
      }
    });
  }, l.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(l.prototype, "observed", {
    get: function() {
      var t;
      return ((t = this.observers) === null || t === void 0 ? void 0 : t.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), l.prototype._trySubscribe = function(t) {
    return this._throwIfClosed(), n.prototype._trySubscribe.call(this, t);
  }, l.prototype._subscribe = function(t) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(t), this._innerSubscribe(t);
  }, l.prototype._innerSubscribe = function(t) {
    var s = this, c = this, a = c.hasError, r = c.isStopped, o = c.observers;
    return a || r ? EMPTY_SUBSCRIPTION : (this.currentObservers = null, o.push(t), new Subscription(function() {
      s.currentObservers = null, arrRemove(o, t);
    }));
  }, l.prototype._checkFinalizedStatuses = function(t) {
    var s = this, c = s.hasError, a = s.thrownError, r = s.isStopped;
    c ? t.error(a) : r && t.complete();
  }, l.prototype.asObservable = function() {
    var t = new Observable();
    return t.source = this, t;
  }, l.create = function(t, s) {
    return new AnonymousSubject(t, s);
  }, l;
}(Observable), AnonymousSubject = function(n) {
  __extends(l, n);
  function l(t, s) {
    var c = n.call(this) || this;
    return c.destination = t, c.source = s, c;
  }
  return l.prototype.next = function(t) {
    var s, c;
    (c = (s = this.destination) === null || s === void 0 ? void 0 : s.next) === null || c === void 0 || c.call(s, t);
  }, l.prototype.error = function(t) {
    var s, c;
    (c = (s = this.destination) === null || s === void 0 ? void 0 : s.error) === null || c === void 0 || c.call(s, t);
  }, l.prototype.complete = function() {
    var t, s;
    (s = (t = this.destination) === null || t === void 0 ? void 0 : t.complete) === null || s === void 0 || s.call(t);
  }, l.prototype._subscribe = function(t) {
    var s, c;
    return (c = (s = this.source) === null || s === void 0 ? void 0 : s.subscribe(t)) !== null && c !== void 0 ? c : EMPTY_SUBSCRIPTION;
  }, l;
}(Subject), EMPTY = new Observable(function(n) {
  return n.complete();
});
function isScheduler(n) {
  return n && isFunction(n.schedule);
}
function last(n) {
  return n[n.length - 1];
}
function popScheduler(n) {
  return isScheduler(last(n)) ? n.pop() : void 0;
}
function popNumber(n, l) {
  return typeof last(n) == "number" ? n.pop() : l;
}
var isArrayLike = function(n) {
  return n && typeof n.length == "number" && typeof n != "function";
};
function isPromise(n) {
  return isFunction(n == null ? void 0 : n.then);
}
function isInteropObservable(n) {
  return isFunction(n[observable]);
}
function isAsyncIterable(n) {
  return Symbol.asyncIterator && isFunction(n == null ? void 0 : n[Symbol.asyncIterator]);
}
function createInvalidObservableTypeError(n) {
  return new TypeError("You provided " + (n !== null && typeof n == "object" ? "an invalid object" : "'" + n + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function getSymbolIterator() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var iterator = getSymbolIterator();
function isIterable(n) {
  return isFunction(n == null ? void 0 : n[iterator]);
}
function readableStreamLikeToAsyncGenerator(n) {
  return __asyncGenerator(this, arguments, function() {
    var t, s, c, a;
    return __generator(this, function(r) {
      switch (r.label) {
        case 0:
          t = n.getReader(), r.label = 1;
        case 1:
          r.trys.push([1, , 9, 10]), r.label = 2;
        case 2:
          return [4, __await(t.read())];
        case 3:
          return s = r.sent(), c = s.value, a = s.done, a ? [4, __await(void 0)] : [3, 5];
        case 4:
          return [2, r.sent()];
        case 5:
          return [4, __await(c)];
        case 6:
          return [4, r.sent()];
        case 7:
          return r.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(n) {
  return isFunction(n == null ? void 0 : n.getReader);
}
function innerFrom(n) {
  if (n instanceof Observable)
    return n;
  if (n != null) {
    if (isInteropObservable(n))
      return fromInteropObservable(n);
    if (isArrayLike(n))
      return fromArrayLike(n);
    if (isPromise(n))
      return fromPromise(n);
    if (isAsyncIterable(n))
      return fromAsyncIterable(n);
    if (isIterable(n))
      return fromIterable(n);
    if (isReadableStreamLike(n))
      return fromReadableStreamLike(n);
  }
  throw createInvalidObservableTypeError(n);
}
function fromInteropObservable(n) {
  return new Observable(function(l) {
    var t = n[observable]();
    if (isFunction(t.subscribe))
      return t.subscribe(l);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fromArrayLike(n) {
  return new Observable(function(l) {
    for (var t = 0; t < n.length && !l.closed; t++)
      l.next(n[t]);
    l.complete();
  });
}
function fromPromise(n) {
  return new Observable(function(l) {
    n.then(function(t) {
      l.closed || (l.next(t), l.complete());
    }, function(t) {
      return l.error(t);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(n) {
  return new Observable(function(l) {
    var t, s;
    try {
      for (var c = __values(n), a = c.next(); !a.done; a = c.next()) {
        var r = a.value;
        if (l.next(r), l.closed)
          return;
      }
    } catch (o) {
      t = { error: o };
    } finally {
      try {
        a && !a.done && (s = c.return) && s.call(c);
      } finally {
        if (t)
          throw t.error;
      }
    }
    l.complete();
  });
}
function fromAsyncIterable(n) {
  return new Observable(function(l) {
    process(n, l).catch(function(t) {
      return l.error(t);
    });
  });
}
function fromReadableStreamLike(n) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(n));
}
function process(n, l) {
  var t, s, c, a;
  return __awaiter(this, void 0, void 0, function() {
    var r, o;
    return __generator(this, function(h) {
      switch (h.label) {
        case 0:
          h.trys.push([0, 5, 6, 11]), t = __asyncValues(n), h.label = 1;
        case 1:
          return [4, t.next()];
        case 2:
          if (s = h.sent(), !!s.done)
            return [3, 4];
          if (r = s.value, l.next(r), l.closed)
            return [2];
          h.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return o = h.sent(), c = { error: o }, [3, 11];
        case 6:
          return h.trys.push([6, , 9, 10]), s && !s.done && (a = t.return) ? [4, a.call(t)] : [3, 8];
        case 7:
          h.sent(), h.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (c)
            throw c.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return l.complete(), [2];
      }
    });
  });
}
function executeSchedule(n, l, t, s, c) {
  s === void 0 && (s = 0), c === void 0 && (c = !1);
  var a = l.schedule(function() {
    t(), c ? n.add(this.schedule(null, s)) : this.unsubscribe();
  }, s);
  if (n.add(a), !c)
    return a;
}
function observeOn(n, l) {
  return l === void 0 && (l = 0), operate(function(t, s) {
    t.subscribe(createOperatorSubscriber(s, function(c) {
      return executeSchedule(s, n, function() {
        return s.next(c);
      }, l);
    }, function() {
      return executeSchedule(s, n, function() {
        return s.complete();
      }, l);
    }, function(c) {
      return executeSchedule(s, n, function() {
        return s.error(c);
      }, l);
    }));
  });
}
function subscribeOn(n, l) {
  return l === void 0 && (l = 0), operate(function(t, s) {
    s.add(n.schedule(function() {
      return t.subscribe(s);
    }, l));
  });
}
function scheduleObservable(n, l) {
  return innerFrom(n).pipe(subscribeOn(l), observeOn(l));
}
function schedulePromise(n, l) {
  return innerFrom(n).pipe(subscribeOn(l), observeOn(l));
}
function scheduleArray(n, l) {
  return new Observable(function(t) {
    var s = 0;
    return l.schedule(function() {
      s === n.length ? t.complete() : (t.next(n[s++]), t.closed || this.schedule());
    });
  });
}
function scheduleIterable(n, l) {
  return new Observable(function(t) {
    var s;
    return executeSchedule(t, l, function() {
      s = n[iterator](), executeSchedule(t, l, function() {
        var c, a, r;
        try {
          c = s.next(), a = c.value, r = c.done;
        } catch (o) {
          t.error(o);
          return;
        }
        r ? t.complete() : t.next(a);
      }, 0, !0);
    }), function() {
      return isFunction(s == null ? void 0 : s.return) && s.return();
    };
  });
}
function scheduleAsyncIterable(n, l) {
  if (!n)
    throw new Error("Iterable cannot be null");
  return new Observable(function(t) {
    executeSchedule(t, l, function() {
      var s = n[Symbol.asyncIterator]();
      executeSchedule(t, l, function() {
        s.next().then(function(c) {
          c.done ? t.complete() : t.next(c.value);
        });
      }, 0, !0);
    });
  });
}
function scheduleReadableStreamLike(n, l) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(n), l);
}
function scheduled(n, l) {
  if (n != null) {
    if (isInteropObservable(n))
      return scheduleObservable(n, l);
    if (isArrayLike(n))
      return scheduleArray(n, l);
    if (isPromise(n))
      return schedulePromise(n, l);
    if (isAsyncIterable(n))
      return scheduleAsyncIterable(n, l);
    if (isIterable(n))
      return scheduleIterable(n, l);
    if (isReadableStreamLike(n))
      return scheduleReadableStreamLike(n, l);
  }
  throw createInvalidObservableTypeError(n);
}
function from(n, l) {
  return l ? scheduled(n, l) : innerFrom(n);
}
function map(n, l) {
  return operate(function(t, s) {
    var c = 0;
    t.subscribe(createOperatorSubscriber(s, function(a) {
      s.next(n.call(l, a, c++));
    }));
  });
}
function mergeInternals(n, l, t, s, c, a, r, o) {
  var h = [], b = 0, u = 0, Z = !1, p = function() {
    Z && !h.length && !b && l.complete();
  }, G = function(R) {
    return b < s ? f(R) : h.push(R);
  }, f = function(R) {
    a && l.next(R), b++;
    var Y = !1;
    innerFrom(t(R, u++)).subscribe(createOperatorSubscriber(l, function(S) {
      c == null || c(S), a ? G(S) : l.next(S);
    }, function() {
      Y = !0;
    }, void 0, function() {
      if (Y)
        try {
          b--;
          for (var S = function() {
            var g = h.shift();
            r ? executeSchedule(l, r, function() {
              return f(g);
            }) : f(g);
          }; h.length && b < s; )
            S();
          p();
        } catch (g) {
          l.error(g);
        }
    }));
  };
  return n.subscribe(createOperatorSubscriber(l, G, function() {
    Z = !0, p();
  })), function() {
    o == null || o();
  };
}
function mergeMap(n, l, t) {
  return t === void 0 && (t = 1 / 0), isFunction(l) ? mergeMap(function(s, c) {
    return map(function(a, r) {
      return l(s, a, c, r);
    })(innerFrom(n(s, c)));
  }, t) : (typeof l == "number" && (t = l), operate(function(s, c) {
    return mergeInternals(s, c, n, t);
  }));
}
function mergeAll(n) {
  return n === void 0 && (n = 1 / 0), mergeMap(identity, n);
}
function merge() {
  for (var n = [], l = 0; l < arguments.length; l++)
    n[l] = arguments[l];
  var t = popScheduler(n), s = popNumber(n, 1 / 0), c = n;
  return c.length ? c.length === 1 ? innerFrom(c[0]) : mergeAll(s)(from(c, t)) : EMPTY;
}
function share(n) {
  n === void 0 && (n = {});
  var l = n.connector, t = l === void 0 ? function() {
    return new Subject();
  } : l, s = n.resetOnError, c = s === void 0 ? !0 : s, a = n.resetOnComplete, r = a === void 0 ? !0 : a, o = n.resetOnRefCountZero, h = o === void 0 ? !0 : o;
  return function(b) {
    var u, Z, p, G = 0, f = !1, R = !1, Y = function() {
      Z == null || Z.unsubscribe(), Z = void 0;
    }, S = function() {
      Y(), u = p = void 0, f = R = !1;
    }, g = function() {
      var J = u;
      S(), J == null || J.unsubscribe();
    };
    return operate(function(J, U) {
      G++, !R && !f && Y();
      var L = p = p != null ? p : t();
      U.add(function() {
        G--, G === 0 && !R && !f && (Z = handleReset(g, h));
      }), L.subscribe(U), !u && G > 0 && (u = new SafeSubscriber({
        next: function(P) {
          return L.next(P);
        },
        error: function(P) {
          R = !0, Y(), Z = handleReset(S, c, P), L.error(P);
        },
        complete: function() {
          f = !0, Y(), Z = handleReset(S, r), L.complete();
        }
      }), innerFrom(J).subscribe(u));
    })(b);
  };
}
function handleReset(n, l) {
  for (var t = [], s = 2; s < arguments.length; s++)
    t[s - 2] = arguments[s];
  if (l === !0) {
    n();
    return;
  }
  if (l !== !1) {
    var c = new SafeSubscriber({
      next: function() {
        c.unsubscribe(), n();
      }
    });
    return innerFrom(l.apply(void 0, __spreadArray([], __read(t)))).subscribe(c);
  }
}
function tap(n, l, t) {
  var s = isFunction(n) || l || t ? { next: n, error: l, complete: t } : n;
  return s ? operate(function(c, a) {
    var r;
    (r = s.subscribe) === null || r === void 0 || r.call(s);
    var o = !0;
    c.subscribe(createOperatorSubscriber(a, function(h) {
      var b;
      (b = s.next) === null || b === void 0 || b.call(s, h), a.next(h);
    }, function() {
      var h;
      o = !1, (h = s.complete) === null || h === void 0 || h.call(s), a.complete();
    }, function(h) {
      var b;
      o = !1, (b = s.error) === null || b === void 0 || b.call(s, h), a.error(h);
    }, function() {
      var h, b;
      o && ((h = s.unsubscribe) === null || h === void 0 || h.call(s)), (b = s.finalize) === null || b === void 0 || b.call(s);
    }));
  }) : identity;
}
class AbstractFlow {
  constructor() {
    d(this, "_downstream", new Subject());
    d(this, "pipe", this._downstream.pipe.bind(this._downstream));
  }
  output(l) {
    this._downstream.next(l);
  }
  asPipeable() {
    return (l) => (l.subscribe((t) => {
      this.handleInput(t);
    }), this._downstream);
  }
}
var IFrameActionType;
(function(n) {
  n.StartRecording = "startRecording", n.StopRecording = "stopRecording", n.Unload = "unload", n.Load = "load";
})(IFrameActionType || (IFrameActionType = {}));
const IFrameEvent = "ReplayIFrameEvent";
function buildIFrameEvent(n) {
  return new CustomEvent(IFrameEvent, { detail: n });
}
var IFrameState;
(function(n) {
  n.Loading = "loading", n.Loaded = "loaded", n.Recording = "recording";
})(IFrameState || (IFrameState = {}));
var TrackerEventType;
(function(n) {
  n[n.Noop = 0] = "Noop", n[n.HTMLSnapshot = 101] = "HTMLSnapshot", n[n.HTMLMutations = 102] = "HTMLMutations", n[n.HTMLScroll = 103] = "HTMLScroll", n[n.HTMLFocus = 104] = "HTMLFocus", n[n.HTMLBlur = 105] = "HTMLBlur", n[n.HTMLValueChange = 106] = "HTMLValueChange", n[n.HTMLSelectionChange = 107] = "HTMLSelectionChange", n[n.HTMLResize = 110] = "HTMLResize", n[n.HTMLIncrementalSnapshot = 111] = "HTMLIncrementalSnapshot", n[n.HTMLNavigation = 115] = "HTMLNavigation", n[n.HTMLCanvas = 120] = "HTMLCanvas", n[n.HTMLImage = 122] = "HTMLImage", n[n.HTMLIFrame = 130] = "HTMLIFrame", n[n.MouseMove = 201] = "MouseMove", n[n.MouseDown = 202] = "MouseDown", n[n.MouseUp = 203] = "MouseUp", n[n.MouseClick = 204] = "MouseClick", n[n.TouchStart = 205] = "TouchStart", n[n.TouchMove = 206] = "TouchMove", n[n.TouchEnd = 207] = "TouchEnd", n[n.TouchCancel = 208] = "TouchCancel", n[n.KeyDown = 301] = "KeyDown", n[n.ConsoleAssert = 401] = "ConsoleAssert", n[n.ConsoleDebug = 402] = "ConsoleDebug", n[n.ConsoleDir = 403] = "ConsoleDir", n[n.ConsoleDirxml = 404] = "ConsoleDirxml", n[n.ConsoleError = 405] = "ConsoleError", n[n.ConsoleInfo = 406] = "ConsoleInfo", n[n.ConsoleLog = 407] = "ConsoleLog", n[n.ConsoleTable = 408] = "ConsoleTable", n[n.ConsoleTrace = 409] = "ConsoleTrace", n[n.ConsoleWarn = 410] = "ConsoleWarn", n[n.ERROR_SCRIPT = 501] = "ERROR_SCRIPT", n[n.ERROR_RUNTIME = 502] = "ERROR_RUNTIME", n[n.ERROR_NOTFOUND = 503] = "ERROR_NOTFOUND", n[n.ERROR_PROMISEREJECTION = 504] = "ERROR_PROMISEREJECTION", n[n.NETWORK_SEND = 601] = "NETWORK_SEND", n[n.NETWORK_DONE = 602] = "NETWORK_DONE", n[n.NETWORK_ABORT = 603] = "NETWORK_ABORT", n[n.NETWORK_ERROR = 604] = "NETWORK_ERROR", n[n.NETWORK_TIMEOUT = 605] = "NETWORK_TIMEOUT", n[n.INSIGHT_RAGE_CLICK = 701] = "INSIGHT_RAGE_CLICK", n[n.INSIGHT_DEAD_CLICK = 702] = "INSIGHT_DEAD_CLICK", n[n.INSIGHT_LONG_HOVER = 703] = "INSIGHT_LONG_HOVER", n[n.INSIGHT_EXCESSIVE_SCROLLING = 704] = "INSIGHT_EXCESSIVE_SCROLLING", n[n.PERFORMANCE_LONG_TASK = 801] = "PERFORMANCE_LONG_TASK", n[n.PERFORMANCE_RESOURCE = 802] = "PERFORMANCE_RESOURCE", n[n.PERFORMANCE_NAVIGATION = 803] = "PERFORMANCE_NAVIGATION";
})(TrackerEventType || (TrackerEventType = {}));
var TrackType;
(function(n) {
  n[n.Noop = 0] = "Noop", n[n.HTML = 100] = "HTML", n[n.Mouse = 200] = "Mouse", n[n.Keyboard = 300] = "Keyboard", n[n.Console = 400] = "Console", n[n.Error = 500] = "Error", n[n.Network = 600] = "Network", n[n.Insight = 700] = "Insight", n[n.Performance = 800] = "Performance";
})(TrackType || (TrackType = {}));
function isCustomTrackType(n) {
  return n >= 1001 && n <= 1999;
}
function checkCustomTrackType(n) {
  if (!isCustomTrackType(n))
    throw new Error("custom tracker type must be in range [1001 ~ 1999].");
  return n;
}
function newNoopFrame(n) {
  return { time: n, trackType: TrackType.Noop, event: { eventType: TrackerEventType.Noop, data: 0 } };
}
var RefType;
(function(n) {
  n.IFrame = "iframe", n.Blackbox = "blackbox", n.Transaction = "transaction";
})(RefType || (RefType = {}));
var RecordingMode;
(function(n) {
  n.Blackbox = "blackbox", n.Blocking = "blocking", n.InMemory = "in-memory", n.LiveStreaming = "live-streaming", n.Streaming = "streaming";
})(RecordingMode || (RecordingMode = {}));
var StreamingCommandType;
(function(n) {
  n.RecorderStopped = "RecorderStopped", n.ReceiverStopped = "ReceiverStopped", n.RecorderDisconnected = "RecorderDisconnected", n.SyncBlock = "SyncBlock", n.SyncPacket = "SyncPacket";
})(StreamingCommandType || (StreamingCommandType = {}));
var TransportChannelType;
(function(n) {
  n.Websocket = "websocket", n.QUIC = "quic", n.HTTP = "http";
})(TransportChannelType || (TransportChannelType = {}));
class Component extends EventEmitter {
  constructor(t) {
    super();
    d(this, "container");
    this.container = this.createElement(t);
  }
  get tagName() {
    return this.container.tagName;
  }
  addClass(...t) {
    this.container.classList.add(...t);
  }
  removeClass(t) {
    this.container.classList.remove(t);
  }
  setAttribute(t, s) {
    this.container.setAttribute(t, s);
  }
  toggleClass(t, s) {
    return this.container.classList.toggle(t, s);
  }
  placeAt(t) {
    t instanceof HTMLElement ? t.appendChild(this.container) : t.container.appendChild(this.container);
  }
  createElement(t, ...s) {
    const c = document.createElement(t);
    return s != null && s.length && c.classList.add(...s), c;
  }
  createElementNS(t, ...s) {
    const c = document.createElementNS("http://www.w3.org/2000/svg", t);
    return s != null && s.length && c.classList.add(...s), c;
  }
}
const CTX_API = [
  "arc",
  "arcTo",
  "beginPath",
  "bezierCurveTo",
  "clearRect",
  "clip",
  "closePath",
  "createConicGradient",
  "createImageData",
  "createLinearGradient",
  "createPattern",
  "createRadialGradient",
  "drawFocusIfNeeded",
  "drawImage",
  "ellipse",
  "fill",
  "fillRect",
  "fillText",
  "getContextAttributes",
  "getImageData",
  "getLineDash",
  "getTransform",
  "isContextLost",
  "isPointInPath",
  "isPointInStroke",
  "lineTo",
  "measureText",
  "moveTo",
  "putImageData",
  "quadraticCurveTo",
  "rect",
  "reset",
  "resetTransform",
  "restore",
  "rotate",
  "roundRect",
  "save",
  "scale",
  "scrollPathIntoView",
  "setLineDash",
  "setTransform",
  "stroke",
  "strokeRect",
  "strokeText",
  "transform",
  "translate"
], CTX_API_ENCODER = {
  setTransform: 0,
  lineTo: 1,
  beginPath: 2,
  fill: 3,
  setAttr: 4,
  // *
  stroke: 5,
  clip: 6,
  save: 7,
  restore: 8,
  fillText: 9,
  fillRect: 10,
  arc: 11,
  arcTo: 12,
  bezierCurveTo: 13,
  clearRect: 14,
  closePath: 15,
  createConicGradient: 16,
  createImageData: 17,
  createLinearGradient: 18,
  createPattern: 19,
  createRadialGradient: 20,
  drawFocusIfNeeded: 21,
  drawImage: 22,
  ellipse: 23,
  getContextAttributes: 24,
  getImageData: 25,
  getLineDash: 26,
  getTransform: 27,
  isContextLost: 28,
  isPointInPath: 29,
  isPointInStroke: 30,
  measureText: 31,
  moveTo: 32,
  putImageData: 33,
  quadraticCurveTo: 34,
  rect: 35,
  reset: 36,
  resetTransform: 37,
  rotate: 38,
  roundRect: 39,
  scale: 40,
  scrollPathIntoView: 41,
  setLineDash: 42,
  strokeRect: 43,
  strokeText: 44,
  transform: 45,
  translate: 46,
  snapshot: 47
  // *
}, CTX_API_DECODER = Object.keys(CTX_API_ENCODER), CTX_DRAWING_API = {
  arc: !1,
  arcTo: !1,
  beginPath: !0,
  bezierCurveTo: !1,
  clearRect: !0,
  //
  clip: !1,
  closePath: !0,
  createConicGradient: !1,
  createImageData: !1,
  createLinearGradient: !1,
  createPattern: !1,
  createRadialGradient: !1,
  drawFocusIfNeeded: !1,
  drawImage: !0,
  ellipse: !1,
  fill: !0,
  fillRect: !0,
  fillText: !0,
  getContextAttributes: !1,
  getImageData: !1,
  getLineDash: !1,
  getTransform: !1,
  isContextLost: !1,
  isPointInPath: !1,
  isPointInStroke: !1,
  lineTo: !1,
  measureText: !1,
  moveTo: !1,
  putImageData: !1,
  quadraticCurveTo: !1,
  rect: !1,
  reset: !1,
  resetTransform: !1,
  restore: !1,
  rotate: !1,
  roundRect: !1,
  save: !1,
  scale: !1,
  scrollPathIntoView: !1,
  setLineDash: !1,
  setTransform: !1,
  stroke: !0,
  strokeRect: !0,
  strokeText: !0,
  transform: !1,
  translate: !1
}, CTX_SETTING_API = [
  "resetTransform",
  "setLineDash",
  "setTransform"
], CTX_ATTR = [
  "direction",
  "fillStyle",
  "filter",
  "font",
  //'fontStretch', 'fontKerning', 'fontVariantCaps', 'letterSpacing', 'textRendering', 'wordSpacing'
  "globalAlpha",
  "globalCompositeOperation",
  "imageSmoothingEnabled",
  "imageSmoothingQuality",
  "lineCap",
  "lineDashOffset",
  "lineJoin",
  "lineWidth",
  "miterLimit",
  "shadowBlur",
  "shadowColor",
  "shadowOffsetX",
  "shadowOffsetY",
  "strokeStyle",
  "textAlign",
  "textBaseline"
], CTX_ATTR_ENCODER = {
  textRendering: 0,
  fillStyle: 1,
  strokeStyle: 2,
  font: 3,
  textAlign: 4,
  wordSpacing: 5,
  lineCap: 6,
  lineDashOffset: 7,
  lineJoin: 8,
  letterSpacing: 9,
  direction: 10,
  filter: 11,
  fontKerning: 12,
  fontStretch: 13,
  fontVariantCaps: 14,
  lineWidth: 15,
  globalCompositeOperation: 16,
  imageSmoothingEnabled: 17,
  imageSmoothingQuality: 18,
  miterLimit: 19,
  shadowBlur: 20,
  shadowColor: 21,
  shadowOffsetX: 22,
  shadowOffsetY: 23,
  textBaseline: 24,
  globalAlpha: 25
}, CTX_ATTR_DECODER = Object.keys(CTX_ATTR_ENCODER), LONG_STR_ATTR = [], pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(n) {
  this._ += n[0];
  for (let l = 1, t = n.length; l < t; ++l)
    this._ += arguments[l] + n[l];
}
function appendRound(n) {
  let l = Math.floor(n);
  if (!(l >= 0))
    throw new Error(`invalid digits: ${n}`);
  if (l > 15)
    return append;
  const t = he(10, l);
  return function(s) {
    this._ += s[0];
    for (let c = 1, a = s.length; c < a; ++c)
      this._ += Math.round(arguments[c] * t) / t + s[c];
  };
}
class Path {
  constructor(l) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = l == null ? append : appendRound(l);
  }
  moveTo(l, t) {
    this._append`M${this._x0 = this._x1 = +l},${this._y0 = this._y1 = +t}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(l, t) {
    this._append`L${this._x1 = +l},${this._y1 = +t}`;
  }
  quadraticCurveTo(l, t, s, c) {
    this._append`Q${+l},${+t},${this._x1 = +s},${this._y1 = +c}`;
  }
  bezierCurveTo(l, t, s, c, a, r) {
    this._append`C${+l},${+t},${+s},${+c},${this._x1 = +a},${this._y1 = +r}`;
  }
  arcTo(l, t, s, c, a) {
    if (l = +l, t = +t, s = +s, c = +c, a = +a, a < 0)
      throw new Error(`negative radius: ${a}`);
    let r = this._x1, o = this._y1, h = s - l, b = c - t, u = r - l, Z = o - t, p = u * u + Z * Z;
    if (this._x1 === null)
      this._append`M${this._x1 = l},${this._y1 = t}`;
    else if (p > epsilon)
      if (!(Math.abs(Z * h - b * u) > epsilon) || !a)
        this._append`L${this._x1 = l},${this._y1 = t}`;
      else {
        let G = s - r, f = c - o, R = h * h + b * b, Y = G * G + f * f, S = Math.sqrt(R), g = Math.sqrt(p), J = a * Math.tan((pi - Math.acos((R + p - Y) / (2 * S * g))) / 2), U = J / g, L = J / S;
        Math.abs(U - 1) > epsilon && this._append`L${l + U * u},${t + U * Z}`, this._append`A${a},${a},0,0,${+(Z * G > u * f)},${this._x1 = l + L * h},${this._y1 = t + L * b}`;
      }
  }
  arc(l, t, s, c, a, r) {
    if (l = +l, t = +t, s = +s, r = !!r, s < 0)
      throw new Error(`negative radius: ${s}`);
    let o = s * Math.cos(c), h = s * Math.sin(c), b = l + o, u = t + h, Z = 1 ^ r, p = r ? c - a : a - c;
    this._x1 === null ? this._append`M${b},${u}` : (Math.abs(this._x1 - b) > epsilon || Math.abs(this._y1 - u) > epsilon) && this._append`L${b},${u}`, s && (p < 0 && (p = p % tau + tau), p > tauEpsilon ? this._append`A${s},${s},0,1,${Z},${l - o},${t - h}A${s},${s},0,1,${Z},${this._x1 = b},${this._y1 = u}` : p > epsilon && this._append`A${s},${s},0,${+(p >= pi)},${Z},${this._x1 = l + s * Math.cos(a)},${this._y1 = t + s * Math.sin(a)}`);
  }
  rect(l, t, s, c) {
    this._append`M${this._x0 = this._x1 = +l},${this._y0 = this._y1 = +t}h${s = +s}v${+c}h${-s}Z`;
  }
  toString() {
    return this._;
  }
}
function path() {
  return new Path();
}
path.prototype = Path.prototype;
function Transform(n, l, t) {
  this.k = n, this.x = l, this.y = t;
}
Transform.prototype = {
  constructor: Transform,
  scale: function(n) {
    return n === 1 ? this : new Transform(this.k * n, this.x, this.y);
  },
  translate: function(n, l) {
    return n === 0 & l === 0 ? this : new Transform(this.k, this.x + this.k * n, this.y + this.k * l);
  },
  apply: function(n) {
    return [n[0] * this.k + this.x, n[1] * this.k + this.y];
  },
  applyX: function(n) {
    return n * this.k + this.x;
  },
  applyY: function(n) {
    return n * this.k + this.y;
  },
  invert: function(n) {
    return [(n[0] - this.x) / this.k, (n[1] - this.y) / this.k];
  },
  invertX: function(n) {
    return (n - this.x) / this.k;
  },
  invertY: function(n) {
    return (n - this.y) / this.k;
  },
  rescaleX: function(n) {
    return n.copy().domain(n.range().map(this.invertX, this).map(n.invert, n));
  },
  rescaleY: function(n) {
    return n.copy().domain(n.range().map(this.invertY, this).map(n.invert, n));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
Transform.prototype;
const check = function(n) {
  return n && n.Math === Math && n;
}, GLOBAL_OBJ = check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || // @ts-expect-error global is globalThis
check(typeof global == "object" && global) || check(typeof globalThis == "object" && globalThis) || function() {
  return this;
}() || Function("return this")();
function proxyPath2D() {
  if (GLOBAL_OBJ.Path2D) {
    class n extends GLOBAL_OBJ.Path2D {
      constructor(t) {
        super(t), this.path = t, this._d3Path = path();
        const s = Object.getPrototypeOf(this), c = Object.getPrototypeOf(s), a = Object.getOwnPropertyDescriptors(c), r = Object.getPrototypeOf(this._d3Path), o = Object.getOwnPropertyDescriptors(r);
        return Object.keys(a).forEach((h) => {
          Object.defineProperty(this, h, {
            writable: !0,
            value: (...b) => (Reflect.apply(o[h].value, this._d3Path, b), Reflect.apply(a[h].value, this, b))
          });
        }), this;
      }
      toJSON() {
        return {
          type: "Path2D",
          value: this._d3Path.toString()
        };
      }
    }
    return n.CANVAS_OBSERVER_PROXYED_PATH2D = !0, n;
  }
  return null;
}
function isProxyed(n) {
  return n != null && n.CANVAS_OBSERVER_PROXYED_PATH2D === !0;
}
class QuickLRU extends Map {
  constructor(l = {}) {
    if (super(), !(l.maxSize && l.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof l.maxAge == "number" && l.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = l.maxSize, this.maxAge = l.maxAge || Number.POSITIVE_INFINITY, this.onEviction = l.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(l) {
    if (typeof this.onEviction == "function")
      for (const [t, s] of l)
        this.onEviction(t, s.value);
  }
  _deleteIfExpired(l, t) {
    return typeof t.expiry == "number" && t.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(l, t.value), this.delete(l)) : !1;
  }
  _getOrDeleteIfExpired(l, t) {
    if (this._deleteIfExpired(l, t) === !1)
      return t.value;
  }
  _getItemValue(l, t) {
    return t.expiry ? this._getOrDeleteIfExpired(l, t) : t.value;
  }
  _peek(l, t) {
    const s = t.get(l);
    return this._getItemValue(l, s);
  }
  _set(l, t) {
    this.cache.set(l, t), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(l, t) {
    this.oldCache.delete(l), this._set(l, t);
  }
  *_entriesAscending() {
    for (const l of this.oldCache) {
      const [t, s] = l;
      this.cache.has(t) || this._deleteIfExpired(t, s) === !1 && (yield l);
    }
    for (const l of this.cache) {
      const [t, s] = l;
      this._deleteIfExpired(t, s) === !1 && (yield l);
    }
  }
  get(l) {
    if (this.cache.has(l)) {
      const t = this.cache.get(l);
      return this._getItemValue(l, t);
    }
    if (this.oldCache.has(l)) {
      const t = this.oldCache.get(l);
      if (this._deleteIfExpired(l, t) === !1)
        return this._moveToRecent(l, t), t.value;
    }
  }
  set(l, t, { maxAge: s = this.maxAge } = {}) {
    const c = typeof s == "number" && s !== Number.POSITIVE_INFINITY ? Date.now() + s : void 0;
    return this.cache.has(l) ? this.cache.set(l, {
      value: t,
      expiry: c
    }) : this._set(l, { value: t, expiry: c }), this;
  }
  has(l) {
    return this.cache.has(l) ? !this._deleteIfExpired(l, this.cache.get(l)) : this.oldCache.has(l) ? !this._deleteIfExpired(l, this.oldCache.get(l)) : !1;
  }
  peek(l) {
    if (this.cache.has(l))
      return this._peek(l, this.cache);
    if (this.oldCache.has(l))
      return this._peek(l, this.oldCache);
  }
  delete(l) {
    const t = this.cache.delete(l);
    return t && this._size--, this.oldCache.delete(l) || t;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(l) {
    if (!(l && l > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const t = [...this._entriesAscending()], s = t.length - l;
    s < 0 ? (this.cache = new Map(t), this.oldCache = /* @__PURE__ */ new Map(), this._size = t.length) : (s > 0 && this._emitEvictions(t.slice(0, s)), this.oldCache = new Map(t.slice(s)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = l;
  }
  *keys() {
    for (const [l] of this)
      yield l;
  }
  *values() {
    for (const [, l] of this)
      yield l;
  }
  *[Symbol.iterator]() {
    for (const l of this.cache) {
      const [t, s] = l;
      this._deleteIfExpired(t, s) === !1 && (yield [t, s.value]);
    }
    for (const l of this.oldCache) {
      const [t, s] = l;
      this.cache.has(t) || this._deleteIfExpired(t, s) === !1 && (yield [t, s.value]);
    }
  }
  *entriesDescending() {
    let l = [...this.cache];
    for (let t = l.length - 1; t >= 0; --t) {
      const s = l[t], [c, a] = s;
      this._deleteIfExpired(c, a) === !1 && (yield [c, a.value]);
    }
    l = [...this.oldCache];
    for (let t = l.length - 1; t >= 0; --t) {
      const s = l[t], [c, a] = s;
      this.cache.has(c) || this._deleteIfExpired(c, a) === !1 && (yield [c, a.value]);
    }
  }
  *entriesAscending() {
    for (const [l, t] of this._entriesAscending())
      yield [l, t.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let l = 0;
    for (const t of this.oldCache.keys())
      this.cache.has(t) || l++;
    return Math.min(this._size + l, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(l, t = this) {
    for (const [s, c] of this.entriesAscending())
      l.call(t, c, s, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
class ImageDeserializer {
  constructor() {
    this._imageCache = new QuickLRU({
      maxSize: 1e3,
      maxAge: 2e4
    });
  }
  deserialize(l) {
    return V(this, null, function* () {
      if (!l)
        return;
      const t = this._imageCache.get(l);
      return t || new Promise((s) => {
        const c = new Image();
        c.onload = () => {
          s(c);
        }, c.src = l, this._imageCache.set(l, c);
      });
    });
  }
}
const defaultImageDeserializer = new ImageDeserializer();
function serialize2DMatrix(n) {
  if (n)
    return [n.a, n.b, n.c, n.d, n.e, n.f];
}
function deserialize2DMatrix(n) {
  return new DOMMatrix(n);
}
class Decoder {
  constructor(l) {
    this._stringRecorder = [];
    const { canvas: t } = l;
    this._stringRecorder = [], this._canvas = t;
  }
  decode(l) {
    return V(this, null, function* () {
      const { api: t, args: s } = l, c = CTX_API_DECODER[t], a = c === "setAttr" ? yield this.decodeAttr(s) : this.decodeArgs(s);
      if (c === "stroke" && a.length && !isProxyed(a[0]))
        throw new Error("argument type invalid, Path2D is not ProxyPath2D");
      return {
        api: c,
        args: a || []
      };
    });
  }
  decodeAttr(l) {
    return V(this, null, function* () {
      const t = [];
      let s = 0;
      for (; s < l.length - 1; ) {
        const c = l[s], a = l[s + 1];
        if (LONG_STR_ATTR.includes(CTX_ATTR_DECODER[c]) && typeof a == "string" || typeof a == "number")
          if (typeof a == "number") {
            const r = this._stringRecorder[a];
            t.push({
              key: CTX_ATTR_DECODER[c],
              value: r
            });
          } else
            t.push({
              key: CTX_ATTR_DECODER[c],
              value: a
            }), this._stringRecorder.push(a);
        else
          (a == null ? void 0 : a.type) === "ProxyLinearGradient" ? t.push({
            key: CTX_ATTR_DECODER[c],
            value: getLinearGradient(a.value, this._canvas)
          }) : (a == null ? void 0 : a.type) === "ProxyPattern" ? t.push({
            key: CTX_ATTR_DECODER[c],
            value: yield getCanvasPattern(a.value, this._canvas)
          }) : t.push({
            key: CTX_ATTR_DECODER[c],
            value: a
          });
        s += 2;
      }
      return t;
    });
  }
  decodeArgs(l) {
    return l != null && l.map ? l.map((t) => isProxyPath2D(t) ? new GLOBAL_OBJ.Path2D(t.value) : t) : l;
  }
}
function isProxyPath2D(n) {
  return (n == null ? void 0 : n.type) === "Path2D";
}
function getLinearGradient(n, l) {
  const t = l.getContext("2d");
  if (!t)
    return null;
  const s = n[0], c = t.createLinearGradient(s[0], s[1], s[2], s[3]);
  for (let a = 1; a < n.length; a++) {
    const r = n[a];
    c.addColorStop(r[0], r[1]);
  }
  return c;
}
function getCanvasPattern(n, l) {
  return V(this, null, function* () {
    var t, s;
    const c = l.getContext("2d");
    if (!c)
      return null;
    const a = (t = n[0]) !== null && t !== void 0 ? t : [], r = yield defaultImageDeserializer.deserialize((s = a[0]) === null || s === void 0 ? void 0 : s.src);
    if (!r)
      return;
    const o = c.createPattern(r, a[1]);
    if (o)
      for (let h = 1; h < n.length; h++) {
        const b = n[h];
        b && o.setTransform(deserialize2DMatrix(b));
      }
    return o;
  });
}
class CanvasPlayer {
  constructor(l) {
    this._prevApi = -1, this._instructionsQueue = [], this._executePromise = null;
    const { canvas: t } = l;
    this._canvas = t, this._decoder = new Decoder({ canvas: t });
  }
  get canvas() {
    return this._canvas;
  }
  execute(l) {
    l != null && l.length && (this._instructionsQueue.length ? this._instructionsQueue.push(...l) : (this._instructionsQueue.push(...l), this._execute()));
  }
  _execute() {
    return V(this, null, function* () {
      for (; this._instructionsQueue.length; ) {
        const l = this._instructionsQueue.shift();
        if (isAPI(l)) {
          const s = l;
          if (this._instructionsQueue.length > 0 && isArg(this._instructionsQueue[0])) {
            const a = this._instructionsQueue.shift();
            yield this.executeOne({ api: s, args: a }), this._executePromise = null;
          } else
            yield this.executeOne({ api: s, args: [] }), this._executePromise = null;
          this._prevApi = s;
        } else
          isArg(l) ? (yield this.executeOne({ api: this._prevApi, args: l }), this._executePromise = null) : console.log("sth error");
      }
    });
  }
  executeOne(l) {
    return V(this, null, function* () {
      return this._executePromise = new Promise((t, s) => V(this, null, function* () {
        var c, a, r;
        const o = (a = (c = this._canvas) === null || c === void 0 ? void 0 : c.getContext) === null || a === void 0 ? void 0 : a.call(c, "2d");
        if (!this._decoder || !this._canvas || !o) {
          s(-1);
          return;
        }
        try {
          const { api: h, args: b } = yield this._decoder.decode(l);
          if (!(h != null && h.length))
            console.log("invalid api"), t(-1);
          else if (h === "setAttr") {
            for (let u = 0; u < b.length; u++) {
              const { key: Z, value: p } = b[u];
              o[Z] = p;
            }
            t(1);
          } else if (h === "snapshot")
            defaultImageDeserializer.deserialize(b).then((u) => {
              o.drawImage(u, 0, 0), t(1);
            });
          else if (h === "lineTo") {
            let u = 0;
            for (; u < b.length - 1; ) {
              const Z = b[u], p = b[u + 1];
              o[h].apply(o, [Z, p]), u += 2;
            }
            t(1);
          } else
            h === "drawImage" && Array.isArray(b) && (!((r = b[0]) === null || r === void 0) && r.src) ? defaultImageDeserializer.deserialize(b[0].src).then((u) => {
              b[0].__drawFullPage && o.clearRect(0, 0, this._canvas.width, this._canvas.height), o.drawImage(u, ...b.slice(1)), t(1);
            }) : (o[h].apply(o, [...b]), t(1));
        } catch (h) {
          localStorage && localStorage.bytereplay_debug && console.error("[bytereplay] Execute canvas command error", h, {
            instruction: l
          }), t(-1);
        }
      })), this._executePromise;
    });
  }
  snapshot() {
    return V(this, null, function* () {
      if (this.canvas instanceof OffscreenCanvas) {
        const l = yield this.canvas.convertToBlob({
          type: "image/png",
          quality: 1
        });
        return yield new Promise((s) => {
          const c = new FileReader();
          c.addEventListener("load", () => s(c.result)), c.readAsDataURL(l);
        });
      } else
        return this.canvas.toDataURL("image/png", 1);
    });
  }
  decode(l) {
    return V(this, null, function* () {
      const t = [];
      if (!(l != null && l.length) || !this._decoder)
        return t;
      const s = [...l];
      for (; s.length; ) {
        const c = s.shift();
        if (isAPI(c)) {
          const r = c;
          if (s.length > 0 && isArg(s[0])) {
            const h = s.shift();
            t.push(yield this._decoder.decode({ api: r, args: h }));
          } else
            t.push(yield this._decoder.decode({ api: r, args: [] }));
          this._prevApi = r;
        } else
          isArg(c) ? t.push(yield this._decoder.decode({ api: this._prevApi, args: c })) : console.log("sth error");
      }
      return t;
    });
  }
}
function isAPI(n) {
  return typeof n == "string" || typeof n == "undefined" ? !1 : CTX_API_DECODER[n] === "setAttr" || CTX_API_DECODER[n] === "snapshot" || CTX_API.includes(CTX_API_DECODER[n]);
}
function isArg(n) {
  return !!(typeof n == "object" || typeof n == "string" && n.startsWith("data:"));
}
class ImageSerializer {
  constructor() {
    this._serializeCache = /* @__PURE__ */ new WeakMap(), this._canvas = null;
  }
  serialize(l) {
    if (l instanceof HTMLCanvasElement)
      return { type: l.constructor.name, src: l.toDataURL() };
    if (l instanceof OffscreenCanvas) {
      const t = l.transferToImageBitmap(), s = this._serializeCache.get(t);
      if (s)
        return s;
      const c = l.transferToImageBitmap(), a = {
        type: l.constructor.name,
        src: this._convertImageBitmapIntoBase64(c)
      };
      return this._serializeCache.set(c, a), a;
    }
    if (GLOBAL_OBJ.VideoFrame && l instanceof VideoFrame) {
      const t = {
        type: l.constructor.name,
        src: this._convertVideoFrameIntoBase64(l)
      };
      return this._serializeCache.set(l, t), t;
    } else if (l instanceof HTMLImageElement || l instanceof HTMLVideoElement || l instanceof Image) {
      const t = { type: l.constructor.name, src: l.src };
      return this._serializeCache.set(l, t), t;
    } else if (l instanceof ImageBitmap) {
      const t = {
        type: l.constructor.name,
        src: this._convertImageBitmapIntoBase64(l)
      };
      return this._serializeCache.set(l, t), t;
    } else if (l instanceof SVGImageElement) {
      const t = { type: l.constructor.name, src: l.href.baseVal };
      return this._serializeCache.set(l, t), t;
    }
  }
  isCanvasImageSource(l) {
    return l instanceof HTMLImageElement || l instanceof HTMLVideoElement || l instanceof HTMLCanvasElement || l instanceof Image || l instanceof ImageBitmap || l instanceof OffscreenCanvas || l instanceof SVGImageElement || GLOBAL_OBJ.VideoFrame && l instanceof VideoFrame;
  }
  _convertImageBitmapIntoBase64(l) {
    const t = this.canvas;
    return t.width = l.width, t.height = l.height, t.getContext("2d").drawImage(l, 0, 0), t.toDataURL("image/png", 1);
  }
  _convertVideoFrameIntoBase64(l) {
    const t = document.createElement("canvas");
    return t.width = l.displayWidth, t.height = l.displayHeight, t.getContext("2d").drawImage(l, 0, 0), t.toDataURL("image/png", 1);
  }
  get canvas() {
    return this._canvas || (this._canvas = document.createElement("canvas")), this._canvas;
  }
}
const defaultImageSerializer = new ImageSerializer();
function once(n) {
  let l = !1, t;
  return function(...s) {
    return l || (l = !0, t = n.apply(this, s)), t;
  };
}
const bootstrap = once(() => {
  if (GLOBAL_OBJ.CanvasRenderingContext2D) {
    const n = CanvasRenderingContext2D.prototype.createLinearGradient;
    CanvasRenderingContext2D.prototype.createLinearGradient = function(...t) {
      const s = n.apply(this, t), c = s.addColorStop;
      return s._values = [t], s._type = "ProxyLinearGradient", s.addColorStop = (...a) => {
        c.apply(s, a), s._values.push(a);
      }, s;
    };
    const l = CanvasRenderingContext2D.prototype.createPattern;
    if (CanvasRenderingContext2D.prototype.createPattern = function(...t) {
      const s = l.apply(this, t);
      if (!s)
        return null;
      const c = s.setTransform;
      return s._type = "ProxyPattern", s._values = [
        [defaultImageSerializer.serialize(t[0]), t[1]]
      ], s.setTransform = (a) => {
        c.apply(s, [a]), a && (s._values[1] = serialize2DMatrix(a));
      }, s;
    }, GLOBAL_OBJ.Path2D && !isProxyed(GLOBAL_OBJ.Path2D)) {
      const t = proxyPath2D();
      t && (GLOBAL_OBJ.Path2D = t);
    }
  }
});
class StepRecorder {
  constructor(l) {
    this.canvas = null, this.callback = () => {
    }, this.lastCtxAttrs = [], this.originApis = null, this.wrappedApis = null, this.sampler = null;
    const { canvas: t, callback: s, sampler: c } = l;
    this.canvas = t, this.callback = s, this.originApis = /* @__PURE__ */ new Map(), this.wrappedApis = /* @__PURE__ */ new Map(), this.sampler = c;
  }
  // 开始记录
  observe(l) {
    if (!this.canvas)
      return;
    const t = this.canvas.getContext("2d");
    CTX_ATTR.forEach((s) => {
      this.lastCtxAttrs.push({ key: s, value: t[s] });
    }), this.callback({
      api: "setAttr",
      args: this.lastCtxAttrs
    }), this.context2DWrapper(this.canvas), l != null && l.snapshot && this.callback({
      api: "snapshot",
      args: this.getSnapshot()
    });
  }
  // 还原 清除所有副作用
  disconnect() {
    if (!this.canvas)
      return;
    const l = this.canvas.getContext("2d");
    CTX_API.forEach((t) => {
      this.wrappedApis.get(t) === l[t] && (l[t] = this.originApis.get(t));
    }), this.sampler.close();
  }
  getSnapshot() {
    if (this.canvas)
      return String(this.canvas.toDataURL("image/png", 1));
  }
  // 包装 getContext
  context2DWrapper(l) {
    const t = this, s = l.getContext("2d");
    CTX_API.forEach((c) => {
      const a = s[c], r = function(...o) {
        if (CTX_DRAWING_API[c]) {
          const b = t.getChangedAttrs(s);
          b != null && b.length && t.callback({
            api: "setAttr",
            args: b
          });
        }
        return t.callback({
          api: c,
          args: o
        }), a.apply(s, [...o]);
      };
      this.originApis.set(c, a), this.wrappedApis.set(c, r), s[c] = r;
    });
  }
  getChangedAttrs(l) {
    const t = [];
    return CTX_ATTR.forEach((s) => {
      this.lastCtxAttrs[s] !== l[s] && (t.push({ key: s, value: l[s] }), this.lastCtxAttrs[s] = l[s]);
    }), t;
  }
}
class Encoder {
  constructor() {
    this.stringRecorder = [], this.stringRecorder = [];
  }
  encode(l, t) {
    var s;
    const c = CTX_API_ENCODER[l];
    if (t != null && t.length || t && (!((s = Object.keys(t)) === null || s === void 0) && s.length)) {
      const a = l === "setAttr" ? this.encodeAttr(t) : this.encodeArgs(t);
      return [c, a];
    } else
      return [c];
  }
  encodeAttr(l) {
    const t = [];
    return l.forEach((s) => {
      const { key: c, value: a } = s;
      LONG_STR_ATTR.includes(c) && typeof a == "string" ? this.stringRecorder.includes(a) ? t.push(CTX_ATTR_ENCODER[c], this.stringRecorder.indexOf(a)) : (this.stringRecorder.push(a), t.push(CTX_ATTR_ENCODER[c], a)) : (a == null ? void 0 : a._type) === "ProxyLinearGradient" ? t.push(CTX_ATTR_ENCODER[c], {
        type: "ProxyLinearGradient",
        value: a._values
      }) : (a == null ? void 0 : a._type) === "ProxyPattern" ? t.push(CTX_ATTR_ENCODER[c], {
        type: "ProxyPattern",
        value: a._values
      }) : t.push(CTX_ATTR_ENCODER[c], a);
    }), t;
  }
  encodeArgs(l) {
    return l != null && l.map ? l.map((t) => t != null && t._d3Path ? t.toJSON() : defaultImageSerializer.isCanvasImageSource(t) ? defaultImageSerializer.serialize(t) : t) : l;
  }
}
class Sampler {
  constructor(l) {
    const { callback: t, canvas: s } = l;
    this._canvas = s, this._records = [], this._callback = t, this._encoder = new Encoder(), this._animationHandle = GLOBAL_OBJ.requestAnimationFrame((c) => this.producer());
  }
  // 记录每一条指令
  sample(l) {
    this._records.push(l);
  }
  close() {
    GLOBAL_OBJ.cancelAnimationFrame(this._animationHandle);
  }
  producer() {
    const l = this._sample(this._records);
    this._callback(l, this._canvas), this._records = [], this._animationHandle = GLOBAL_OBJ.requestAnimationFrame(() => this.producer());
  }
  // 接受一帧内的指令，返回处理后的一帧内的指令
  _sample(l) {
    var t;
    if (!(l != null && l.length))
      return [];
    const s = [];
    let c = 0, a = [];
    for (; c < l.length; ) {
      const o = l[c], h = c === l.length - 1 ? { api: "" } : l[c + 1], b = o.api === h.api && isSettingApi(o.api), u = o.api === h.api && o.api === "lineTo";
      if (!b) {
        const Z = o.api;
        let { args: p } = o;
        Z === "clip" && typeof p[0] != "undefined" && typeof p[1] == "undefined" && (o.args = [p[0]]), p = (t = p == null ? void 0 : p.map) === null || t === void 0 ? void 0 : t.call(p, (G) => typeof G == "number" ? toFixed2(G) : G), u ? a.push(...p) : Z === "lineTo" ? (s.push({ api: Z, args: [...a, ...p] }), a = []) : s.push({ api: Z, args: o.args });
      }
      c++;
    }
    const r = [];
    return s.forEach((o) => {
      const { api: h, args: b } = o, u = this._encoder.encode(h, b);
      r.push(...u);
    }), r;
  }
}
const toFixed2 = (n) => Number(n.toString().match(/^\d+(?:\.\d{0,2})?/)), isSettingApi = (n) => CTX_SETTING_API.includes(n);
class ImageBitmapConverter {
  constructor() {
    this._offscreenMap = new QuickLRU({
      maxSize: 1e3,
      maxAge: 1e3 * 60 * 4
    }), this.clear = () => {
      this._offscreenMap.clear();
    };
  }
  toBase64(l, t) {
    return V(this, null, function* () {
      const s = `${l.width}x${l.height}`;
      let c = this._offscreenMap.get(s);
      c || (c = new OffscreenCanvas(l.width, l.height), this._offscreenMap.set(s, c));
      const a = c.getContext("bitmaprenderer");
      a == null || a.transferFromImageBitmap(l);
      const r = yield c.convertToBlob(t);
      return new Promise((o, h) => {
        const b = new FileReader();
        b.onload = () => {
          o(b.result);
        }, b.onerror = (u) => {
          h(u);
        }, b.readAsDataURL(r);
      });
    });
  }
}
const imageBitmapConverter = new ImageBitmapConverter(), DEFAULT_SAMPLING_OPTIONS = {
  fps: 3,
  // multiThread: true,
  dataURLOptions: {
    type: "image/webp",
    quality: 0.6
  }
};
class FpsRecorder {
  constructor(l, t) {
    this._canvas = l, this._callback = t, this._animeId = null, this._prevImg = null, this.observe = (s) => {
      var c;
      this._animeId !== null && cancelAnimationFrame(this._animeId);
      const a = (s == null ? void 0 : s.sampling) === !0 || !(s != null && s.sampling) ? DEFAULT_SAMPLING_OPTIONS : s.sampling;
      let r = 0;
      const o = 1e3 / ((c = a.fps) !== null && c !== void 0 ? c : DEFAULT_SAMPLING_OPTIONS.fps), h = (b) => V(this, null, function* () {
        if (r && b - r < o) {
          this._animeId = requestAnimationFrame(h);
          return;
        }
        r = b;
        const u = yield this._snapshotCanvas(a.dataURLOptions || DEFAULT_SAMPLING_OPTIONS.dataURLOptions);
        u && u !== this._prevImg && (this._callback({
          api: "drawImage",
          args: [
            { src: u, __drawFullPage: !0 },
            0,
            0,
            this._canvas.width,
            this._canvas.height
          ]
        }), this._prevImg = u), this._animeId = requestAnimationFrame(h);
      });
      this._animeId = requestAnimationFrame(h);
    }, this.disconnect = () => {
      this._animeId !== null && cancelAnimationFrame(this._animeId);
    }, this.getSnapshot = () => {
      if (this._canvas)
        return String(this._canvas.toDataURL("image/png", 1));
    }, this._snapshotCanvas = (s) => V(this, null, function* () {
      if (!this._canvas || this._canvas.width === 0 || this._canvas.height === 0)
        return;
      const c = yield createImageBitmap(this._canvas);
      return imageBitmapConverter.toBase64(c, s);
    });
  }
}
bootstrap();
const DEFAULT_OBSERVE_OPTIONS = {
  snapshot: !0,
  sampling: !1
};
class CanvasObserver {
  constructor(l) {
    this._canvasMap = /* @__PURE__ */ new WeakMap(), this._callback = l, this._canvasList = [];
  }
  observe(l, t) {
    const s = this._canvasMap.get(l);
    if (s)
      s.observe();
    else {
      const c = new Sampler({ canvas: l, callback: this._callback });
      if (t != null && t.sampling)
        new FpsRecorder(l, (r) => c.sample(r)).observe(t);
      else {
        const a = new StepRecorder({
          canvas: l,
          callback: (r) => c.sample(r),
          sampler: c
        });
        this._canvasMap.set(l, a), this._canvasList.push(l), a.observe(v(v({}, DEFAULT_OBSERVE_OPTIONS), t));
      }
    }
  }
  disconnect(l) {
    if (!l)
      return this.disconnectAll();
    const t = this._canvasMap.get(l);
    if (t) {
      t.disconnect(), this._canvasMap.delete(l);
      const s = this._canvasList.indexOf(l);
      s >= 0 && this._canvasList.splice(s, 1);
    } else
      console.error("no recorder to disconnect");
  }
  disconnectAll() {
    this._canvasList.forEach((l) => {
      const t = this._canvasMap.get(l);
      t && t.disconnect();
    }), this._canvasList = [], this._canvasMap = /* @__PURE__ */ new WeakMap();
  }
  // 获取快照
  getSnapshot(l) {
    if (!l)
      return {};
    const t = this._canvasMap.get(l);
    return t ? {
      url: t.getSnapshot(),
      width: l.width,
      height: l.height
    } : (console.error("no recorder to getSnapshot"), {});
  }
}
class CanvasElementObserver {
  constructor(l, t) {
    d(this, "options");
    d(this, "callback");
    d(this, "_canvasObserver");
    d(this, "_canvas", /* @__PURE__ */ new WeakMap());
    d(this, "_handleCanvasChange", (l, t) => {
      if (l.length === 0)
        return;
      const s = this._canvas.get(t), c = s == null ? void 0 : s.nodes.getNodeId(t);
      c && this.callback({ eventType: TrackerEventType.HTMLCanvas, data: { target: c, data: l } });
    });
    this.options = l, this.callback = t, this._canvasObserver = new CanvasObserver(this._handleCanvasChange);
  }
  get nodeName() {
    return "CANVAS";
  }
  observe(l, t, s) {
    this._canvasObserver.observe(t, v({ snapshot: !1 }, this.options)), this._canvas.set(t, l), s.extra = {
      image: t.toDataURL("image/png", 1),
      width: t.width,
      height: t.height
    };
  }
  disconnect(l) {
    this._canvasObserver.disconnect(l), this._canvas.delete(l);
  }
  disconnectAll() {
    this._canvasObserver.disconnectAll();
  }
}
class SnapshotError extends RuntimeError {
  constructor(l, t) {
    super(l, t), this.name = "SnapshotError";
  }
}
class CapturingError extends SnapshotError {
  constructor(l, t) {
    super(l, t), this.name = "CapturingError";
  }
}
class RenderingError extends SnapshotError {
  constructor(l, t) {
    super(l, t), this.name = "RenderingError";
  }
}
function captureDocument(n, l) {
  const t = l.nodes.getNodeId(n);
  console.assert(t === 1, `Unexpected id: expected 1 but got ${t}.`);
  const s = captureElementNode(n.documentElement, l);
  return {
    id: t,
    type: VNodeType.DocumentNode,
    title: n.title,
    baseURI: n.baseURI,
    root: s,
    visibilityState: n.visibilityState,
    scrollSize: [n.documentElement.scrollWidth, n.documentElement.scrollHeight],
    offsetSize: [n.documentElement.offsetWidth, n.documentElement.offsetHeight]
  };
}
function captureNode(n, l, t) {
  switch (n.nodeType) {
    case VNodeType.ElementNode:
      const s = captureElementNode(n, l, t);
      return l.onNodeCapture(n, s), s;
    case VNodeType.DocumentFragmentNode:
      const c = captureDocumentFragmentNode(n, l, t);
      return l.onNodeCapture(n, c), c;
    case VNodeType.TextNode:
    case VNodeType.CommentNode:
      const a = captureBasicNode(n, l, t);
      return l.onNodeCapture(n, a), a;
    case VNodeType.HTMLNode:
      return;
    default:
      throw new UnsupportedError(`Unsupported node type '${n.nodeType}'.`);
  }
}
function captureElementNode(n, l, t) {
  const s = captureBasicNode(n, l, t);
  if (s.type = VNodeType.ElementNode, s.tag = n.tagName, captureNamespace(n, s), captureAttributes(n, s, t), s.ignored || (captureValue(n, s), captureChecked(n, s), captureScroll(n, s)), captureChildren(n, l, s), n.shadowRoot) {
    const c = captureNode(n.shadowRoot, l, s);
    c && (c.parentId = s.id, s.shadowRoot = c);
  }
  return s;
}
function captureDocumentFragmentNode(n, l, t) {
  const s = captureBasicNode(n, l, t);
  return s.tag = n.nodeName, captureChildren(n, l, s), s;
}
function captureBasicNode(n, l, t) {
  const c = { id: l.nodes.getNodeId(n), type: n.nodeType };
  return isHTMLScriptElement(n) && (c.ignored = !0), t ? isVNode(t) ? (c.parentId = t.id, t.ignored && (c.ignored = t.ignored)) : (c.parentId = captureParentNode(n, l, t), shouldIgnore(t) && (c.ignored = !0)) : c.parentId = captureParentNode(n, l), !c.ignored && n.nodeValue != null && (c.text = isHTMLScriptElement(n) ? "" : n.nodeValue), c;
}
function captureParentNode(n, l, t) {
  const s = t != null ? t : n.parentNode;
  if (s) {
    const c = l.nodes.getNodeId(s, !1);
    if (c == null)
      throw new CapturingError("Parent node is not captured yet.");
    return c;
  } else
    return;
}
function captureChildren(n, l, t) {
  if (n.hasChildNodes()) {
    const s = [];
    n.childNodes.forEach((c) => {
      const a = captureNode(c, l, t);
      a && s.push(a);
    }), t.children = s;
  }
}
function captureNamespace(n, l) {
  n.namespaceURI && !n.ownerDocument.isDefaultNamespace(n.namespaceURI) && (l.ns = n.namespaceURI);
}
function captureAttributes(n, l, t) {
  var c;
  if (n.hasAttributes()) {
    shouldIgnore(n) && (l.ignored = !0);
    const a = {};
    for (const r of n.getAttributeNames()) {
      const o = n.getAttribute(r);
      o != null && (a[r] = o);
    }
    l.attrs = a;
  }
  let s;
  if (t) {
    if (isVNode(t))
      s = (c = t == null ? void 0 : t.attrs) == null ? void 0 : c[DATA_MASK];
    else if (isHTMLElement(t))
      if (t.hasAttribute(DATA_MASK))
        s = t.getAttribute(DATA_MASK);
      else {
        let a = t.parentElement;
        for (; a; ) {
          if (a.hasAttribute(DATA_MASK)) {
            s = a.getAttribute(DATA_MASK);
            break;
          }
          a = a.parentElement;
        }
      }
  }
  s != null && (l.attrs ? l.attrs[DATA_MASK] = s : l.attrs = { [DATA_MASK]: s });
}
function captureValue(n, l) {
  let t, s, c = !1;
  isHTMLInputElement(n) || isHTMLSelectElement(n) ? (t = n.value, s = n.getAttribute("value"), c = n.type === "password") : isHTMLTextAreaElement(n) && (t = n.value, s = n.textContent), isString(t) && t !== s && (l.value = c ? "*".repeat(t.length) : t);
}
function captureChecked(n, l) {
  isHTMLInputElement(n) ? l.checked = n.checked : isHTMLOptionElement(n) && (l.checked = n.selected);
}
function captureScroll(n, l) {
  (n.scrollTop || n.scrollLeft) && (l.scroll = [n.scrollLeft, n.scrollTop]);
}
function captureMutations(n, l) {
  l.optimizer.start();
  for (const s of n) {
    const c = l.nodes.getNodeId(s.target, !1);
    if (c !== void 0)
      switch (s.type) {
        case "attributes":
          const a = captureChangedAttribute(c, s);
          l.optimizer.onAttributesMutation(a);
          break;
        case "childList":
          if (s.addedNodes.length) {
            const o = captureAddedNodes(c, s, l);
            l.optimizer.onNodeAddMutation(...o);
          }
          if (s.removedNodes.length) {
            const o = captureRemovedNodes(c, s, l);
            l.optimizer.onNodeRemoveMutation(...o);
          }
          break;
        case "characterData":
          const r = captureCharacterData(c, s);
          l.optimizer.onCharacterMutation(r);
          break;
        default:
          throw new UnsupportedError(`Unsupported mutation type: ${s.type}`);
      }
  }
  const t = l.optimizer.merge();
  return l.optimizer.stop(), t;
}
function captureChangedAttribute(n, l) {
  const t = l.attributeName, s = l.target.getAttribute(t);
  return {
    type: VMutationType.ChangeAttributes,
    target: n,
    data: {
      [t]: s
    }
  };
}
function captureAddedNodes(n, l, t) {
  const s = [];
  let c;
  return l.nextSibling && (c = t.nodes.getNodeId(l.nextSibling, !1)), l.addedNodes.forEach((a) => {
    const r = a.parentNode;
    let o = n;
    if (r) {
      const b = t.nodes.getNodeId(r, !1);
      b && b !== n && (o = b);
    }
    const h = t.nodes.getNodeId(a, !1);
    if (h === void 0 || !t.optimizer.isNewAddedNode(h)) {
      const b = captureNode(a, t, l.target);
      if (!b)
        return;
      const u = {
        type: VMutationType.AddNode,
        target: o,
        data: {
          node: b
        }
      };
      c && (u.data.before = c), s.push(u);
    } else
      checkChildren(a, t, s);
  }), s;
}
function checkChildren(n, l, t) {
  if (!l.nodes.has(n))
    if (n.parentElement) {
      const c = l.nodes.getNodeId(n.parentElement, !1);
      if (c) {
        const a = captureNode(n, l, n.parentElement);
        if (!a)
          return;
        t.push({
          type: VMutationType.AddNode,
          target: c,
          data: {
            node: a
          }
        });
      } else
        console.warn("parent id is null", n.parentElement);
    } else
      console.warn("parent is null", n);
  n.childNodes.forEach((c) => {
    checkChildren(c, l, t);
  });
}
function captureRemovedNodes(n, l, t) {
  const s = [];
  return l.removedNodes.forEach((c) => {
    const a = t.nodes.getNodeId(c, !1);
    if (a === void 0)
      return;
    const r = [];
    let o = n;
    if (c.parentNode) {
      const h = t.nodes.getNodeId(c.parentNode, !1);
      h && h !== n && (o = h);
    }
    t.onNodeRemove(c, a), t.nodes.removeNode(c, !0, r), r.length > 0 && r[r.length - 1] === a && r.pop(), a && s.push({
      type: VMutationType.RemoveNode,
      target: o,
      data: { id: a, children: r }
    });
  }), s;
}
function captureCharacterData(n, l) {
  const t = l.target.nodeValue;
  return {
    type: VMutationType.CharacterData,
    target: n,
    data: t
  };
}
function captureWindow(n) {
  return {
    location: n.location.href,
    size: [n.innerWidth, n.innerHeight]
  };
}
class DocumentObserver {
  constructor(l) {
    d(this, "callback");
    d(this, "_mutationObserver");
    d(this, "_context");
    d(this, "_handleMutationObserver", (l) => {
      if (!this._context)
        return;
      const t = captureMutations(l, this._context);
      this.callback({ eventType: TrackerEventType.HTMLMutations, data: t });
    });
    d(this, "_handleDocumentVisibilityChange", () => {
      this.callback({
        eventType: TrackerEventType.HTMLMutations,
        data: [{ type: VMutationType.Document, target: 1, data: { visibilityState: document.visibilityState } }]
      });
    });
    d(this, "_handleSelectionChange", () => {
      if (!this._context)
        return;
      const l = document.getSelection();
      if (!l)
        return;
      const t = [];
      for (let s = 0; s < l.rangeCount; s++) {
        const c = l.getRangeAt(s), a = this._context.getNodeId(c.startContainer), r = this._context.getNodeId(c.endContainer);
        a != null && r != null && t.push({
          startTargetId: a,
          startOffset: c.startOffset,
          endTargetId: r,
          endOffset: c.endOffset
        });
      }
      this.callback({ eventType: TrackerEventType.HTMLSelectionChange, data: t });
    });
    this.callback = l, this._mutationObserver = new MutationObserver(this._handleMutationObserver);
  }
  observe(l, t) {
    this._context = l, this._mutationObserver.observe(t, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      characterData: !0
    });
    const s = this.capture(l);
    t.addEventListener("visibilitychange", this._handleDocumentVisibilityChange), t.addEventListener("selectionchange", this._handleSelectionChange), this.callback({ eventType: TrackerEventType.HTMLSnapshot, data: s });
  }
  disconnect(l) {
    this._mutationObserver.disconnect(), l.removeEventListener("visibilitychange", this._handleDocumentVisibilityChange), l.removeEventListener("selectionchange", this._handleSelectionChange);
  }
  disconnectAll() {
    this.disconnect(document);
  }
  capture(l) {
    return {
      version: 1,
      window: captureWindow(window),
      document: captureDocument(document, l),
      id: generateUUID$1()
    };
  }
}
function captureEvent(n, l) {
  switch (n.type) {
    case "scroll":
      return captureScrollEvent(n, l);
    case "focus":
    case "blur":
      return captureFocusAndBlurEvent(n, l);
    case "input":
    case "change":
      return captureInputAndChangeEvent(n, l);
    case "resize":
      return captureResizeEvent();
  }
}
function captureScrollEvent({ target: n }, l) {
  let t;
  n === document ? document.scrollingElement ? t = document.scrollingElement : t = document.documentElement : t = n;
  const s = l.nodes.getNodeId(t, !1);
  if (s != null)
    return {
      eventType: TrackerEventType.HTMLScroll,
      data: {
        target: s,
        scroll: [t.scrollLeft, t.scrollTop]
      }
    };
}
function captureFocusAndBlurEvent({ target: n, type: l }, t) {
  const s = n, c = t.nodes.getNodeId(s, !1);
  if (c != null)
    return {
      eventType: l === "focus" ? TrackerEventType.HTMLFocus : TrackerEventType.HTMLBlur,
      data: { target: c }
    };
}
function captureInputAndChangeEvent({ target: n }, l) {
  const t = n, s = l.nodes.getNodeId(t, !1);
  if (s != null) {
    if (isHTMLInputElement(t) && t.type === "checkbox" || t.type === "radio")
      return {
        eventType: TrackerEventType.HTMLValueChange,
        data: { target: s, value: t.checked }
      };
    let c = t.value;
    return typeof c != "string" && (c = String(c)), isHTMLInputElement(t) && t.type === "password" && (c = "*".repeat(t.value.length)), { eventType: TrackerEventType.HTMLValueChange, data: { target: s, value: c } };
  }
}
function captureResizeEvent() {
  return {
    eventType: TrackerEventType.HTMLResize,
    data: { size: [window.innerWidth, window.innerHeight] }
  };
}
const WINDOW_EVENTS = ["focus", "blur", "change", "input"];
class GlobalEventObserver {
  constructor(l) {
    d(this, "callback");
    d(this, "_context");
    d(this, "_handleEvent", (l) => {
      if (!this._context)
        return;
      const t = captureEvent(l, this._context);
      t && this.callback(t);
    });
    d(this, "_handleScroll", (l) => {
      if (!this._context)
        return;
      const t = captureEvent(l, this._context);
      t && t.eventType === TrackerEventType.HTMLScroll && this._scrollSampler.sample(t.data.target, t.data.scroll);
    });
    d(this, "_handleScrollSampleCallback", (l, t) => {
      this.callback({ eventType: TrackerEventType.HTMLScroll, data: { target: l, scroll: t } });
    });
    d(this, "_scrollSampler", new Sampler$1(5, this._handleScrollSampleCallback));
    d(this, "_handleResize", (l) => {
      if (!this._context)
        return;
      const t = captureEvent(l, this._context);
      t && t.eventType === TrackerEventType.HTMLResize && this._resizeSampler.sample(0, t.data.size);
    });
    d(this, "_handleResizeSampleCallback", (l, t) => {
      this.callback({ eventType: TrackerEventType.HTMLResize, data: { size: t } });
    });
    d(this, "_resizeSampler", new Sampler$1(1, this._handleResizeSampleCallback));
    this.callback = l;
  }
  observe(l, t) {
    this._context = l, isWindow(t) && WINDOW_EVENTS.forEach((s) => t.addEventListener(s, this._handleEvent, !0)), t.addEventListener("scroll", this._handleScroll, { capture: !0, passive: !0 }), t.addEventListener("resize", this._handleResize, { capture: !0, passive: !0 });
  }
  disconnect(l) {
    isWindow(l) && WINDOW_EVENTS.forEach((t) => l.removeEventListener(t, this._handleEvent, !0)), l.removeEventListener("scroll", this._handleScroll, !0), l.removeEventListener("resize", this._handleResize, !0);
  }
  disconnectAll() {
    this._context = void 0, this._scrollSampler.stop(), this._resizeSampler.stop();
  }
}
class ImageElementObserver {
  constructor(l, t) {
    d(this, "options");
    d(this, "callback");
    this.options = l, this.callback = t;
  }
  get nodeName() {
    return "IMG";
  }
  observe(l, t, s) {
    if (this.options.captureStatus && (t.decode().then(() => {
      const c = l.nodes.getNodeId(t, !1);
      c && this.callback({
        eventType: TrackerEventType.HTMLImage,
        data: { target: c, data: { status: "loaded" } }
      });
    }).catch(() => {
      const c = l.nodes.getNodeId(t, !1);
      c && this.callback({
        eventType: TrackerEventType.HTMLImage,
        data: { target: c, data: { status: "failed" } }
      });
    }), s.extra = { status: "unknown" }), this.options.captureAttributes) {
      const c = this.options.captureAttributes(t), a = s;
      a.attrs = v(v({}, a.attrs), c);
    }
  }
  disconnect(l) {
  }
  disconnectAll() {
  }
}
class DeferredTaskQueue {
  constructor() {
    d(this, "_tasks", []);
  }
  enqueue(l) {
    this._tasks.push(l);
  }
  executeAll() {
    return V(this, null, function* () {
      for (const l of this._tasks)
        yield l();
      this.clear();
    });
  }
  clear() {
    this._tasks.splice(0, this._tasks.length);
  }
  size() {
    return this._tasks.length;
  }
}
class Id2NodeMap extends EventEmitter {
  constructor() {
    super(...arguments);
    d(this, "_map", /* @__PURE__ */ new Map());
  }
  reset() {
    this._map.clear(), this.emit("nodeReset");
  }
  has(t) {
    return this._map.has(t);
  }
  getNode(t) {
    return this._map.get(t);
  }
  addNode(t, s) {
    this._map.set(t, s), s && this.emit("nodeAdded", s, t);
  }
  keys() {
    return this._map.keys();
  }
  size() {
    return this._map.size;
  }
  removeNode(t) {
    const s = this._map.get(t);
    this._map.delete(t), s && this.emit("nodeRemoved", s, t);
  }
}
class Node2IdMap {
  constructor() {
    d(this, "_events", new EventEmitter());
    d(this, "_map", /* @__PURE__ */ new WeakMap());
    d(this, "_sequentialId", 0);
    this.reset();
  }
  has(l) {
    return this._map.has(l);
  }
  getNodeId(l, t = !0) {
    if (this.has(l))
      return this._map.get(l);
    if (t)
      return this.addNode(l);
  }
  reset() {
    this._sequentialId = 0, this._map = /* @__PURE__ */ new WeakMap();
  }
  addNode(l) {
    if (this.has(l))
      throw new RuntimeError("Node already added.");
    const t = this._nextId();
    this._map.set(l, t);
    try {
      this._events.emit("nodeAdded", l, t);
    } catch (s) {
    }
    return t;
  }
  removeNode(l, t = !1, s = []) {
    t && l.hasChildNodes() && l.childNodes.forEach((r) => {
      this.removeNode(r, !0, s);
    }), l instanceof Element && l.shadowRoot && this.removeNode(l.shadowRoot, !0, s);
    const c = this._map.get(l);
    if (this._map.delete(l), c && c >= 0) {
      s.push(c);
      try {
        this._events.emit("nodeRemoved", l, c);
      } catch (a) {
      }
    }
  }
  _nextId() {
    return ++this._sequentialId;
  }
  on(l, t, s) {
    return this._events.on(l, t, s);
  }
  once(l, t, s) {
    return this._events.once(l, t, s);
  }
  off(l, t, s, c) {
    return this._events.off(l, t, s, c);
  }
  addListener(l, t, s) {
    return this._events.addListener(l, t, s);
  }
  removeListener(l, t, s, c) {
    return this._events.removeListener(l, t, s, c);
  }
}
class PromiseList {
  constructor() {
    d(this, "_promises", []);
  }
  add(l) {
    this._promises.push(l);
  }
  all() {
    return V(this, null, function* () {
      yield Promise.all(this._promises), this.clear();
    });
  }
  clear() {
    this._promises.splice(0, this._promises.length);
  }
  size() {
    return this._promises.length;
  }
}
class MutationOptimizer {
  constructor(l) {
    d(this, "context");
    d(this, "mutations", []);
    d(this, "nodes", /* @__PURE__ */ new Set());
    d(this, "attributeChangingMutationMap", /* @__PURE__ */ new Map());
    d(this, "characterDataMutationMap", /* @__PURE__ */ new Map());
    d(this, "removedNodes", /* @__PURE__ */ new Map());
    d(this, "addedNodes", /* @__PURE__ */ new Map());
    d(this, "handleNodeAdd", (l, t) => {
      this.nodes.add(t), this.addedNodes.set(t, !0);
    });
    d(this, "handleNodeRemove", (l, t) => {
      this.addedNodes.has(t) && this.removedNodes.set(t, !0), this.nodes.delete(t);
    });
    this.context = l;
  }
  start() {
    this.context.nodes.on("nodeAdded", this.handleNodeAdd), this.context.nodes.on("nodeRemoved", this.handleNodeRemove);
  }
  stop() {
    this.context.nodes.off("nodeAdded", this.handleNodeAdd), this.context.nodes.off("nodeRemoved", this.handleNodeRemove), this.mutations = [], this.nodes.clear(), this.attributeChangingMutationMap.clear(), this.characterDataMutationMap.clear(), this.removedNodes.clear(), this.addedNodes.clear();
  }
  onAttributesMutation(l) {
    const t = l.target, s = this.attributeChangingMutationMap.get(t);
    s ? Object.assign(s.data, l.data) : this.removedNodes.has(l.target) || (this.attributeChangingMutationMap.set(t, l), this.mutations.push(l));
  }
  onNodeAddMutation(...l) {
    this.mutations.push(...l);
  }
  onNodeRemoveMutation(...l) {
    this.mutations.push(...l);
  }
  onCharacterMutation(l) {
    const t = l.target, s = this.characterDataMutationMap.get(t);
    s ? s.data = l.data : this.removedNodes.has(t) || (this.characterDataMutationMap.set(t, l), this.mutations.push(l));
  }
  merge() {
    const l = /* @__PURE__ */ new Set();
    return this.mutations.filter((t) => {
      if (this.removedNodes.has(t.target) || l.has(t.target))
        return !1;
      if (t.type === VMutationType.RemoveNode) {
        let s;
        if (typeof t.data == "number" ? s = t.data : s = t.data.id, this.removedNodes.has(s) && l.has(s))
          return !1;
      } else if (t.type === VMutationType.AddNode && this.removedNodes.has(t.data.node.id))
        return this.visitIgnoreNode(t.data.node, l), !1;
      return !0;
    });
  }
  visitIgnoreNode(l, t) {
    var s;
    t.add(l.id), (s = l.children) == null || s.forEach((c) => {
      this.visitIgnoreNode(c, t);
    });
  }
  isNewAddedNode(l) {
    return this.nodes.has(l);
  }
}
class ObserverContext extends EventEmitter {
  constructor(t) {
    super();
    d(this, "callback");
    d(this, "_map", new Node2IdMap());
    d(this, "_nodeObservers", /* @__PURE__ */ new Map());
    d(this, "_documentObserver");
    d(this, "_globalEventObserver");
    d(this, "optimizer", new MutationOptimizer(this));
    this.callback = t, this._documentObserver = new DocumentObserver(this.callback), this._globalEventObserver = new GlobalEventObserver(this.callback);
  }
  get documentObserver() {
    return this._documentObserver;
  }
  get eventsObserver() {
    return this._globalEventObserver;
  }
  get nodes() {
    return this._map;
  }
  getNodeId(t) {
    return this._map.getNodeId(t);
  }
  reset() {
    this.disconnectAll(), this._map.reset();
  }
  registerNodeObserver(t) {
    this._nodeObservers.set(t.nodeName, t);
  }
  onNodeRemove(t, s) {
    try {
      const c = this._nodeObservers.get(t.nodeName);
      c && c.disconnect(t);
    } catch (c) {
    }
  }
  onNodeCapture(t, s) {
    const c = this._nodeObservers.get(t.nodeName);
    try {
      c && c.observe(this, t, s);
    } catch (a) {
      console.error(a);
    }
  }
  disconnectAll() {
    this._nodeObservers.forEach((t) => {
      t.disconnectAll();
    });
  }
}
const STYLE_SHEET_INTERCEPTOR_FLAG = Symbol.for("bytereplay.StyleSheetInterceptor"), RuleSheetMethodEncodes = {
  insertRule: 0,
  deleteRule: 1,
  replace: 2,
  replaceSync: 3,
  addRule: 4,
  removeRule: 5
}, RuleSheetMethodDecodes = {
  0: "insertRule",
  1: "deleteRule",
  2: "replace",
  3: "replaceSync",
  4: "addRule",
  5: "removeRule"
}, ce = class ce {
  constructor(l, t) {
    d(this, "host");
    d(this, "callback");
    d(this, "_context");
    this.host = l, this.callback = t;
  }
  observe(l, t) {
    if (this._context || (this._context = l), t[STYLE_SHEET_INTERCEPTOR_FLAG] !== void 0)
      return;
    const s = this._nextSheetId(), c = Object.getPrototypeOf(t), a = Object.getOwnPropertyDescriptors(c);
    Object.keys(a).forEach((r) => {
      const o = Reflect.get(t, r);
      typeof o != "function" || o.name === "CSSStyleSheet" || Object.defineProperty(t, r, {
        value: (...h) => {
          const b = a[r].value;
          if (typeof b == "function") {
            const u = RuleSheetMethodEncodes[r];
            if (u !== void 0 && this._context) {
              const Z = this._context.nodes.getNodeId(this.host, !1);
              Z && this.callback({
                eventType: TrackerEventType.HTMLMutations,
                data: [
                  { type: VMutationType.StyleSheetRule, target: Z, data: [u, h], sheetId: s }
                ]
              });
            }
          }
          return Reflect.apply(b, t, h);
        }
      });
    }), t[STYLE_SHEET_INTERCEPTOR_FLAG] = s;
  }
  captureRules(l) {
    const t = l.cssRules, s = [];
    if (t)
      for (let c = 0; c < t.length; c++)
        s.push([RuleSheetMethodEncodes.insertRule, [t[c].cssText, c]]);
    return s;
  }
  static getSheetId(l) {
    return l[STYLE_SHEET_INTERCEPTOR_FLAG];
  }
  static setSheetId(l, t) {
    l[STYLE_SHEET_INTERCEPTOR_FLAG] = t;
  }
  _nextSheetId() {
    return ++ce._sheetId;
  }
  disconnect(l) {
    this._context = void 0;
  }
  disconnectAll() {
    this._context = void 0;
  }
};
d(ce, "_sheetId", 0);
let StyleSheetObserver = ce;
const AdoptedStyleSheetsInterceptor = Symbol("bytereplay.adoptedStyleSheets");
class ShadowRootObserver {
  constructor(l) {
    d(this, "callback");
    d(this, "mutationObservers", /* @__PURE__ */ new WeakMap());
    d(this, "styleSheetObservers", /* @__PURE__ */ new WeakMap());
    d(this, "_context");
    d(this, "_handleAdoptedStyleSheetsChange", (l, t) => {
      const s = this._context;
      if (!s)
        return;
      const c = { sheets: [], rules: {} }, a = s.nodes.getNodeId(l, !1);
      a && (t.forEach((r) => {
        let o = StyleSheetObserver.getSheetId(r);
        if (o !== void 0) {
          c.sheets.push(o);
          return;
        }
        const h = this.styleSheetObservers.get(l);
        if (!h)
          return;
        h.observe(s, r), o = StyleSheetObserver.getSheetId(r), c.sheets.push(o);
        const b = h.captureRules(r);
        c.rules[o] = b;
      }), this.callback({
        eventType: TrackerEventType.HTMLMutations,
        data: [
          {
            type: VMutationType.StyleSheetAdopted,
            target: a,
            data: c
          }
        ]
      }));
    });
    d(this, "_handleMutationObserver", (l) => {
      if (!this._context)
        return;
      const t = captureMutations(l, this._context);
      this.callback({ eventType: TrackerEventType.HTMLMutations, data: t });
    });
    this.callback = l;
  }
  get nodeName() {
    return "#document-fragment";
  }
  observe(l, t, s) {
    this._context || (this._context = l);
    const c = new MutationObserver(this._handleMutationObserver);
    c.observe(t, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      characterData: !0
    }), this.mutationObservers.set(t, c), s.extra = { styleSheets: this._observerAdoptedStyleSheets(l, t) }, l.eventsObserver.observe(l, t);
  }
  _observerAdoptedStyleSheets(l, t) {
    const s = new StyleSheetObserver(t, this.callback);
    this.styleSheetObservers.set(t, s), this._watchAdoptedStyleSheetsChange(t);
    const c = t.adoptedStyleSheets, a = { sheets: [], rules: {} };
    if (c.length === 0)
      return a;
    for (let r = 0; r < c.length; r++) {
      const o = c[r];
      s.observe(l, o);
      const h = StyleSheetObserver.getSheetId(o);
      if (h === void 0)
        continue;
      const b = s.captureRules(o);
      a.sheets.push(h), a.rules[h] = b;
    }
    return a;
  }
  _watchAdoptedStyleSheetsChange(l) {
    if (l[AdoptedStyleSheetsInterceptor])
      return;
    const s = Object.getPrototypeOf(l), c = Object.getOwnPropertyDescriptor(s, "adoptedStyleSheets"), a = this;
    Object.defineProperty(l, "adoptedStyleSheets", {
      configurable: c == null ? void 0 : c.configurable,
      enumerable: c == null ? void 0 : c.enumerable,
      get() {
        var r;
        return (r = c == null ? void 0 : c.get) == null ? void 0 : r.call(this);
      },
      set(r) {
        var h;
        const o = (h = c == null ? void 0 : c.set) == null ? void 0 : h.call(this, r);
        try {
          a._handleAdoptedStyleSheetsChange(l, r);
        } catch (b) {
        }
        return o;
      }
    });
  }
  disconnect(l) {
    var a;
    (a = this._context) == null || a.eventsObserver.disconnect(l), this._context = void 0;
    const t = this.mutationObservers.get(l);
    t == null || t.disconnect();
    const s = this.styleSheetObservers.get(l), c = l.adoptedStyleSheets;
    for (let r = 0; r < c.length; r++) {
      const o = c[r];
      s == null || s.disconnect(o);
    }
  }
  disconnectAll() {
    this._context = void 0, this.mutationObservers = /* @__PURE__ */ new WeakMap(), this.styleSheetObservers = /* @__PURE__ */ new WeakMap();
  }
}
class StyleElementObserver {
  constructor(l) {
    d(this, "callback");
    d(this, "observers", /* @__PURE__ */ new WeakMap());
    this.callback = l;
  }
  get nodeName() {
    return "STYLE";
  }
  observe(l, t, s) {
    if (t.textContent === "" && t.sheet) {
      const c = new StyleSheetObserver(t, this.callback), a = c.captureRules(t.sheet);
      s.extra = { commands: a }, c.observe(l, t.sheet), this.observers.set(t, c);
    } else
      s.extra = {};
  }
  disconnect(l) {
    const t = this.observers.get(l);
    l.sheet && (t == null || t.disconnect(l.sheet));
  }
  disconnectAll() {
    this.observers = /* @__PURE__ */ new WeakMap();
  }
}
function takeSnapshot(n, l) {
  const { token: t, safety: s, data: c } = l, a = {};
  return t && (a.Authorization = t), n.post(s ? "snapshot/safe/take" : "snapshot/take", c, a);
}
class ScreenshotRenderer {
  constructor() {
    d(this, "_env");
    d(this, "_apiClient");
  }
  render(l, t) {
    return V(this, null, function* () {
      const s = JSON.stringify(l), c = new TextEncoder().encode(s), a = new Blob([c]), Z = t, { token: r, environment: o, safety: h } = Z, b = le(Z, ["token", "environment", "safety"]), u = createFormData();
      return u.append("snapshot", a), u.append("options", JSON.stringify(b)), takeSnapshot(this.getAPIClient(o), { token: r, safety: h, data: u });
    });
  }
  getAPIClient(l) {
    return this._env ? (this._env.baseURL = l == null ? void 0 : l.baseURL, this._env.type = l == null ? void 0 : l.type) : this._env = new Environment(l), this._apiClient || (this._apiClient = new APIClient(this._env)), this._apiClient;
  }
}
class SnapshotCapturer extends EventEmitter {
  constructor(t) {
    var s, c;
    super();
    d(this, "options");
    d(this, "context");
    d(this, "_handleEventObserver", (t) => {
      this.emit("event", t);
    });
    this.options = t, this.context = new ObserverContext(this._handleEventObserver), (s = this.options) != null && s.canvas && (globalThis.Path2D ? this.registerNodeObserver(CanvasElementObserver, isObject$1(this.options.canvas) ? this.options.canvas : void 0) : console.warn("canvas not supported in this runtime.")), (c = this.options) != null && c.image && this.registerNodeObserver(ImageElementObserver, this.options.image), this.registerNodeObserver(StyleElementObserver), this.registerNodeObserver(ShadowRootObserver);
  }
  get nodes() {
    return this.context.nodes;
  }
  getNodeId(t) {
    return this.nodes.getNodeId(t, !1);
  }
  reset() {
    this.context.reset();
  }
  registerNodeObserver(t, ...s) {
    const c = Reflect.construct(t, [...s, this._handleEventObserver]);
    this.context.registerNodeObserver(c);
  }
  start() {
    this.context.documentObserver.observe(this.context, document), this.context.eventsObserver.observe(this.context, window);
  }
  stop() {
    this.context.documentObserver.disconnect(document), this.context.eventsObserver.disconnect(window), this.reset();
  }
  captureSnapshot() {
    return this.context.documentObserver.capture(this.context);
  }
  captureMutations(t) {
    return captureMutations(t, this.context);
  }
  captureEvent(t) {
    return captureEvent(t, this.context);
  }
  screenshot(t) {
    return V(this, null, function* () {
      const s = this.captureSnapshot();
      return yield new ScreenshotRenderer().render(s, t);
    });
  }
}
var RenderMode;
(function(n) {
  n.VanillaDOM = "VanillaDOM", n.VirtualDOM = "VirtualDOM";
})(RenderMode || (RenderMode = {}));
const B = class B {
  constructor() {
    d(this, "tag", "CANVAS");
  }
  static registerPlayer(l, t, s, c) {
    const a = { player: new CanvasPlayer({ canvas: s }), order: c }, r = B.players.get(`${l}/${t}`);
    r ? r.order < a.order && B.players.set(`${l}/${t}`, a) : B.players.set(`${l}/${t}`, a);
  }
  static resolvePlayer(l, t, s) {
    const c = B.players.get(`${l}/${t}`);
    if (c && c.order <= s)
      return c.player;
  }
  static removePlayer(l, t) {
    B.players.delete(`${l}/${t}`);
  }
  static resetPlayer(l) {
    const t = B.players.keys();
    Array.from(t).forEach((s) => {
      s.startsWith(l) && B.players.delete(s);
    });
  }
  onRender(l, t) {
    var a, r, o;
    const s = (a = t.extra) == null ? void 0 : a.image;
    if (!s)
      return;
    const c = this.getPerformOrder(l);
    if (l.isVanilla()) {
      const h = l.getNode(t.id), b = h.getContext("2d");
      l.addWaiting(new Promise((u) => {
        const Z = new Image();
        Z.onload = () => {
          b == null || b.drawImage(Z, 0, 0), u({ element: h, failed: !1, timeout: !1 });
        }, Z.onerror = () => {
          u({ element: h, failed: !0, timeout: !1 });
        }, Z.src = s;
      })), B.registerPlayer(l.snapshotId, t.id, h, c);
    } else {
      const h = new OffscreenCanvas(parseFloat(((r = t.attrs) == null ? void 0 : r.width) || "300") || 300, parseFloat(((o = t.attrs) == null ? void 0 : o.height) || "150") || 150);
      B.registerPlayer(l.snapshotId, t.id, h, c);
    }
  }
  onRemove(l, t) {
    B.removePlayer(l.snapshotId, t);
  }
  performEvent(l, t) {
    if (t.eventType === TrackerEventType.HTMLCanvas) {
      const { target: s, data: c } = t.data, a = this.getPerformOrder(l), r = B.resolvePlayer(l.snapshotId, s, a);
      r && r.execute(c);
    }
  }
  onReset(l) {
    B.resetPlayer(l.snapshotId);
  }
  onCapture(l, t) {
    if (l.isVirtual()) {
      const s = l.getNode(t);
      if (s && s.tag === this.tag) {
        const c = this.getPerformOrder(l), a = B.resolvePlayer(l.snapshotId, t, c);
        a && l.addWaiting(new Promise((r, o) => {
          a.snapshot().then((h) => {
            s.extra = { image: h }, r({ element: void 0, failed: !1, timeout: !1 });
          }).catch(() => {
            o({ element: void 0, failed: !0, timeout: !1 });
          });
        }));
      }
    }
  }
  getPerformOrder(l) {
    return l.mode === RenderMode.VanillaDOM ? 2 : l.isIncremental ? 0 : 1;
  }
};
d(B, "players", /* @__PURE__ */ new Map());
let CanvasElementRenderer = B;
class IFrameElementRenderer {
  constructor() {
    d(this, "tag", "IFRAME");
  }
  onRender(l, t) {
  }
  onRemove(l, t) {
  }
  performEvent(l, t) {
    if (t.eventType === TrackerEventType.HTMLIFrame)
      if (l.isVanilla()) {
        const s = l.getNode(t.data.target);
        s && s.dispatchEvent(buildIFrameEvent(t.data.action));
      } else {
        const { target: s, action: c } = t.data, a = l.getNode(s);
        if (!a)
          throw new RenderingError(`Node with ID '${s}' not found.`);
        const r = a.extra || { state: IFrameState.Loaded };
        switch (c.type) {
          case IFrameActionType.Load:
            r.state = IFrameState.Loaded, r.recordings = void 0;
            break;
          case IFrameActionType.Unload:
            r.state = IFrameState.Loading, r.recordings = void 0;
            break;
          case IFrameActionType.StartRecording:
            r.state = IFrameState.Recording, r.recordings = M(v({}, r.recordings), { [c.data.parentId]: c.data.recording });
            break;
          case IFrameActionType.StopRecording:
            r.state = IFrameState.Loaded, r.recordings && delete r.recordings[c.data.parentId];
            break;
        }
        a.extra = r;
      }
  }
}
class ImageElementRenderer {
  constructor(l) {
    d(this, "options");
    this.options = l;
  }
  get tag() {
    return "IMAGE";
  }
  onRender(l, t, s) {
    var c, a;
    if (l.isVanilla()) {
      const r = s, o = t.extra;
      (c = this.options) != null && c.onError && (o == null ? void 0 : o.status) === "failed" && this.options.onError(r), (a = this.options) != null && a.onLoad && (o == null ? void 0 : o.status) === "loaded" && this.options.onLoad(r);
    }
  }
  onRemove(l, t) {
  }
  performEvent(l, t) {
    var a, r;
    if (t.eventType !== TrackerEventType.HTMLImage)
      return;
    const { target: s, data: c } = t.data;
    if (l.isVanilla()) {
      const o = l.getNode(s);
      (a = this.options) != null && a.onError && (c == null ? void 0 : c.status) === "failed" && this.options.onError(o), (r = this.options) != null && r.onLoad && c.status === "loaded" && this.options.onLoad(o);
    } else {
      const o = l.getNode(s);
      if (!o)
        return;
      o.extra = M(v({}, (o == null ? void 0 : o.extra) || {}), { status: c.status });
    }
  }
}
class RenderContext {
  constructor(l) {
    d(this, "mode");
    d(this, "_isIncremental", !1);
    d(this, "_snapshotId");
    d(this, "_map", new Id2NodeMap());
    d(this, "_waitList", new PromiseList());
    d(this, "_deferredTaskQueue", new DeferredTaskQueue());
    d(this, "_nodeRenderers", /* @__PURE__ */ new Map());
    this.mode = l;
  }
  get nodes() {
    return this._map;
  }
  get snapshotId() {
    return this._snapshotId ? this._snapshotId : "-";
  }
  get isIncremental() {
    return this._isIncremental;
  }
  setSnapshotId(l) {
    this._snapshotId = l;
  }
  setIncremental(l) {
    this._isIncremental = l;
  }
  setNodes(l) {
    this._map = l;
  }
  getNode(l) {
    return this._map.getNode(l);
  }
  registerNodeRenderer(l) {
    this._nodeRenderers.set(l.tag, l);
  }
  onNodeRender(l, t) {
    const s = this._nodeRenderers.get(l.tag);
    try {
      s && s.onRender(this, l, t);
    } catch (c) {
      console.error(c);
    }
  }
  onNodeRemove(l) {
    const t = this.nodes.getNode(l);
    if (!t)
      return;
    let s;
    this.isVanilla() ? s = this._nodeRenderers.get(t.tagName) : s = this._nodeRenderers.get(t.tag);
    try {
      s && s.onRemove(this, l);
    } catch (c) {
      console.error(c);
    }
  }
  onPatch(l, t, s) {
    if (l === "attrs")
      Reflect.set(t, l, Object.assign({}, t[l], s[l]));
    else if (l === "extra") {
      const c = this._nodeRenderers.get(t.tag);
      c && c.onPatchExtra && c.onPatchExtra(t, s);
    }
  }
  performEvent(l) {
    this._nodeRenderers.forEach((t) => {
      t.performEvent(this, l);
    });
  }
  addWaiting(l) {
    this._waitList.add(l);
  }
  deferTask(l) {
    this._deferredTaskQueue.enqueue(l);
  }
  waitAsyncTask() {
    return V(this, null, function* () {
      yield this._waitList.all(), yield this._deferredTaskQueue.executeAll();
    });
  }
  capture() {
    var l;
    for (const t of this._map.keys())
      for (const s of this._nodeRenderers.values())
        (l = s.onCapture) == null || l.call(s, this, t);
  }
  reset() {
    this._snapshotId && this._nodeRenderers.forEach((l) => {
      var t;
      (t = l.onReset) == null || t.call(l, this);
    }), this._map.reset(), this._waitList.clear(), this._deferredTaskQueue.clear();
  }
  isVanilla() {
    return this.mode === RenderMode.VanillaDOM;
  }
  isVirtual() {
    return this.mode === RenderMode.VirtualDOM;
  }
}
function lazyLoad(n, l = 0) {
  return new Promise((t) => {
    setTimeout(() => {
      const s = n();
      t(s);
    }, l);
  });
}
class StyleElementRenderer {
  get tag() {
    return "STYLE";
  }
  onRender(l, t) {
    var s;
    if (l.isVanilla()) {
      const c = l.getNode(t.id);
      if (c && isHTMLElement(c) && isHTMLStyleElement(c)) {
        const a = t;
        (s = a.extra) != null && s.commands && l.addWaiting(new Promise((r) => {
          setTimeout(() => {
            var b;
            if (!c.sheet) {
              r({
                failed: !1,
                timeout: !1,
                element: c
              });
              return;
            }
            const o = c.sheet, h = (b = a.extra) == null ? void 0 : b.commands;
            h == null || h.forEach((u) => {
              performStyleRuleSheet(o, u);
            }), r({
              failed: !1,
              timeout: !1,
              element: c
            });
          }, 0);
        }));
      }
    }
  }
  onPatchExtra(l, t) {
    var c, a, r;
    const s = l.extra;
    "commands" in s && ((c = s.commands) != null && c.length) && (s.commands = [
      ...(r = (a = t.extra) == null ? void 0 : a.commands) != null ? r : [],
      ...s.commands
    ]);
  }
  onRemove(l, t) {
  }
  performEvent(l, t) {
    t.eventType === TrackerEventType.HTMLMutations && t.data.forEach((c) => {
      var a;
      if (c.type === VMutationType.StyleSheetRule) {
        if (l.isVanilla()) {
          const r = l.getNode(c.target);
          if (!r)
            return;
          isHTMLElement(r) && isHTMLStyleElement(r) && r.sheet && performStyleRuleSheet(r.sheet, c.data);
        } else if (l.isVirtual()) {
          const r = l.getNode(c.target);
          if (!r)
            return;
          const o = r;
          o.extra || (o.extra = { commands: [] }), (a = o.extra.commands) == null || a.push(c.data);
        }
      }
    });
  }
}
function performStyleRuleSheet(n, l) {
  const t = RuleSheetMethodDecodes[l[0]];
  if (!t)
    return;
  const s = Reflect.get(n, t);
  try {
    Reflect.apply(s, n, l[1]);
  } catch (c) {
    console.warn(c);
  }
}
class ShadowRootRenderer {
  get tag() {
    return "#document-fragment";
  }
  onRender(l, t, s) {
    const c = t.extra, a = c.styleSheets.sheets;
    if (l.isVanilla()) {
      const r = s;
      r.__styles = {}, l.addWaiting(new Promise((o) => {
        setTimeout(() => {
          const h = [];
          for (let b = 0; b < a.length; b++) {
            const u = a[b], Z = c.styleSheets.rules[u], p = this._createHostedStyleSheet(r, Z);
            StyleSheetObserver.setSheetId(p, u), h.push(p), r.__styles[u] = p;
          }
          r.adoptedStyleSheets = [...r.adoptedStyleSheets, ...h], o({
            failed: !1,
            timeout: !1,
            element: r
          });
        }, 0);
      }));
    }
  }
  onPatchExtra(l, t) {
    const { sheets: s, rules: c } = t.extra.styleSheets, a = {
      styleSheets: {
        sheets: [...s],
        rules: Object.keys(c).reduce((h, b) => M(v({}, h), { [b]: [...c[Number(b)]] }), {})
      }
    }, o = l.extra.styleSheets;
    Object.keys(o.rules).forEach((h) => {
      const b = a.styleSheets.rules[Number(h)];
      b ? b.push(...o.rules[Number(h)]) : (a.styleSheets.rules[Number(h)] = [...o.rules[Number(h)]], a.styleSheets.sheets.push(Number(h)));
    }), l.extra = a;
  }
  performEvent(l, t) {
    t.eventType === TrackerEventType.HTMLMutations && t.data.forEach((c) => {
      c.type === VMutationType.StyleSheetRule ? this._performStyleSheetRuleChange(l, c) : c.type === VMutationType.StyleSheetAdopted && this._performStyleSheetAdoptedChange(l, c);
    });
  }
  _createHostedStyleSheet(l, t) {
    var a;
    const s = (a = l.host.ownerDocument) == null ? void 0 : a.defaultView;
    let c;
    return s ? c = new s.CSSStyleSheet() : c = new CSSStyleSheet(), t == null || t.forEach((r) => {
      performStyleRuleSheet(c, r);
    }), c;
  }
  _performStyleSheetRuleChange(l, t) {
    var s;
    if (l.isVanilla()) {
      const c = l.getNode(t.target);
      if (!c || !(c instanceof ShadowRoot) || !t.sheetId)
        return;
      const a = (s = c.__styles) == null ? void 0 : s[t.sheetId];
      a && performStyleRuleSheet(a, t.data);
    } else if (l.isVirtual()) {
      const c = l.getNode(t.target);
      if (!(c && c.tag === this.tag) || !t.sheetId)
        return;
      let a = c.extra;
      if (a || (a = { styleSheets: { sheets: [], rules: {} } }, c.extra = a), a && a.styleSheets.rules) {
        const r = a.styleSheets.rules[t.sheetId];
        r ? r.push(t.data) : (a.styleSheets.rules[t.sheetId] = [t.data], a.styleSheets.sheets.push(t.sheetId));
      }
    }
  }
  _performStyleSheetAdoptedChange(l, t) {
    if (l.isVanilla()) {
      const s = l.getNode(t.target);
      if (!s || !(s instanceof ShadowRoot))
        return;
      l.addWaiting(lazyLoad(() => {
        const c = s, { sheets: a, rules: r } = t.data, o = a.map((h) => {
          let b = c.__styles[h];
          return b || (b = this._createHostedStyleSheet(c, r[h])), b;
        });
        return c.adoptedStyleSheets = o, {
          failed: !1,
          timeout: !1,
          element: c
        };
      }));
    } else if (l.isVirtual()) {
      const s = l.getNode(t.target);
      if (!s || s.tag !== this.tag)
        return;
      const { sheets: c, rules: a } = t.data, r = s.extra, o = r.styleSheets.rules;
      r.styleSheets.rules = c.reduce((h, b) => M(v({}, h), { [b]: o[b] || a[b] }), {}), r.styleSheets.sheets = c;
    }
  }
  onRemove(l, t) {
  }
}
class AbstractSnapshotRenderer extends EventEmitter {
  constructor(t, s) {
    super();
    d(this, "context");
    d(this, "_suspended", !0);
    d(this, "_needRebuildId2NodeMap", !1);
    this.context = new RenderContext(t), this.registerNodeRenderer(StyleElementRenderer), this.registerNodeRenderer(IFrameElementRenderer), this.registerNodeRenderer(CanvasElementRenderer), this.registerNodeRenderer(ImageElementRenderer, s == null ? void 0 : s.image), this.registerNodeRenderer(ShadowRootRenderer), this.context.nodes.on("nodeAdded", (c, a) => {
      this.emit("nodeAdded", c, a);
    }), this.context.nodes.on("nodeRemoved", (c, a) => {
      this.emit("nodeRemoved", c, a);
    }), this.context.nodes.on("nodeReset", () => {
      this.emit("nodeReset");
    }), setInterval(() => {
      this._needRebuildId2NodeMap = !0;
    }, 1e3 * 60);
  }
  get suspended() {
    return this._suspended;
  }
  getNode(t) {
    return this.context.nodes.getNode(t);
  }
  reset() {
    this.context.reset();
  }
  suspend() {
    this._suspended = !0;
  }
  resume() {
    this._suspended = !1;
  }
  registerNodeRenderer(t, ...s) {
    const c = Reflect.construct(t, [...s]);
    this.context.registerNodeRenderer(c);
  }
  render(t) {
    return V(this, null, function* () {
      if (t.version !== 1)
        throw new UnsupportedError(`Unsupported snapshot version ${t.version}.`);
      this.context.setSnapshotId(t.id), this.reset();
      const s = this.suspended;
      this.suspend(), this.renderWindow(t.window), this.renderDocument(t.document), s || this.resume();
    });
  }
  performEvent(t) {
    return V(this, null, function* () {
      try {
        switch (t.eventType) {
          case TrackerEventType.HTMLSnapshot:
            yield this.render(t.data);
            return;
          case TrackerEventType.HTMLMutations:
            this.performMutations(t.data);
            break;
          case TrackerEventType.HTMLNavigation:
            this.performNavigation(t.data);
            break;
          case TrackerEventType.HTMLScroll:
            this.performScroll(t.data);
            break;
          case TrackerEventType.HTMLFocus:
            this.performFocus(t.data);
            break;
          case TrackerEventType.HTMLBlur:
            this.performBlur(t.data);
            break;
          case TrackerEventType.HTMLValueChange:
            this.performValueChange(t.data);
            break;
          case TrackerEventType.HTMLSelectionChange:
            this.performSelectionChange(t.data);
            break;
          case TrackerEventType.HTMLResize:
            this.performResize(t.data);
            break;
        }
        this.context.performEvent(t), yield this.performPostRendering();
      } catch (s) {
        console.error(s);
      }
      if (this._needRebuildId2NodeMap) {
        const s = new Id2NodeMap();
        this.rebuildNodes(s), this.context.setNodes(s), this._needRebuildId2NodeMap = !1;
      }
    });
  }
  performMutations(t) {
    for (const s of t)
      try {
        this.performMutation(s);
      } catch (c) {
        console.error(c);
      }
  }
  performMutation(t) {
    switch (t.type) {
      case VMutationType.AddNode:
        this.performAddNodeMutation(t);
        break;
      case VMutationType.ChangeAttributes:
        this.performChangeAttributeMutation(t);
        break;
      case VMutationType.RemoveNode:
        try {
          this.performRemoveNodeMutation(t);
        } catch (s) {
        }
        break;
      case VMutationType.CharacterData:
        this.performCharacterDataMutation(t);
        break;
      case VMutationType.Document:
        this.performDocumentMutation(t);
        break;
    }
  }
  performPostRendering() {
    return V(this, null, function* () {
    });
  }
  performChangeAttributeMutation(t) {
    const s = this.getNode(t.target);
    if (!s)
      throw new RenderingError(`Node with ID '${t.target}' not found.`);
    this.applyAttrs(t.data, s);
  }
  performScroll(t) {
    const s = this.getNode(t.target);
    s && this.applyScrolling(t.scroll, s);
  }
  performFocus(t) {
    const s = this.getNode(t.target);
    if (s)
      this.applyFocus(s);
    else
      throw new RenderingError(`Node with ID '${t.target}' not found.`);
  }
  performBlur(t) {
    const s = this.getNode(t.target);
    if (s)
      this.applyBlur(s);
    else
      throw new RenderingError(`Node with ID '${t.target}' not found.`);
  }
  performValueChange(t) {
    const s = this.getNode(t.target);
    s && (typeof t.value == "string" ? this.applyValue(t.value, s) : this.applyCheckedState(t.value, s));
  }
  performSelectionChange(t) {
    this.applySelection(t);
  }
  performResize(t) {
    this.applySize(t.size);
  }
}
class VirtualSnapshotRenderer extends AbstractSnapshotRenderer {
  constructor(t) {
    super(RenderMode.VirtualDOM, t);
    d(this, "_contentWindow");
    d(this, "_contentDocument");
    this._createNewContent();
  }
  get contentWindow() {
    return this._contentWindow;
  }
  get contentDocument() {
    return this._contentDocument;
  }
  get size() {
    return this.contentWindow.size;
  }
  get documentTitle() {
    return this.contentDocument.title;
  }
  get documentURL() {
    return this.contentWindow.location;
  }
  get documentBaseURI() {
    return this.contentDocument.baseURI;
  }
  getNode(t) {
    return this.context.nodes.getNode(t);
  }
  reset() {
    super.reset(), this._createNewContent();
  }
  captureSnapshot() {
    return V(this, null, function* () {
      const t = {
        version: 1,
        window: this.contentWindow,
        document: this._contentDocument,
        id: this.context.snapshotId
      };
      return this.context.capture(), yield this.context.waitAsyncTask(), deepClone(t);
    });
  }
  mergeIncrementalSnapshot(t, s) {
    let a = deepClone(t);
    return s.forEach((r) => {
      const o = /* @__PURE__ */ new Map();
      this.visitVElement(a.document.root, o), a = this.patchIncrementalSnapshot(a, deepClone(r), o);
    }), a;
  }
  visitVElement(t, s) {
    var c;
    s.set(t.id, t), (c = t.children) == null || c.forEach((a) => {
      this.visitVElement(a, s);
    });
  }
  patchVElement(t, s) {
    var r;
    const c = s.get(t.id);
    if (c) {
      const a = c, { children: o, shadowRoot: h, id: b, type: u, tag: Z, extra: p } = a, G = le(a, ["children", "shadowRoot", "id", "type", "tag", "extra"]);
      ["id", "type", "tag", ...Object.keys(G), "extra"].forEach((f) => {
        const R = f;
        t[R] === void 0 ? Reflect.set(t, R, c[R]) : this.context.onPatch(R, t, c);
      }), isVParentNode(t) && ((r = t.children) == null || r.forEach((f) => {
        this.patchVElement(f, s);
      })), h && (t.shadowRoot = this.patchVElement(h, s));
    }
    return t;
  }
  patchIncrementalSnapshot(t, s, c) {
    const a = this.patchVElement(s.document.root, c);
    t.window = v(v({}, t.window), s.window);
    const { visibilityState: r } = s.document;
    return t.document.root = a, r && (t.document.visibilityState = r), t;
  }
  _createNewContent() {
    this._contentWindow = {
      location: "about:blank",
      size: [0, 0]
    }, this._contentDocument = {
      type: VNodeType.DocumentNode,
      id: 1,
      baseURI: "about:blank",
      title: "",
      root: {
        id: 2,
        parentId: 1,
        tag: "HTML",
        type: VNodeType.ElementNode
      },
      visibilityState: "hidden"
    };
  }
  renderWindow(t) {
    this._contentWindow = deepClone(t);
  }
  renderDocument(t) {
    this._contentDocument = deepClone(t), this.renderNode(this._contentDocument.root, !1);
  }
  renderNode(t, s = !0) {
    const c = s ? deepClone(t) : t;
    return this.context.nodes.addNode(t.id, c), this.context.onNodeRender(t, c), isVElement(c) && this._renderElementNode(c), isVParentNode(c) && this._renderChildren(c), c;
  }
  _renderElementNode(t) {
    t.shadowRoot && this.renderNode(t.shadowRoot, !1);
  }
  _renderChildren(t) {
    if (t.children)
      for (const s of t.children)
        this.renderNode(s, !1);
  }
  performNavigation(t) {
    this._contentWindow.location = t.to, this.emit("navigate", t);
  }
  performAddNodeMutation(t) {
    const s = this.getNode(t.target);
    if (!s)
      throw new RenderingError(`Target with ID '${t.target}' not found.`);
    const c = this.renderNode(t.data.node);
    s.children || (s.children = []);
    let a;
    t.data.before && (a = this.getNode(t.data.before));
    let r;
    a && (r = s.children.findIndex((o) => o.id === (a == null ? void 0 : a.id))) !== -1 ? s.children.splice(r, 0, c) : s.children.push(c);
  }
  performRemoveNodeMutation(t) {
    const s = this.getNode(t.target);
    if (!s)
      throw new RenderingError(`Node with ID '${t.target}' not found.`);
    let c, a = [];
    typeof t.data == "object" ? (c = t.data.id, a = t.data.children) : c = t.data;
    const r = this.getNode(c);
    if (!r)
      throw new RenderingError(`Node with ID '${c}' not found.`);
    if (s.children) {
      const o = s.children.findIndex((h) => h.id === r.id);
      o !== -1 && s.children.splice(o, 1);
    }
    a.forEach((o) => {
      this.context.onNodeRemove(o), this.context.nodes.removeNode(o);
    }), this.context.onNodeRemove(c), this.context.nodes.removeNode(c);
  }
  performCharacterDataMutation(t) {
    const s = this.getNode(t.target);
    if (!s)
      throw new RenderingError(`Node with ID '${t.target}' not found.`);
    t.data !== null ? s.text = t.data : delete s.text;
  }
  performDocumentMutation(t) {
    t.data.visibilityState && (this.contentDocument.visibilityState = t.data.visibilityState);
  }
  applyAttrs(t, s) {
    for (const [c, a] of Object.entries(t))
      a !== null ? (s.attrs || (s.attrs = {}), s.attrs[c] = a) : s.attrs && delete s.attrs[c];
  }
  applyScrolling(t, s) {
    s.scroll = [...t];
  }
  applyValue(t, s) {
    s.value = t;
  }
  applyCheckedState(t, s) {
    s.checked = t;
  }
  applySize(t, s = !0) {
    this.contentWindow.size = [...t], s && this.emit("resize");
  }
  applyBlur() {
  }
  applyFocus() {
  }
  applySelection() {
  }
  rebuildNodes(t) {
    t.addNode(this._contentDocument.root.id, this._contentDocument), this._rebuildNode(t, this._contentDocument.root);
  }
  _rebuildNode(t, s) {
    var c;
    t.addNode(s.id, s), isVParentNode(s) && ((c = s.children) == null || c.forEach((a) => this._rebuildNode(t, a))), isVElement(s) && s.shadowRoot && this._rebuildNode(t, s.shadowRoot);
  }
}
class IncrementalSnapshotRenderer extends VirtualSnapshotRenderer {
  constructor(t) {
    super(t);
    d(this, "_changedWindow");
    d(this, "_changedDocument");
    d(this, "_changedCount", 0);
    this.context.setIncremental(!0), this._initIncremental();
  }
  get size() {
    return this._changedWindow.size || super.size;
  }
  get documentTitle() {
    return this._changedDocument.title || super.documentTitle;
  }
  get documentURL() {
    return this._changedWindow.location || super.documentURL;
  }
  get documentBaseURI() {
    return this._changedDocument.baseURI || super.documentBaseURI;
  }
  reset() {
    super.reset(), this._initIncremental();
  }
  _initIncremental() {
    this._changedWindow = {}, this._changedDocument = {}, this._changedCount = 0;
  }
  getIncrementalPercent() {
    return this._changedCount / this.context.nodes.size();
  }
  renderWindow(t) {
    super.renderWindow(t);
  }
  renderDocument(t) {
    super.renderDocument(t), this._changedDocument.root = this.renderNode(t.root, !1);
  }
  captureIncrementalSnapshot() {
    return V(this, null, function* () {
      const t = {
        version: 1,
        window: this._changedWindow,
        document: this._changedDocument,
        id: this.context.snapshotId
      };
      this.context.capture(), yield this.context.waitAsyncTask();
      const s = deepClone(t);
      return this._initIncremental(), this.context.reset(), this._changedDocument.root = this.renderNode(t.document.root, !1), s;
    });
  }
  renderNode(t, s = !0) {
    const { id: c, type: a } = t, r = s ? deepClone(t) : { id: c, type: a };
    return isVParentNode(t) && (r.children = this.__renderChildren(t, s)), isVElement(t) && t.shadowRoot && (r.shadowRoot = this.renderNode(t.shadowRoot, s)), this.context.nodes.addNode(t.id, r), r;
  }
  __renderChildren(t, s = !0) {
    if (t.children)
      return t.children.map((c) => this.renderNode(c, s));
  }
  performAddNodeMutation(t) {
    super.performAddNodeMutation(t), this._changedCount++;
  }
  performNavigation(t) {
    this._changedWindow.location = t.to;
  }
  applyAttrs(t, s) {
    for (const [c, a] of Object.entries(t))
      s.attrs || (s.attrs = {}), s.attrs[c] = a;
  }
  applySize(t, s) {
    this._changedWindow.size = t, s && this.emit("resize");
  }
  rebuildNodes(t) {
    this._changedDocument.id != null && t.addNode(this._changedDocument.root.id, this._changedDocument), this._rebuildNode(t, this._changedDocument.root);
  }
}
const BRIDGING_TOPIC = "bytereplay.bridging";
function isEnvelop(n) {
  return typeof n == "object" && !!n && "topic" in n && n.topic === BRIDGING_TOPIC;
}
var InternalMessageType = /* @__PURE__ */ ((n) => (n.Handshake = "internal.handshake", n.Stopped = "internal.stopped", n.Connected = "internal.connected", n.Disconnected = "internal.disconnected", n))(InternalMessageType || {});
const GLOBAL_BRIDGE_SYMBOL = "__bytereplay_bridge__";
class GlobalAccessor {
  get global() {
    return globalThis[GLOBAL_BRIDGE_SYMBOL];
  }
}
function hasByteReplayBridge(n) {
  return n[GLOBAL_BRIDGE_SYMBOL] != null;
}
const bridge = new GlobalAccessor();
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const proxyMarker = Symbol("Comlink.proxy"), createEndpoint = Symbol("Comlink.endpoint"), releaseProxy = Symbol("Comlink.releaseProxy"), finalizer = Symbol("Comlink.finalizer"), throwMarker = Symbol("Comlink.thrown"), isObject = (n) => typeof n == "object" && n !== null || typeof n == "function", proxyTransferHandler = {
  canHandle: (n) => isObject(n) && n[proxyMarker],
  serialize(n) {
    const { port1: l, port2: t } = new MessageChannel();
    return expose(n, l), [t, [t]];
  },
  deserialize(n) {
    return n.start(), wrap(n);
  }
}, throwTransferHandler = {
  canHandle: (n) => isObject(n) && throwMarker in n,
  serialize({ value: n }) {
    let l;
    return n instanceof Error ? l = {
      isError: !0,
      value: {
        message: n.message,
        name: n.name,
        stack: n.stack
      }
    } : l = { isError: !1, value: n }, [l, []];
  },
  deserialize(n) {
    throw n.isError ? Object.assign(new Error(n.value.message), n.value) : n.value;
  }
}, transferHandlers = /* @__PURE__ */ new Map([
  ["proxy", proxyTransferHandler],
  ["throw", throwTransferHandler]
]);
function isAllowedOrigin(n, l) {
  for (const t of n)
    if (l === t || t === "*" || t instanceof RegExp && t.test(l))
      return !0;
  return !1;
}
function expose(n, l = globalThis, t = ["*"]) {
  l.addEventListener("message", function s(c) {
    if (!c || !c.data)
      return;
    if (!isAllowedOrigin(t, c.origin)) {
      console.warn(`Invalid origin '${c.origin}' for comlink proxy`);
      return;
    }
    const { id: a, type: r, path: o } = Object.assign({ path: [] }, c.data), h = (c.data.argumentList || []).map(fromWireValue);
    let b;
    try {
      const u = o.slice(0, -1).reduce((p, G) => p[G], n), Z = o.reduce((p, G) => p[G], n);
      switch (r) {
        case "GET":
          b = Z;
          break;
        case "SET":
          u[o.slice(-1)[0]] = fromWireValue(c.data.value), b = !0;
          break;
        case "APPLY":
          b = Z.apply(u, h);
          break;
        case "CONSTRUCT":
          {
            const p = new Z(...h);
            b = proxy(p);
          }
          break;
        case "ENDPOINT":
          {
            const { port1: p, port2: G } = new MessageChannel();
            expose(n, G), b = transfer(p, [p]);
          }
          break;
        case "RELEASE":
          b = void 0;
          break;
        default:
          return;
      }
    } catch (u) {
      b = { value: u, [throwMarker]: 0 };
    }
    Promise.resolve(b).catch((u) => ({ value: u, [throwMarker]: 0 })).then((u) => {
      const [Z, p] = toWireValue(u);
      l.postMessage(Object.assign(Object.assign({}, Z), { id: a }), p), r === "RELEASE" && (l.removeEventListener("message", s), closeEndPoint(l), finalizer in n && typeof n[finalizer] == "function" && n[finalizer]());
    }).catch((u) => {
      const [Z, p] = toWireValue({
        value: new TypeError("Unserializable return value"),
        [throwMarker]: 0
      });
      l.postMessage(Object.assign(Object.assign({}, Z), { id: a }), p);
    });
  }), l.start && l.start();
}
function isMessagePort(n) {
  return n.constructor.name === "MessagePort";
}
function closeEndPoint(n) {
  isMessagePort(n) && n.close();
}
function wrap(n, l) {
  return createProxy(n, [], l);
}
function throwIfProxyReleased(n) {
  if (n)
    throw new Error("Proxy has been released and is not useable");
}
function releaseEndpoint(n) {
  return requestResponseMessage(n, {
    type: "RELEASE"
  }).then(() => {
    closeEndPoint(n);
  });
}
const proxyCounter = /* @__PURE__ */ new WeakMap(), proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((n) => {
  const l = (proxyCounter.get(n) || 0) - 1;
  proxyCounter.set(n, l), l === 0 && releaseEndpoint(n);
});
function registerProxy(n, l) {
  const t = (proxyCounter.get(l) || 0) + 1;
  proxyCounter.set(l, t), proxyFinalizers && proxyFinalizers.register(n, l, n);
}
function unregisterProxy(n) {
  proxyFinalizers && proxyFinalizers.unregister(n);
}
function createProxy(n, l = [], t = function() {
}) {
  let s = !1;
  const c = new Proxy(t, {
    get(a, r) {
      if (throwIfProxyReleased(s), r === releaseProxy)
        return () => {
          unregisterProxy(c), releaseEndpoint(n), s = !0;
        };
      if (r === "then") {
        if (l.length === 0)
          return { then: () => c };
        const o = requestResponseMessage(n, {
          type: "GET",
          path: l.map((h) => h.toString())
        }).then(fromWireValue);
        return o.then.bind(o);
      }
      return createProxy(n, [...l, r]);
    },
    set(a, r, o) {
      throwIfProxyReleased(s);
      const [h, b] = toWireValue(o);
      return requestResponseMessage(n, {
        type: "SET",
        path: [...l, r].map((u) => u.toString()),
        value: h
      }, b).then(fromWireValue);
    },
    apply(a, r, o) {
      throwIfProxyReleased(s);
      const h = l[l.length - 1];
      if (h === createEndpoint)
        return requestResponseMessage(n, {
          type: "ENDPOINT"
        }).then(fromWireValue);
      if (h === "bind")
        return createProxy(n, l.slice(0, -1));
      const [b, u] = processArguments(o);
      return requestResponseMessage(n, {
        type: "APPLY",
        path: l.map((Z) => Z.toString()),
        argumentList: b
      }, u).then(fromWireValue);
    },
    construct(a, r) {
      throwIfProxyReleased(s);
      const [o, h] = processArguments(r);
      return requestResponseMessage(n, {
        type: "CONSTRUCT",
        path: l.map((b) => b.toString()),
        argumentList: o
      }, h).then(fromWireValue);
    }
  });
  return registerProxy(c, n), c;
}
function myFlat(n) {
  return Array.prototype.concat.apply([], n);
}
function processArguments(n) {
  const l = n.map(toWireValue);
  return [l.map((t) => t[0]), myFlat(l.map((t) => t[1]))];
}
const transferCache = /* @__PURE__ */ new WeakMap();
function transfer(n, l) {
  return transferCache.set(n, l), n;
}
function proxy(n) {
  return Object.assign(n, { [proxyMarker]: !0 });
}
function toWireValue(n) {
  for (const [l, t] of transferHandlers)
    if (t.canHandle(n)) {
      const [s, c] = t.serialize(n);
      return [
        {
          type: "HANDLER",
          name: l,
          value: s
        },
        c
      ];
    }
  return [
    {
      type: "RAW",
      value: n
    },
    transferCache.get(n) || []
  ];
}
function fromWireValue(n) {
  switch (n.type) {
    case "HANDLER":
      return transferHandlers.get(n.name).deserialize(n.value);
    case "RAW":
      return n.value;
  }
}
function requestResponseMessage(n, l, t) {
  return new Promise((s) => {
    const c = generateUUID();
    n.addEventListener("message", function a(r) {
      !r.data || !r.data.id || r.data.id !== c || (n.removeEventListener("message", a), s(r.data));
    }), n.start && n.start(), n.postMessage(Object.assign({ id: c }, l), t);
  });
}
function generateUUID() {
  return new Array(4).fill(0).map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}
class WorkerBridgeFlow extends AbstractFlow {
  constructor(l) {
    super(), this.worker = l;
  }
  handleInput(l) {
    this._postFrame(l), this.output(l);
  }
  _postFrame(l) {
    const t = {
      topic: BRIDGING_TOPIC,
      contentType: "bytereplay.core.Frame",
      content: l
    };
    try {
      this.worker.postMessage(t);
    } catch (s) {
      console.error(`post frame(${l.trackType}, ${l.event.eventType}) to worker error.`, s);
    }
  }
}
const ONE_PIXEL_TRANSPARENT = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
function createFrameFromEvent(n, l, t) {
  return { time: t, trackType: n, event: l };
}
function getMousePosition(n) {
  const [l, t] = n.eventType === TrackerEventType.MouseDown || n.eventType === TrackerEventType.MouseMove || n.eventType === TrackerEventType.MouseUp || n.eventType === TrackerEventType.MouseClick ? n.data : n.data[0];
  return [l, t];
}
function getMouseTargetId(n) {
  return (n.eventType === TrackerEventType.MouseDown || n.eventType === TrackerEventType.MouseMove || n.eventType === TrackerEventType.MouseUp || n.eventType === TrackerEventType.MouseClick ? n.data : n.data[0])[3];
}
function getMouseTargetContext(n) {
  return (n.eventType === TrackerEventType.MouseDown || n.eventType === TrackerEventType.MouseMove || n.eventType === TrackerEventType.MouseUp || n.eventType === TrackerEventType.MouseClick ? n.data : n.data[0])[4];
}
class ObservableTracker {
  constructor(l, t) {
    d(this, "_isActive", !1);
    d(this, "_output", null);
    this.trackType = l, this.context = t;
  }
  get isActive() {
    return this._isActive;
  }
  get output() {
    return this._output || (this._output = this.createOutput()), this._output;
  }
  activate() {
    this.setActive(!0), this.onActivate();
  }
  deactivate() {
    this.setActive(!1), this.onDeactivate();
  }
  onActivate() {
  }
  onDeactivate() {
  }
  setActive(l) {
    this._isActive = l;
  }
}
class AbstractTracker extends ObservableTracker {
  track(l) {
    if (this.isActive) {
      const t = createFrameFromEvent(this.trackType, l, now());
      this.output.next(t);
    }
  }
  createOutput() {
    return new Subject();
  }
}
const ae = class ae extends AbstractTracker {
  constructor(t, s) {
    super(TrackType.Console, t);
    d(this, "_options");
    d(this, "_eventTypesMapping");
    d(this, "_vanillaMethods", /* @__PURE__ */ new Map());
    d(this, "_hookedMethods", /* @__PURE__ */ new Map());
    d(this, "_handleConsole", (t, ...s) => {
      this._eventTypesMapping && this.track({ eventType: this._eventTypesMapping[t], data: this._postProcess(s) });
    });
    this._options = s;
  }
  activate() {
    super.activate();
    const t = this._getAvailableMethodNames();
    this._eventTypesMapping = this._generateEventTypesMapping(t);
    for (const s of t)
      this._hook(s, this._handleConsole);
  }
  deactivate() {
    super.deactivate();
    const t = this._getAvailableMethodNames();
    for (const s of t)
      this._unhook(s);
    this._eventTypesMapping = void 0, this._vanillaMethods.clear(), this._hookedMethods.clear();
  }
  _hook(t, s) {
    if (!this._vanillaMethods.has(t)) {
      const c = window.console[t];
      this._vanillaMethods.set(t, c), window.console[t] = function(...r) {
        s(t, ...r), c.apply(this, r);
      }, this._hookedMethods.set(t, window.console[t]);
    }
  }
  _unhook(t) {
    this._vanillaMethods.has(t) && window.console[t] === this._hookedMethods.get(t) && (window.console[t] = this._vanillaMethods.get(t));
  }
  _generateEventTypesMapping(t) {
    const s = {};
    for (const c of t)
      s[c] = TrackerEventType[`Console${c[0].toUpperCase()}${c.slice(1)}`];
    return s;
  }
  /**
   * Replace args with placeholders, such as `window`, `document`, etc, and decycle the args.
   */
  _postProcess(t) {
    return t.map((s) => {
      var c;
      try {
        return stringify(s, (c = this._options) == null ? void 0 : c.stringifyOptions);
      } catch (a) {
        return "[Can't stringify]";
      }
    });
  }
  _getAvailableMethodNames() {
    var t, s;
    return window.console ? ((s = (t = this._options) == null ? void 0 : t.levels) != null ? s : ae.CONSOLE_METHODS).filter((c) => isFunction$1(window.console[c])) : [];
  }
};
d(ae, "CONSOLE_METHODS", [
  "error",
  "log"
  // 'assert',
  // 'debug',
  // 'dir',
  // 'dirxml',
  // 'info',
  // 'table',
  // 'trace',
  // 'warn'
]);
let ConsoleTracker = ae;
class CustomTracker extends AbstractTracker {
  constructor(l, t) {
    super(checkCustomTrackType(l), t);
  }
  track(l) {
    checkCustomTrackType(l.eventType), super.track(l);
  }
}
class ErrorTracker extends AbstractTracker {
  constructor(t) {
    super(TrackType.Error, t);
    d(this, "_sequentialId", 0);
    d(this, "_handleError", (t) => {
      var a, r;
      const s = this._nextId(), c = window.location.href;
      if (t instanceof ErrorEvent) {
        const { message: o } = t;
        if (/^script error\.?$/i.test(o))
          this.track({ eventType: TrackerEventType.ERROR_SCRIPT, data: { id: s, message: o, page: c } });
        else {
          const h = {}, { error: b } = t;
          b && b.stack && (h.stack = b.stack), this.track({
            eventType: TrackerEventType.ERROR_RUNTIME,
            data: v({
              id: s,
              message: o,
              source: t.filename,
              lineno: t.lineno,
              colno: t.colno,
              page: c
            }, h)
          });
        }
      } else {
        const o = { id: s, message: "Resource Not Found." }, h = t.target;
        h && (o.page = (a = h.baseURI) != null ? a : c, o.source = (r = h.src) != null ? r : h.href), this.track({ eventType: TrackerEventType.ERROR_NOTFOUND, data: o });
      }
    });
    d(this, "_handleRejection", (t) => {
      const s = "Uncaught (in promise) Error", c = {
        id: this._nextId(),
        message: `${s}.`,
        page: window.location.href
      }, { reason: a } = t;
      a && (isString(a) ? c.message = a : (a.message && (c.message = `${s}: ${a.message}`), a.stack && (c.stack = a.stack))), this.track({ eventType: TrackerEventType.ERROR_PROMISEREJECTION, data: c });
    });
  }
  activate() {
    super.activate(), window.addEventListener("error", this._handleError, !0), window.addEventListener("unhandledrejection", this._handleRejection, !0);
  }
  deactivate() {
    super.deactivate(), window.removeEventListener("error", this._handleError, !0), window.removeEventListener("unhandledrejection", this._handleRejection, !0);
  }
  _nextId() {
    return ++this._sequentialId;
  }
}
class IFrameObserver {
  constructor(l) {
    d(this, "_iFrames", /* @__PURE__ */ new WeakMap());
    d(this, "_contexts", /* @__PURE__ */ new WeakMap());
    var t, s, c;
    this.callback = l, (t = bridge.global) == null || t.iframe.on("recordingStarted", (a, r) => {
      const o = this._iFrames.get(r);
      o && this._handleAction(o, { type: IFrameActionType.StartRecording, data: a });
    }), (s = bridge.global) == null || s.iframe.on("recordingStopped", (a, r) => {
      const o = this._iFrames.get(r);
      o && this._handleAction(o, { type: IFrameActionType.StopRecording, data: a });
    }), (c = bridge.global) == null || c.iframe.on("unload", (a) => {
      const r = this._iFrames.get(a);
      r && this._handleAction(r, { type: IFrameActionType.Unload, data: {} });
    });
  }
  get nodeName() {
    return "IFRAME";
  }
  observe(l, t, s) {
    var a;
    const c = t.contentWindow;
    if (c) {
      const r = t.contentDocument == null;
      this._iFrames.set(c, t), this._contexts.set(t, l);
      let o = "";
      if (!r)
        o = location.origin;
      else
        try {
          o = new URL(t.src).origin;
        } catch (h) {
        }
      (a = bridge.global) == null || a.iframe.connect(c, { isCrossOrigin: r, origin: o }), t.addEventListener(
        "load",
        () => {
          this.observe(l, t, {}), this._handleAction(t, { type: IFrameActionType.Load, data: {} });
        },
        { once: !0 }
      );
    }
    s.extra = { state: IFrameState.Loaded };
  }
  disconnect(l) {
    l.contentWindow && (this._iFrames.delete(l.contentWindow), this._contexts.delete(l));
  }
  disconnectAll() {
    this._iFrames = /* @__PURE__ */ new WeakMap(), this._contexts = /* @__PURE__ */ new WeakMap();
  }
  _handleAction(l, t) {
    const s = this._contexts.get(l), c = s == null ? void 0 : s.nodes.getNodeId(l);
    c && this.callback({
      eventType: TrackerEventType.HTMLIFrame,
      data: { target: c, action: t }
    });
  }
}
class NavigationObserver {
  constructor(l, t) {
    d(this, "prevUrl");
    d(this, "_navigationHandler");
    d(this, "_idleTimer");
    d(this, "_watch", () => {
      this.prevUrl !== location.href && (this.callback({
        eventType: TrackerEventType.HTMLNavigation,
        data: { from: this.prevUrl || "", to: location.href, type: "unknown" }
      }), this.prevUrl = location.href);
    });
    this.context = l, this.callback = t;
  }
  start() {
    if ("navigation" in globalThis) {
      const l = (t) => {
        this.callback({
          eventType: TrackerEventType.HTMLNavigation,
          data: { from: t.target.currentEntry.url, to: t.destination.url, type: t.navigationType }
        });
      };
      globalThis.navigation.addEventListener("navigate", l);
    } else
      this.prevUrl = location.href, this._idleTimer = this._nextTick();
  }
  _nextTick() {
    return setInterval(this._watch, 1e3);
  }
  stop() {
    "navigation" in globalThis && this._navigationHandler ? globalThis.navigation.removeEventListener("navigate", this._navigationHandler) : this._idleTimer !== void 0 && clearInterval(this._idleTimer);
  }
}
class HTMLTracker extends AbstractTracker {
  constructor(t, s) {
    super(TrackType.HTML, t);
    d(this, "_snapshotCapturer");
    d(this, "_navigationObserver");
    d(this, "_handleTrackEvent", (t) => {
      this.track(t);
    });
    this._snapshotCapturer = new SnapshotCapturer(s), s != null && s.navigation && (this._navigationObserver = new NavigationObserver(t, (c) => {
      this.track(c);
    })), s != null && s.iframe && this._snapshotCapturer.registerNodeObserver(IFrameObserver);
  }
  get snapshotCapturer() {
    return this._snapshotCapturer;
  }
  activate() {
    var t;
    super.activate(), this._snapshotCapturer.on("event", this._handleTrackEvent), this._snapshotCapturer.start(), (t = this._navigationObserver) == null || t.start();
  }
  deactivate() {
    var t;
    super.deactivate(), this._snapshotCapturer.off("event", this._handleTrackEvent), this._snapshotCapturer.stop(), (t = this._navigationObserver) == null || t.stop();
  }
  getNodeId(t) {
    return this._snapshotCapturer.getNodeId(t);
  }
}
class KeyboardTracker extends AbstractTracker {
  constructor(t) {
    super(TrackType.Keyboard, t);
    d(this, "_ignoredKeys", {
      Alt: !0,
      Shift: !0,
      Control: !0,
      Meta: !0
    });
    d(this, "_allowedInputTypes", {
      button: !0,
      checkbox: !0,
      color: !0,
      file: !0,
      hidden: !0,
      image: !0,
      radio: !0,
      range: !0,
      reset: !0,
      submit: !0
    });
    d(this, "_handleKeyDown", (t) => {
      const { key: s, target: c } = t;
      this._ignoredKeys[s] || this.track({
        eventType: TrackerEventType.KeyDown,
        data: [s, t.code, t.altKey, t.ctrlKey, t.metaKey, t.shiftKey, this.context.getNodeId(c)]
      });
    });
  }
  activate() {
    super.activate(), document.addEventListener("keydown", this._handleKeyDown, !0);
  }
  deactivate() {
    super.deactivate(), document.removeEventListener("keydown", this._handleKeyDown, !0);
  }
}
class RecordingError extends RuntimeError {
  constructor(l, t) {
    super(l, t), this.name = "bytereplay.recorder.RecordingError";
  }
}
class TrackingError extends RecordingError {
  constructor(l, t) {
    super(l, t), this.name = "bytereplay.recorder.TrackingError";
  }
}
const TRACKED_TEXT_CONTENT_ELEMENTS = {
  BUTTON: !0,
  A: !0,
  SPAN: !0,
  LABEL: !0,
  INPUT: !0,
  SELECT: !0,
  TH: !0,
  TD: !0,
  SUMMARY: !0,
  DETAILS: !0
};
class MouseTracker extends AbstractTracker {
  constructor(t, s) {
    var c, a;
    super(TrackType.Mouse, t);
    /**
     * Sampling interval in `milliseconds`.
     */
    d(this, "_samplingInterval");
    d(this, "_maxTextLength");
    d(this, "_samplingDistance", 2);
    d(this, "_lastMoveTime", 0);
    d(this, "_lastMovePosition");
    /**
     * For mouse events.
     */
    d(this, "_mouseTargetId");
    d(this, "_mouseTargetContext");
    /**
     * Indicates whether the user is touching the screen,
     * used to prevent mouse events from being tracked.
     */
    d(this, "_isTouching", !1);
    d(this, "_handleMouseMove", (t) => {
      this._isTouching || (this._lastMoveTime === 0 || calculateElapsedTime(this._lastMoveTime) > this._samplingInterval) && (this._lastMovePosition == null || calculateManhattanDistance(t, this._lastMovePosition) > this._samplingDistance) && (this._lastMoveTime = now(), this._lastMovePosition == null ? this._lastMovePosition = [t.x, t.y] : (this._lastMovePosition[0] = t.x, this._lastMovePosition[1] = t.y), this.track(this._convertMouseEvent2TrackerEvent(t)));
    });
    d(this, "_handleMouseDown", (t) => {
      if (this._isTouching)
        return;
      this._lastMoveTime = 0, this._lastMovePosition = void 0;
      const s = t.target;
      this._mouseTargetId = this.context.getNodeId(s), this._mouseTargetContext = this._getTargetContext(s), this.track(this._convertMouseEvent2TrackerEvent(t, this._mouseTargetId, this._mouseTargetContext));
    });
    d(this, "_handleMouseUp", (t) => {
      this._isTouching || (this.track(this._convertMouseEvent2TrackerEvent(t, this._mouseTargetId, this._mouseTargetContext)), this._reset());
    });
    d(this, "_handleMouseClick", (t) => {
      const s = t.target;
      this.track(this._convertMouseEvent2TrackerEvent(t, this.context.getNodeId(s), this._getTargetContext(s)));
    });
    d(this, "_handleTouchStart", (t) => {
      this._isTouching = !0, this._lastMoveTime = 0;
      const s = this._gatherTouches(t.touches);
      s.length > 0 && this.track({ eventType: TrackerEventType.TouchStart, data: s });
    });
    d(this, "_handleTouchMove", (t) => {
      if (this._lastMoveTime === 0 || calculateElapsedTime(this._lastMoveTime) > this._samplingInterval) {
        this._lastMoveTime = now();
        const s = this._gatherTouches(t.touches, !1, !1);
        s.length > 0 && this.track({ eventType: TrackerEventType.TouchMove, data: s });
      }
    });
    d(this, "_handleTouchEnd", (t) => {
      setTimeout(() => this._isTouching = !1, 20);
      const s = this._gatherTouches(t.changedTouches);
      s.length > 0 && this.track({ eventType: TrackerEventType.TouchEnd, data: s });
    });
    d(this, "_handleTouchCancel", (t) => {
      setTimeout(() => this._isTouching = !1, 20);
      const s = this._gatherTouches(t.changedTouches);
      s.length > 0 && this.track({ eventType: TrackerEventType.TouchCancel, data: s });
    });
    this._samplingInterval = Math.floor(1e3 / ((c = s == null ? void 0 : s.samplingRate) != null ? c : 8) * 1e3) / 1e3, this._maxTextLength = (a = s == null ? void 0 : s.maxTextLength) != null ? a : 100, this._maxTextLength > 199 && console.warn(
      `The option "maxTextLength" is set too high (${this._maxTextLength}), which may reduce recording performance.`
    );
  }
  activate() {
    super.activate(), this._reset(), window.addEventListener("touchstart", this._handleTouchStart, !0), window.addEventListener("touchmove", this._handleTouchMove, !0), window.addEventListener("touchend", this._handleTouchEnd, !0), window.addEventListener("touchcancel", this._handleTouchCancel, !0), window.addEventListener("mousemove", this._handleMouseMove, !0), window.addEventListener("mousedown", this._handleMouseDown, !0), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("click", this._handleMouseClick, !0);
  }
  deactivate() {
    super.deactivate(), this._reset(), window.removeEventListener("touchstart", this._handleTouchStart, !0), window.removeEventListener("touchmove", this._handleTouchMove, !0), window.removeEventListener("touchend", this._handleTouchEnd, !0), window.removeEventListener("touchcancel", this._handleTouchCancel, !0), window.removeEventListener("mousemove", this._handleMouseMove, !0), window.removeEventListener("mousedown", this._handleMouseDown, !0), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("click", this._handleMouseClick, !0);
  }
  _convertMouseEvent2TrackerEvent(t, s, c) {
    const a = [t.clientX, t.clientY, t.buttons];
    return s != null && c != null ? a.push(s, c) : s != null ? a.push(s) : c != null && (a[4] = c), { eventType: _getEventType(t), data: a };
  }
  _gatherTouches(t, s = !0, c = !0) {
    const a = [];
    for (let r = 0; r < t.length; r++) {
      const o = t[r], h = [Math.round(o.clientX), Math.round(o.clientY), o.identifier];
      if (s) {
        const b = this.context.getNodeId(o.target);
        b != null && h.push(b);
      }
      if (c) {
        const b = this._getTargetContext(o.target);
        b != null && (h[4] = b);
      }
      a.push(h);
    }
    return a;
  }
  _getTargetContext(t) {
    var s;
    if (t != null && isHTMLElement(t)) {
      const c = { tagName: t.tagName };
      if (TRACKED_TEXT_CONTENT_ELEMENTS[c.tagName]) {
        const a = (s = t.textContent) != null ? s : void 0;
        a != null && (c.textContent = a.length > this._maxTextLength ? a.slice(0, this._maxTextLength) + "..." : a);
      }
      return c;
    }
  }
  _reset() {
    this._lastMoveTime = 0, this._lastMovePosition = void 0, this._mouseTargetId = void 0, this._mouseTargetContext = void 0, this._isTouching = !1;
  }
}
function _getEventType(n) {
  switch (n.type) {
    case "mousemove":
      return TrackerEventType.MouseMove;
    case "mousedown":
      return TrackerEventType.MouseDown;
    case "mouseup":
      return TrackerEventType.MouseUp;
    case "click":
      return TrackerEventType.MouseClick;
    default:
      throw new TrackingError(`Unknown mouse event type: ${n.type}`);
  }
}
function calculateElapsedTime(n) {
  return now() - n;
}
function calculateManhattanDistance(n, l) {
  return Math.abs(n.x - l[0]) + Math.abs(n.y - l[1]);
}
const F = class F extends AbstractTracker {
  constructor(t, s) {
    super(TrackType.Network, t);
    d(this, "_options");
    d(this, "_sequentialId", 0);
    d(this, "_vanillaMethods", /* @__PURE__ */ new Map());
    d(this, "_hookedMethods", /* @__PURE__ */ new Map());
    d(this, "_xhrContexts", /* @__PURE__ */ new WeakMap());
    d(this, "_handleXHRSend", (t, s) => {
      if (t) {
        const c = M(v({}, t.request), { body: this._options.captureRequestBody ? this._parseBody(s) : null });
        c.url = this._parseURL(c.url), this.track({
          eventType: TrackerEventType.NETWORK_SEND,
          data: c
        });
      }
    });
    d(this, "_handleXHRAbort", (t) => {
      const s = this._xhrContexts.get(t.target);
      s && (s.eventType = TrackerEventType.NETWORK_ABORT);
    });
    d(this, "_handleXHRError", (t) => {
      const s = this._xhrContexts.get(t.target);
      s && (s.eventType = TrackerEventType.NETWORK_ERROR);
    });
    d(this, "_handleXHRTimeout", (t) => {
      const s = t.target, c = this._xhrContexts.get(s);
      if (c) {
        this._xhrContexts.delete(s);
        const a = v({}, c.response);
        a.url = this._parseURL(a.url), this.track({ eventType: TrackerEventType.NETWORK_TIMEOUT, data: a });
      }
    });
    d(this, "_handleXHRLoad", (t) => {
      const s = this._xhrContexts.get(t.target);
      s && (s.eventType = TrackerEventType.NETWORK_DONE);
    });
    d(this, "_handleXHRLoadEnd", (t) => {
      const s = t.target, c = this._xhrContexts.get(s);
      if (c) {
        this._xhrContexts.delete(s);
        const a = M(v({}, c.response), {
          url: s.responseURL,
          headers: parseHeaders(s.getAllResponseHeaders()),
          status: s.status,
          statusText: s.statusText,
          type: s.responseType
        });
        this._options.captureResponseBody && (a.body = s.responseType === "" || s.responseType === "text" || s.responseType === "json" ? s.response : s.response && s.response.toString()), a.url = this._parseURL(a.url), this.track({ eventType: c.eventType, data: a });
      }
    });
    this._options = v({
      captureResponseBody: !1,
      captureRequestBody: !0,
      captureRequestURLQuery: !0,
      disableDataMasking: !1,
      disableBuiltInDataMasks: !1,
      dataMasks: [],
      maskingLevel: DataMaskingLevel.BALANCE
    }, s);
  }
  activate() {
    super.activate(), this._hookXHR(), this._hookFetch();
  }
  deactivate() {
    super.deactivate(), this._unhookXHR(), this._unhookFetch();
  }
  _hookXHR() {
    const t = this._options.xhr ? this._options.xhr.prototype : XMLHttpRequest ? XMLHttpRequest.prototype : void 0;
    if (t) {
      const s = F.XHR_METHODS.filter((c) => isFunction$1(t[c]));
      for (const c of s)
        this._hookXHRMethod(t, c);
    }
  }
  _unhookXHR() {
    const t = this._options.xhr ? this._options.xhr.prototype : XMLHttpRequest ? XMLHttpRequest.prototype : void 0;
    if (t) {
      const s = F.XHR_METHODS.filter((c) => isFunction$1(t[c]));
      for (const c of s)
        this._unhook(t, c);
      this._xhrContexts = /* @__PURE__ */ new WeakMap();
    }
  }
  _hookXHRMethod(t, s) {
    if (!this._vanillaMethods.has(s)) {
      const c = t[s];
      this._vanillaMethods.set(s, c);
      const a = this;
      t[s] = function(...r) {
        var o, h;
        if (s === F.XHR_OPEN) {
          const b = a._nextId(), [u, Z, p, G, f] = r, R = {
            eventType: TrackerEventType.NETWORK_SEND,
            request: { id: b, type: "xhr", method: u, url: String(Z) },
            response: { id: b }
          };
          p != null && (R.request.async = p), G != null && (R.request.user = G), f != null && (R.request.password = f), a._xhrContexts.set(this, R);
        } else if (s === F.XHR_SEND) {
          const b = a._xhrContexts.get(this);
          b && ((h = (o = a._options).shouldIgnoreRequest) != null && h.call(o, b.request)) ? a._xhrContexts.delete(this) : (this.removeEventListener && (this.removeEventListener("abort", a._handleXHRAbort), this.removeEventListener("error", a._handleXHRError), this.removeEventListener("timeout", a._handleXHRTimeout), this.removeEventListener("load", a._handleXHRLoad), this.removeEventListener("loadend", a._handleXHRLoadEnd)), this.addEventListener("abort", a._handleXHRAbort), this.addEventListener("error", a._handleXHRError), this.addEventListener("timeout", a._handleXHRTimeout), this.addEventListener("load", a._handleXHRLoad), this.addEventListener("loadend", a._handleXHRLoadEnd), a._handleXHRSend(b, r[0]));
        } else if (s === F.XHR_SET_REQUEST_HEADER) {
          const b = a._xhrContexts.get(this);
          if (b) {
            const [u, Z] = r;
            b.request.headers == null && (b.request.headers = {});
            const p = b.request.headers;
            p[u] == null ? p[u] = Z : p[u] = `${p[u]}, ${Z}`;
          }
        }
        c.apply(this, r);
      }, this._hookedMethods.set(s, t[s]);
    }
  }
  _hookFetch() {
    var s;
    const t = (s = this._options.fetchable) != null ? s : window;
    if (caniuse.fetch(t) && !this._vanillaMethods.has(F.FETCH_API)) {
      const c = this, a = t[F.FETCH_API];
      this._vanillaMethods.set(F.FETCH_API, a), t[F.FETCH_API] = function(r, o) {
        var u, Z;
        if (o != null && o[FETCH_FLAG])
          return a.call(this, r, o);
        const h = c._nextId(), b = {
          request: { id: h, type: "fetch", method: "GET", url: "" },
          response: { id: h }
        };
        return isString(r) ? b.request.url = r : isFetchRequest(r) && (c._options.captureRequestBody && (b.request.body = c._parseBody(r.body)), b.request.method = r.method, b.request.url = r.url, b.request.cache = r.cache, b.request.credentials = r.credentials, b.request.headers = parseHeaders(r.headers), b.request.integrity = r.integrity, b.request.keepalive = r.keepalive, b.request.mode = r.mode, b.request.redirect = r.redirect, b.request.referrer = r.referrer, b.request.referrerPolicy = r.referrerPolicy), (Z = (u = c._options).shouldIgnoreRequest) != null && Z.call(u, b.request) ? a.call(this, r, o) : (o != null && (o.body != null && c._options.captureRequestBody && (b.request.body = c._parseBody(o.body)), o.cache != null && (b.request.cache = o.cache), o.credentials != null && (b.request.credentials = o.credentials), o.integrity != null && (b.request.integrity = o.integrity), o.keepalive != null && (b.request.keepalive = o.keepalive), o.method != null && (b.request.method = o.method), o.mode != null && (b.request.mode = o.mode), o.redirect != null && (b.request.redirect = o.redirect), o.referrer != null && (b.request.referrer = o.referrer), o.referrerPolicy != null && (b.request.referrerPolicy = o.referrerPolicy), o.headers != null && (b.request.headers = v(v({}, b.request.headers), parseHeaders(o.headers)))), c._handleFetchEvent(b, TrackerEventType.NETWORK_SEND), a.call(this, r, o).then((p) => V(this, null, function* () {
          return c._handleFetchResponse(b, p), p;
        })).catch((p) => {
          throw c._handleFetchEvent(b, TrackerEventType.NETWORK_ERROR), p;
        }));
      }, t[F.FETCH_API].toString = function() {
        return "function fetch() { [native code] }";
      }, this._hookedMethods.set(F.FETCH_API, t[F.FETCH_API]);
    }
  }
  _unhookFetch() {
    var s;
    const t = (s = this._options.fetchable) != null ? s : window;
    this._unhook(t, F.FETCH_API);
  }
  _unhook(t, s) {
    t && this._vanillaMethods.has(s) && this._hookedMethods.has(s) && t[s] === this._hookedMethods.get(s) && (t[s] = this._vanillaMethods.get(s), this._vanillaMethods.delete(s), this._hookedMethods.delete(s));
  }
  _handleFetchResponse(t, s) {
    return V(this, null, function* () {
      var c, a, r, o;
      if (t.response.ok = s.ok, t.response.url = s.url, t.response.redirected = s.redirected, t.response.status = s.status, t.response.statusText = s.statusText, t.response.type = s.type, t.response.headers = parseHeaders(s.headers), this._options.captureResponseBody)
        try {
          const h = s.clone(), b = (a = (c = s.headers) == null ? void 0 : c.get("Content-Type")) == null ? void 0 : a.toLowerCase();
          let u;
          try {
            if (includes(b, "text/plain"))
              u = yield h.text();
            else if (includes(b, "application/json"))
              u = yield h.json();
            else if (includes(b, "application/octet-stream")) {
              const Z = yield h.arrayBuffer();
              u = new TextDecoder().decode(Z);
            } else
              u = (r = h.body) == null ? void 0 : r.toString();
          } catch (Z) {
            u = (o = h.body) == null ? void 0 : o.toString();
          }
          t.response.body = u;
        } catch (h) {
        }
      this._handleFetchEvent(t, TrackerEventType.NETWORK_DONE);
    });
  }
  _handleFetchEvent(t, s) {
    let c;
    s === TrackerEventType.NETWORK_SEND ? c = v({}, t.request) : c = v({}, t.response), c.url = this._parseURL(c.url), this.track({ eventType: s, data: c });
  }
  _parseURL(t) {
    try {
      if (!this._options.captureRequestURLQuery && isString(t)) {
        const s = new URL(t);
        return s.search = "", s.toString();
      }
    } catch (s) {
    }
    return t != null ? t : "";
  }
  _parseBody(t) {
    return isFormData(t) ? flattenFormData(t) : t instanceof ReadableStream ? "ReadableStream" : t;
  }
  _nextId() {
    return ++this._sequentialId;
  }
};
d(F, "FETCH_API", "fetch"), d(F, "XHR_OPEN", "open"), d(F, "XHR_SEND", "send"), d(F, "XHR_SET_REQUEST_HEADER", "setRequestHeader"), d(F, "XHR_METHODS", [
  F.XHR_OPEN,
  F.XHR_SEND,
  F.XHR_SET_REQUEST_HEADER
]);
let NetworkTracker = F;
const ENTRY_TYPE_LONGTASK = "longtask", ENTRY_TYPE_NAVIGATION = "navigation", ENTRY_TYPE_RESOURCE = "resource";
class PerformanceTracker extends AbstractTracker {
  constructor(t, s) {
    var a;
    super(TrackType.Performance, t);
    d(this, "_performanceObserver");
    d(this, "_config");
    d(this, "_handlePerformance", (t) => {
      this._traceLongTaskEntries(t.getEntriesByType(ENTRY_TYPE_LONGTASK)), this._traceNavigationEntries(t.getEntriesByType(ENTRY_TYPE_NAVIGATION)), this._traceResourceEntries(t.getEntriesByType(ENTRY_TYPE_RESOURCE));
    });
    d(this, "_traceLongTaskEntries", (t) => {
      const s = [];
      for (const c of t) {
        const a = {
          entryType: c.entryType,
          name: c.name,
          startTime: convertDOMHighResTimeStamp2AbsoluteTime(c.startTime),
          duration: roundToTwoDecimals(c.duration)
        };
        this._config.shouldIgnoreTiming(a) || s.push(a);
      }
      s.length > 0 && this.track({ eventType: TrackerEventType.PERFORMANCE_LONG_TASK, data: s });
    });
    d(this, "_traceResourceEntries", (t) => {
      if (t.length > 0) {
        const s = [];
        for (const c of t) {
          const a = this._createResourceTiming(c);
          this._config.shouldIgnoreTiming(a) || s.push(a);
        }
        s.length > 0 && this.track({ eventType: TrackerEventType.PERFORMANCE_RESOURCE, data: s });
      }
    });
    d(this, "_traceNavigationEntries", (t) => {
      if (t.length > 0) {
        const s = [];
        for (const c of t) {
          const a = this._createNavigationTiming(c);
          this._config.shouldIgnoreTiming(a) || s.push(a);
        }
        s.length > 0 && this.track({ eventType: TrackerEventType.PERFORMANCE_NAVIGATION, data: s });
      }
    });
    d(this, "_createResourceTiming", (t) => {
      var c;
      const s = {
        // BaseTiming
        entryType: t.entryType,
        name: t.name,
        startTime: convertDOMHighResTimeStamp2AbsoluteTime(t.startTime),
        duration: roundToTwoDecimals(t.duration),
        // ResourceTiming
        initiatorType: t.initiatorType,
        nextHopProtocol: t.nextHopProtocol,
        serverTiming: ((c = t.serverTiming) != null ? c : []).map((a) => ({
          name: a.name,
          duration: roundToTwoDecimals(a.duration),
          description: a.description
        })),
        // NetworkStats
        stats: { total: roundToTwoDecimals(t.duration) }
      };
      if (t.deliveryType != null && (s.deliveryType = t.deliveryType), t.notRestoredReasons != null && (s.notRestoredReasons = t.notRestoredReasons), t.renderBlockingStatus != null && (s.renderBlockingStatus = t.renderBlockingStatus), t.responseStatus != null && (s.responseStatus = t.responseStatus), isValidNumber(t.redirectStart) && (s.redirectStart = convertDOMHighResTimeStamp2AbsoluteTime(t.redirectStart)), isValidNumber(t.redirectEnd) && (s.redirectEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.redirectEnd)), isValidNumber(t.workerStart) && (s.workerStart = convertDOMHighResTimeStamp2AbsoluteTime(t.workerStart)), isValidNumber(t.fetchStart) && (s.fetchStart = convertDOMHighResTimeStamp2AbsoluteTime(t.fetchStart)), isValidNumber(t.domainLookupStart) && (s.domainLookupStart = convertDOMHighResTimeStamp2AbsoluteTime(t.domainLookupStart)), isValidNumber(t.domainLookupEnd) && (s.domainLookupEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.domainLookupEnd)), isValidNumber(t.connectStart) && (s.connectStart = convertDOMHighResTimeStamp2AbsoluteTime(t.connectStart)), isValidNumber(t.secureConnectionStart) && (s.secureConnectionStart = convertDOMHighResTimeStamp2AbsoluteTime(t.secureConnectionStart)), isValidNumber(t.connectEnd) && (s.connectEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.connectEnd)), isValidNumber(t.requestStart) && (s.requestStart = convertDOMHighResTimeStamp2AbsoluteTime(t.requestStart)), isValidNumber(t.firstInterimResponseStart) && (s.firstInterimResponseStart = convertDOMHighResTimeStamp2AbsoluteTime(t.firstInterimResponseStart)), isValidNumber(t.responseStart) && (s.responseStart = convertDOMHighResTimeStamp2AbsoluteTime(t.responseStart)), isValidNumber(t.responseEnd) && (s.responseEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.responseEnd)), isValidNumber(t.redirectEnd) && isValidNumber(t.redirectStart) && (s.stats.redirect = roundToTwoDecimals(t.redirectEnd - t.redirectStart)), isValidNumber(t.domainLookupStart) && isValidNumber(t.workerStart) && (s.stats.serviceWorker = roundToTwoDecimals(t.domainLookupStart - t.workerStart)), isValidNumber(t.domainLookupEnd) && isValidNumber(t.domainLookupStart) && (s.stats.dns = roundToTwoDecimals(t.domainLookupEnd - t.domainLookupStart)), isValidNumber(t.connectEnd) && isValidNumber(t.connectStart) && (s.stats.tcp = roundToTwoDecimals(t.connectEnd - t.connectStart)), isValidNumber(t.responseEnd) && isValidNumber(t.responseStart) && (s.stats.contentDownload = roundToTwoDecimals(t.responseEnd - t.responseStart)), isValidNumber(t.responseStart) && (s.stats.ttfb = roundToTwoDecimals(t.responseStart - t.startTime)), t.serverTiming != null && t.serverTiming.length > 0) {
        const a = Math.max(...t.serverTiming.map((r) => r.duration));
        s.stats.server = roundToTwoDecimals(a), isValidNumber(t.responseStart) && (s.stats.client = roundToTwoDecimals(t.responseStart - t.startTime - a));
      }
      return s;
    });
    d(this, "_createNavigationTiming", (t) => {
      const s = M(v({}, this._createResourceTiming(t)), {
        entryType: t.entryType,
        // NavigationTiming
        type: t.type,
        redirectCount: t.redirectCount
      });
      return isValidNumber(t.unloadEventStart) && (s.unloadEventStart = convertDOMHighResTimeStamp2AbsoluteTime(t.unloadEventStart)), isValidNumber(t.unloadEventEnd) && (s.unloadEventEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.unloadEventEnd)), isValidNumber(t.domInteractive) && (s.domInteractive = convertDOMHighResTimeStamp2AbsoluteTime(t.domInteractive)), isValidNumber(t.domContentLoadedEventStart) && (s.domContentLoadedEventStart = convertDOMHighResTimeStamp2AbsoluteTime(t.domContentLoadedEventStart)), isValidNumber(t.domContentLoadedEventEnd) && (s.domContentLoadedEventEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.domContentLoadedEventEnd)), isValidNumber(t.domComplete) && (s.domComplete = convertDOMHighResTimeStamp2AbsoluteTime(t.domComplete)), isValidNumber(t.loadEventStart) && (s.loadEventStart = convertDOMHighResTimeStamp2AbsoluteTime(t.loadEventStart)), isValidNumber(t.loadEventEnd) && (s.loadEventEnd = convertDOMHighResTimeStamp2AbsoluteTime(t.loadEventEnd)), isValidNumber(t.unloadEventEnd) && isValidNumber(t.unloadEventStart) && (s.stats.unload = roundToTwoDecimals(t.unloadEventEnd - t.unloadEventStart)), isValidNumber(t.domComplete) && isValidNumber(t.domInteractive) && (s.stats.domProcessing = roundToTwoDecimals(t.domComplete - t.domInteractive)), isValidNumber(t.loadEventEnd) && isValidNumber(t.loadEventStart) && (s.stats.load = roundToTwoDecimals(t.loadEventEnd - t.loadEventStart)), s;
    });
    const c = s == null ? void 0 : s.buffered;
    this._config = {
      buffered: c === !0 || c === !1 ? { navigation: c, resource: c } : v({ navigation: !0, resource: !1 }, c),
      shouldIgnoreTiming: (a = s == null ? void 0 : s.shouldIgnoreTiming) != null ? a : defaultShouldIgnoreTiming
    };
  }
  activate() {
    super.activate(), caniuse.performanceObserver() && (this._performanceObserver = new PerformanceObserver(this._handlePerformance), this._performanceObserver.observe({ type: ENTRY_TYPE_LONGTASK }), this._performanceObserver.observe({ type: ENTRY_TYPE_NAVIGATION, buffered: this._config.buffered.navigation }), this._performanceObserver.observe({ type: ENTRY_TYPE_RESOURCE, buffered: this._config.buffered.resource }));
  }
  deactivate() {
    var t;
    super.deactivate(), (t = this._performanceObserver) == null || t.disconnect(), this._performanceObserver = void 0;
  }
}
function defaultShouldIgnoreTiming() {
  return !1;
}
function isValidNumber(n) {
  return n != null && n > 0;
}
function roundToTwoDecimals(n) {
  return Math.round(n * 100) / 100;
}
class TrackerContext {
  constructor() {
    d(this, "_snapshotCapturer", null);
  }
  get snapshotCapturer() {
    return this._snapshotCapturer;
  }
  set snapshotCapturer(l) {
    this._snapshotCapturer = l;
  }
  getNodeId(l) {
    var t;
    return (t = this.snapshotCapturer) == null ? void 0 : t.getNodeId(l);
  }
}
function normalizeTrackType(n) {
  return isString(n) ? TrackType[n] : n;
}
function normalizeTrackTypes(n) {
  const l = n == null ? void 0 : n.map((t) => normalizeTrackType(t)).filter((t) => !!t);
  return l && l.length > 0 ? l : [TrackType.HTML, TrackType.Mouse];
}
function serialize(n) {
  var s, c, a, r, o, h, b, u;
  const l = clone(n), t = {};
  return typeof ((c = (s = l.html) == null ? void 0 : s.image) == null ? void 0 : c.captureAttributes) == "function" && (t["options.html.image.captureAttributes"] = String(l.html.image.captureAttributes), (r = (a = l.html) == null ? void 0 : a.image) == null || delete r.captureAttributes), (o = l.network) != null && o.xhr && delete l.network.xhr, (h = l.network) != null && h.fetchable && delete l.network.fetchable, (b = l.network) != null && b.shouldIgnoreRequest && delete l.network.shouldIgnoreRequest, (u = l.performance) != null && u.shouldIgnoreTiming && delete l.performance.shouldIgnoreTiming, l.worker && delete l.worker, M(v({}, l), { fns: t });
}
function deserialize(n) {
  return v({}, n);
}
function clone(n) {
  if (isPlainObject(n)) {
    const l = {};
    for (const t of Object.keys(n))
      l[t] = clone(n[t]);
    return l;
  }
  return n;
}
class AbstractRecorder extends EventEmitter {
  constructor(t, s) {
    super();
    d(this, "context", new TrackerContext());
    d(this, "trackers", []);
    d(this, "options");
    d(this, "_trackTypes");
    d(this, "_recordingManager", null);
    d(this, "_trackerSource", null);
    d(this, "_initialHandler");
    d(this, "_initialTasks", []);
    d(this, "_watchRecordingStop", (t) => V(this, null, function* () {
      var c;
      (c = bridge.global) == null || c.stopRecording(t), (yield this.recordingManager.getCurrentRecordingCount()) === 0 && this._stopTracking(), this.emit("stopRecording", t);
    }));
    d(this, "_watchRecordingDump", (t) => V(this, null, function* () {
      var s;
      (s = bridge.global) == null || s.dumpRecording(t), this.emit("dumpRecording", t);
    }));
    d(this, "_watchRecordingFrame", (t) => {
      this.emit("frame", t);
    });
    d(this, "_handleBeforeUnload", () => V(this, null, function* () {
      this.options.cache && (yield this.isRecording()) && this.recordingManager.cacheRecordings();
    }));
    this.mode = t;
    const c = normalizeTrackTypes(s == null ? void 0 : s.trackers);
    this.options = M(v({}, s), { trackers: c }), this._trackTypes = c;
  }
  static get version() {
    return version;
  }
  get recordingManager() {
    return this._recordingManager == null && (this._recordingManager = this.createRecordingManager()), this._recordingManager;
  }
  get trackerSource() {
    return this._trackerSource;
  }
  addInitialTask(t) {
    this._initialTasks.push(t);
  }
  getManager() {
    return this._recordingManager;
  }
  getTracker(t) {
    let s;
    isString(t) ? s = TrackType[t] : s = t;
    const c = this.trackers.find((a) => a.trackType === s);
    if (!c)
      throw new Error("Unknown track type or not enabled");
    return c;
  }
  registerTracker(t) {
    const s = Reflect.construct(t, [this.context]);
    if (s.trackType <= 1e3)
      throw new Error("Custom tracker type must be greater than 1000");
    this.trackers.push(s), this._trackTypes.push(s.trackType);
  }
  startRecording(t) {
    return V(this, null, function* () {
      var c, a;
      yield this._initialize();
      const s = yield this.recordingManager.createRecordingContext(v({
        clientTime: (/* @__PURE__ */ new Date()).toISOString(),
        startTime: now(),
        environment: this.getEnvironment(),
        mode: RecordingMode.Streaming,
        trackers: this._trackTypes
      }, t));
      return ((c = this.options.html) != null && c.iframe || t.refType === "iframe") && (bridge.global && bridge.global.setRecorder(this), (a = bridge.global) == null || a.startRecording(t, s.recording)), this._startTracking(), this.emit("startRecording", s.recording), s;
    });
  }
  getEnvironment() {
    return getEnvironmentMeta();
  }
  /**
   * @deprecated use the method `dumpRecording` on `RecordingContext`
   */
  dumpRecording(t, s) {
    return V(this, null, function* () {
      return yield this.recordingManager.dumpRecording(t, s);
    });
  }
  stopRecording(t) {
    return V(this, null, function* () {
      yield this.recordingManager.stopRecordingContext(t);
    });
  }
  isRecording() {
    return V(this, null, function* () {
      return (yield this.recordingManager.getCurrentRecordingCount()) > 0;
    });
  }
  _initialize() {
    return this._initialHandler || (this._initialHandler = Promise.all([
      new Promise((t) => {
        this._initTrackers(), this.onInit(), this._trackerSource = merge(...this.trackers.map((s) => s.output)), t();
      }),
      this._waitUntilPageLoaded(),
      ...this._initialTasks
    ])), this._initialHandler;
  }
  _waitUntilPageLoaded() {
    return !document || document.readyState === "complete" ? Promise.resolve() : new Promise((t) => {
      document.addEventListener("readystatechange", () => {
        if (document.readyState === "complete")
          return t();
      });
    });
  }
  _initTrackers() {
    if (includes(this._trackTypes, TrackType.HTML)) {
      const t = new HTMLTracker(this.context, this.options.html);
      this.context.snapshotCapturer = t.snapshotCapturer, this.trackers.push(t);
    }
    if (includes(this._trackTypes, TrackType.Mouse)) {
      const t = new MouseTracker(this.context, this.options.mouse);
      this.trackers.push(t);
    }
    if (includes(this._trackTypes, TrackType.Keyboard)) {
      const t = new KeyboardTracker(this.context);
      this.trackers.push(t);
    }
    if (includes(this._trackTypes, TrackType.Console)) {
      const t = new ConsoleTracker(this.context, this.options.console);
      this.trackers.push(t);
    }
    if (includes(this._trackTypes, TrackType.Error)) {
      const t = new ErrorTracker(this.context);
      this.trackers.push(t);
    }
    if (includes(this._trackTypes, TrackType.Network)) {
      const t = new NetworkTracker(this.context, this.options.network);
      this.trackers.push(t);
    }
    if (includes(this._trackTypes, TrackType.Performance)) {
      const t = new PerformanceTracker(this.context, this.options.performance);
      this.trackers.push(t);
    }
  }
  onInit() {
  }
  _startTracking() {
    this._subscribeRawEvents();
    for (const t of this.trackers)
      t.isActive || t.activate();
    this._resumeRecordings();
  }
  _stopTracking() {
    this._unsubscribeRawEvents();
    for (const t of this.trackers)
      t.deactivate();
  }
  _subscribeRawEvents() {
    window.addEventListener("beforeunload", this._handleBeforeUnload, !0);
  }
  _unsubscribeRawEvents() {
    window.removeEventListener("beforeunload", this._handleBeforeUnload, !0);
  }
  _resumeRecordings() {
    this.options.autoUploadingCache && setTimeout(() => {
      this.recordingManager.uploadRecordingCaches();
    }, 1e3);
  }
}
class RecordingContext {
  constructor(l, t, s) {
    d(this, "manager");
    d(this, "_id");
    d(this, "_recording");
    d(this, "_startTime");
    d(this, "_offsetTime");
    d(this, "_trackers");
    d(this, "_transmitter");
    d(this, "_events", new EventEmitter());
    var a, r;
    this.options = s, this.manager = l, this._recording = t, this._id = t.id, this._startTime = (a = s.startTime) != null ? a : now(), this._trackers = s.trackers, this._offsetTime = this.getOffsetTime(this._startTime);
    const c = (r = s.transport) == null ? void 0 : r.strategies.find((o) => o.mode === s.mode && "channelType" in o);
    this._transmitter = { strategy: c };
  }
  /**
   * Gets the context id.
   */
  get id() {
    return this._id;
  }
  get recording() {
    return this._recording;
  }
  get baseURL() {
    return this.manager.env.baseURL;
  }
  get env() {
    return this.manager.env;
  }
  /**
   * A relative time of when the recording started/created.
   * This is useful as a reference value when calculating relative time.
   *
   * @remarks
   * `startTime` is in high resolution time.
   */
  get startTime() {
    return this._startTime;
  }
  /**
   * A offset duration of the recording started and right now in the web worker.
   */
  get offsetTime() {
    return this._offsetTime;
  }
  /**
   * A relative time of now which added the offset time.
   */
  get now() {
    return now() + this._offsetTime;
  }
  get transmitter() {
    return this._transmitter;
  }
  get trackers() {
    return this._trackers;
  }
  dumpRecording(l) {
    return this.manager.dumpRecording(this._id, l);
  }
  /**
   * Caches current recordings to offline storage.
   */
  cacheRecordings() {
    return this.manager.cacheRecordings();
  }
  stopRecording() {
    return this.manager.stopRecordingContext(this._id);
  }
  toString() {
    return JSON.stringify(this._recording);
  }
  emit(l, ...t) {
    return this._events.emit(l, ...t);
  }
  on(l, t) {
    this._events.on(l, t, {});
  }
  once(l, t) {
    this._events.once(l, t, {});
  }
  off(l, t) {
    this._events.off(l, t, {});
  }
  addListener(l, t) {
    this._events.addListener(l, t, {});
  }
  removeListener(l, t) {
    this._events.removeListener(l, t, {});
  }
  getOffsetTime(l) {
    return l - now();
  }
}
class BlackboxRecordingContext extends RecordingContext {
  constructor(t, s, c) {
    var r;
    super(t, s, c);
    d(this, "_dumpConfig");
    const a = (r = c.transport) == null ? void 0 : r.strategies.find((o) => o.name === "blackbox-record-dump");
    a ? this._dumpConfig = a == null ? void 0 : a.config : this._dumpConfig = { id: generateUUID$1(), token: c.token };
  }
  get dumpConfig() {
    return this._dumpConfig;
  }
  set dumpConfig(t) {
    this._dumpConfig = t;
  }
  dumpRecording(t) {
    return V(this, null, function* () {
      const s = yield Xe(BlackboxRecordingContext.prototype, this, "dumpRecording").call(this, t);
      return this.emit("dumped", s.id, this.dumpConfig), s.id;
    });
  }
  getDumpConfig() {
    return V(this, null, function* () {
      return Promise.resolve(this.dumpConfig);
    });
  }
}
var TransferPosition = /* @__PURE__ */ ((n) => (n.Worker = "worker", n.Main = "main", n))(TransferPosition || {});
class RecordingContextTransferHandler {
  constructor(l) {
    this.position = l;
  }
  /**
   * 判断改对象是否为 {@link RecordingContext}
   * @param obj
   * @returns
   */
  canHandle(l) {
    return l instanceof RecordingContext;
  }
  /**
   * 序列化 {@link RecordingContext}，这里借助了 Comlink.{@link expose} 的能力，通过 `postMessage` 来实现远程访问。
   *
   * @param rc
   * @returns
   *
   * @remark
   * 此方法目前只会在 worker 中被调用。在建立 `MessageChannel` 时还会把静态数据和支持调用的方法名传到主线程。
   */
  serialize(l) {
    const { port1: t, port2: s } = new MessageChannel();
    if (l instanceof RecordingContext) {
      const c = {
        id: l.id,
        startTime: l.startTime,
        recording: l.recording,
        transmitter: l.transmitter,
        baseURL: l.baseURL,
        trackers: l.trackers
      };
      l instanceof BlackboxRecordingContext && (c.dumpConfig = l.dumpConfig), t.postMessage({
        type: "RecordingContextManifest",
        value: {
          id: generateUUID$1(),
          staticProperties: c,
          exposeMethods: [
            "on",
            "once",
            "off",
            "stopRecording",
            "cacheRecordings",
            "dumpRecording",
            "getDumpConfig",
            "addListener",
            "removeListener"
          ]
        }
      });
    }
    return expose(l, t), [s, [s]];
  }
  /**
   * 反序列化 {@link RecordingContext}，这里借助了 Comlink.{@link wrap} 方法，包装一个 `Proxy` 对象给主线程访问。
   * @param port
   * @returns
   *
   * @remark
   * 此方法目前只会在主线程中被调用。在建立 `MessageChannel` 时，会先等待 `RecordingContextManifest` 的到达，然后才返回 Proxy 对象。
   * 同时做了二次 Proxy 实现以下能力：
   *  1. 对于访问静态属性，直接返回
   *  2. 调用方式时，如果有参数是一个函数，则使用 Comlink.{@link proxy} 处理
   *  3. 监听 RecordingContext stopped 事件，释放所有 Proxy
   */
  deserialize(l) {
    let t;
    const s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), r = wrap(l), o = new Proxy(r, {
      get(b, u, Z) {
        const p = u;
        if (!t)
          throw new Error("RecordingContext manifest not found from worker");
        if (s.has(p))
          return t.staticProperties[p];
        if (p === "toString")
          return () => JSON.stringify(t == null ? void 0 : t.staticProperties.recording);
        const G = Reflect.get(b, u, Z);
        if (c.has(p))
          return (...f) => {
            const R = f.map((S) => {
              if (typeof S == "function") {
                const g = proxy(S);
                return a.add(g), g;
              }
              return S;
            });
            return Reflect.apply(G, b, [...R]);
          };
        if (u === "then" || u === releaseProxy)
          return G;
      }
    });
    return new Promise((b) => {
      const u = (Z) => {
        typeof Z.data == "object" && Z.data.type === "RecordingContextManifest" && (t = Z.data.value, Object.keys(t.staticProperties).forEach((p) => {
          s.add(p);
        }), t.exposeMethods.forEach((p) => {
          c.add(p);
        }), b(), l.removeEventListener("message", u));
      };
      l.addEventListener("message", u, !0), l.start();
    }).then(() => (o.once("stopped", () => {
      try {
        r[releaseProxy](), a.forEach((b) => {
          typeof b[releaseProxy] == "function" && b[releaseProxy]();
        }), a.clear(), c.clear();
      } catch (b) {
        console.error(b);
      }
    }), o));
  }
}
transferHandlers.set("RecordingContext", new RecordingContextTransferHandler(TransferPosition.Main));
function createRecordingManagerFromWorker(n) {
  return wrap(n);
}
var RecorderMode = /* @__PURE__ */ ((n) => (n.Standard = "standard", n.Multithreaded = "multithreaded", n))(RecorderMode || {});
const encodedJs = "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", blob = typeof window != "undefined" && window.Blob && new Blob([atob(encodedJs)], { type: "text/javascript;charset=utf-8" });
function WorkerWrapper() {
  let n;
  try {
    if (n = blob && (window.URL || window.webkitURL).createObjectURL(blob), !n)
      throw "";
    return new Worker(n);
  } catch (l) {
    return new Worker("data:application/javascript;base64," + encodedJs);
  } finally {
    n && (window.URL || window.webkitURL).revokeObjectURL(n);
  }
}
class MultithreadedRecorder extends AbstractRecorder {
  constructor(t) {
    super(RecorderMode.Multithreaded, t);
    d(this, "_workerProvider");
    d(this, "_worker");
    this._verifyOptions(t), this._workerProvider = t == null ? void 0 : t.worker;
  }
  get worker() {
    const t = this._workerProvider || WorkerWrapper;
    return this._worker == null && (typeof t == "string" ? this._worker = new Worker(t, {
      type: "module"
    }) : typeof t == "function" ? this._worker = new t() : this._worker = t), this._worker;
  }
  onInit() {
  }
  createRecordingManager() {
    const t = createRecordingManagerFromWorker(this.worker), s = new Environment(this.options.environment);
    return this.addInitialTask(
      new Promise((c) => {
        if (this.trackerSource) {
          const a = new WorkerBridgeFlow(this.worker);
          this.trackerSource.pipe(a.asPipeable());
        } else
          throw new RecordingError("Trackers must be initialized before creating recording manager.");
        c();
      })
    ), this.addInitialTask(
      t.syncOptions(serialize(M(v({}, this.options), { environment: s.toOptions() })), { mainTime: now() })
    ), t.on("stopRecording", proxy(this._watchRecordingStop)), t.on("dumpRecording", proxy(this._watchRecordingDump)), t.on("frame", proxy(this._watchRecordingFrame)), t;
  }
  /**
   * Verify and convert options for multithread safety.
   */
  _verifyOptions(t) {
    var s, c, a, r;
    if ((c = (s = t == null ? void 0 : t.html) == null ? void 0 : s.dataMasks) != null && c.length || (r = (a = t == null ? void 0 : t.network) == null ? void 0 : a.dataMasks) != null && r.length)
      throw console.log(
        "🎥 ByteReplay: %cPlease note that custom DataMasks are not supported in multithreaded mode yet.",
        "font-weight:bold;color:#446EEA"
      ), new RecordingError("Custom DataMasks are not supported in multithreaded mode.");
    this.options.interceptRequest && (this.options.interceptRequest = String(this.options.interceptRequest));
  }
}
class InMemoryRecordingContext extends RecordingContext {
  dumpRecording() {
    return super.dumpRecording();
  }
}
function createRecording(n, l) {
  const { id: t, token: s, mode: c, clientTime: a, meta: r, environment: o, parent: h, refType: b, trackers: u } = l;
  return n.post(
    `recording/${t != null ? t : generateUUID$1()}/create`,
    { mode: c, clientTime: a, meta: r, environment: o, parent: h, refType: b, trackers: u },
    s ? { Authorization: s } : void 0
  );
}
function createBlock(n, l) {
  return V(this, null, function* () {
    const { token: t, recordingId: s, blob: c, offset: a, count: r, firstFrameTime: o, lastFrameTime: h } = l, b = createFormData();
    b.append("block", c), b.append("offset", `${a}`), b.append("count", `${r}`), b.append("firstFrameTime", `${o}`), b.append("lastFrameTime", `${h}`);
    const u = {};
    return t && (u.Authorization = t), n.post(`storage/${s}/block`, b, u);
  });
}
const BR_RECORDING_DUPLICATED = "BR_RECORDING_DUPLICATED";
function encode(n, l) {
  const t = n.map(
    (a) => (
      // if (frame.event.eventType === TrackerEventType.HTMLSnapshot) {
      //   const snapshot = frame.event.data;
      //   if (!this._firstSnapshot) {
      //     this._firstSnapshot = snapshot;
      //   } else {
      //     console.time('📸');
      //     const patch = jsonDiff(this._firstSnapshot, snapshot);
      //     console.timeEnd('📸');
      //     console.info('patch', Math.round(JSON.stringify(patch).length / 1024) + 'Kb', patch);
      //   }
      // }
      JSON.stringify([a.time - l, a.trackType, a.event.eventType, a.event.data])
    )
  );
  t.push("");
  const s = t.join(`
`);
  return new TextEncoder().encode(s);
}
class DefaultEncoder {
  constructor(l) {
    this.context = l;
  }
  encode(l) {
    return encode(l, this.context.startTime);
  }
}
var SignalType = /* @__PURE__ */ ((n) => (n.CompensateSnapshot = "CompensateSnapshot", n.BlockCreated = "BlockCreated", n.FrameIndex = "FrameIndex", n))(SignalType || {}), u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array, fleb = new u8([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), fdeb = new u8([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), freb = function(n, l) {
  for (var t = new u16(31), s = 0; s < 31; ++s)
    t[s] = l += 1 << n[s - 1];
  for (var c = new i32(t[30]), s = 1; s < 30; ++s)
    for (var a = t[s]; a < t[s + 1]; ++a)
      c[a] = a - t[s] << 5 | s;
  return { b: t, r: c };
}, _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), revfd = _b.r, rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
  var x = (i & 43690) >> 1 | (i & 21845) << 1;
  x = (x & 52428) >> 2 | (x & 13107) << 2, x = (x & 61680) >> 4 | (x & 3855) << 4, rev[i] = ((x & 65280) >> 8 | (x & 255) << 8) >> 1;
}
var hMap = function(n, l, t) {
  for (var s = n.length, c = 0, a = new u16(l); c < s; ++c)
    n[c] && ++a[n[c] - 1];
  var r = new u16(l);
  for (c = 1; c < l; ++c)
    r[c] = r[c - 1] + a[c - 1] << 1;
  var o;
  if (t) {
    o = new u16(1 << l);
    var h = 15 - l;
    for (c = 0; c < s; ++c)
      if (n[c])
        for (var b = c << 4 | n[c], u = l - n[c], Z = r[n[c] - 1]++ << u, p = Z | (1 << u) - 1; Z <= p; ++Z)
          o[rev[Z] >> h] = b;
  } else
    for (o = new u16(s), c = 0; c < s; ++c)
      n[c] && (o[c] = rev[r[n[c] - 1]++] >> 15 - n[c]);
  return o;
}, flt = new u8(288);
for (var i = 0; i < 144; ++i)
  flt[i] = 8;
for (var i = 144; i < 256; ++i)
  flt[i] = 9;
for (var i = 256; i < 280; ++i)
  flt[i] = 7;
for (var i = 280; i < 288; ++i)
  flt[i] = 8;
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
  fdt[i] = 5;
var flm = /* @__PURE__ */ hMap(flt, 9, 0), fdm = /* @__PURE__ */ hMap(fdt, 5, 0), shft = function(n) {
  return (n + 7) / 8 | 0;
}, slc = function(n, l, t) {
  return (l == null || l < 0) && (l = 0), (t == null || t > n.length) && (t = n.length), new u8(n.subarray(l, t));
}, wbits = function(n, l, t) {
  t <<= l & 7;
  var s = l / 8 | 0;
  n[s] |= t, n[s + 1] |= t >> 8;
}, wbits16 = function(n, l, t) {
  t <<= l & 7;
  var s = l / 8 | 0;
  n[s] |= t, n[s + 1] |= t >> 8, n[s + 2] |= t >> 16;
}, hTree = function(n, l) {
  for (var t = [], s = 0; s < n.length; ++s)
    n[s] && t.push({ s, f: n[s] });
  var c = t.length, a = t.slice();
  if (!c)
    return { t: et, l: 0 };
  if (c == 1) {
    var r = new u8(t[0].s + 1);
    return r[t[0].s] = 1, { t: r, l: 1 };
  }
  t.sort(function(L, P) {
    return L.f - P.f;
  }), t.push({ s: -1, f: 25001 });
  var o = t[0], h = t[1], b = 0, u = 1, Z = 2;
  for (t[0] = { s: -1, f: o.f + h.f, l: o, r: h }; u != c - 1; )
    o = t[t[b].f < t[Z].f ? b++ : Z++], h = t[b != u && t[b].f < t[Z].f ? b++ : Z++], t[u++] = { s: -1, f: o.f + h.f, l: o, r: h };
  for (var p = a[0].s, s = 1; s < c; ++s)
    a[s].s > p && (p = a[s].s);
  var G = new u16(p + 1), f = ln(t[u - 1], G, 0);
  if (f > l) {
    var s = 0, R = 0, Y = f - l, S = 1 << Y;
    for (a.sort(function(P, C) {
      return G[C.s] - G[P.s] || P.f - C.f;
    }); s < c; ++s) {
      var g = a[s].s;
      if (G[g] > l)
        R += S - (1 << f - G[g]), G[g] = l;
      else
        break;
    }
    for (R >>= Y; R > 0; ) {
      var J = a[s].s;
      G[J] < l ? R -= 1 << l - G[J]++ - 1 : ++s;
    }
    for (; s >= 0 && R; --s) {
      var U = a[s].s;
      G[U] == l && (--G[U], ++R);
    }
    f = l;
  }
  return { t: new u8(G), l: f };
}, ln = function(n, l, t) {
  return n.s == -1 ? Math.max(ln(n.l, l, t + 1), ln(n.r, l, t + 1)) : l[n.s] = t;
}, lc = function(n) {
  for (var l = n.length; l && !n[--l]; )
    ;
  for (var t = new u16(++l), s = 0, c = n[0], a = 1, r = function(h) {
    t[s++] = h;
  }, o = 1; o <= l; ++o)
    if (n[o] == c && o != l)
      ++a;
    else {
      if (!c && a > 2) {
        for (; a > 138; a -= 138)
          r(32754);
        a > 2 && (r(a > 10 ? a - 11 << 5 | 28690 : a - 3 << 5 | 12305), a = 0);
      } else if (a > 3) {
        for (r(c), --a; a > 6; a -= 6)
          r(8304);
        a > 2 && (r(a - 3 << 5 | 8208), a = 0);
      }
      for (; a--; )
        r(c);
      a = 1, c = n[o];
    }
  return { c: t.subarray(0, s), n: l };
}, clen = function(n, l) {
  for (var t = 0, s = 0; s < l.length; ++s)
    t += n[s] * l[s];
  return t;
}, wfblk = function(n, l, t) {
  var s = t.length, c = shft(l + 2);
  n[c] = s & 255, n[c + 1] = s >> 8, n[c + 2] = n[c] ^ 255, n[c + 3] = n[c + 1] ^ 255;
  for (var a = 0; a < s; ++a)
    n[c + a + 4] = t[a];
  return (c + 4 + s) * 8;
}, wblk = function(n, l, t, s, c, a, r, o, h, b, u) {
  wbits(l, u++, t), ++c[256];
  for (var Z = hTree(c, 15), p = Z.t, G = Z.l, f = hTree(a, 15), R = f.t, Y = f.l, S = lc(p), g = S.c, J = S.n, U = lc(R), L = U.c, P = U.n, C = new u16(19), I = 0; I < g.length; ++I)
    ++C[g[I] & 31];
  for (var I = 0; I < L.length; ++I)
    ++C[L[I] & 31];
  for (var N = hTree(C, 7), z = N.t, k = N.l, _ = 19; _ > 4 && !z[clim[_ - 1]]; --_)
    ;
  var q = b + 5 << 3, D = clen(c, flt) + clen(a, fdt) + r, A = clen(c, p) + clen(a, R) + r + 14 + 3 * _ + clen(C, z) + 2 * C[16] + 3 * C[17] + 7 * C[18];
  if (h >= 0 && q <= D && q <= A)
    return wfblk(l, u, n.subarray(h, h + b));
  var w, H, Q, E;
  if (wbits(l, u, 1 + (A < D)), u += 2, A < D) {
    w = hMap(p, G, 0), H = p, Q = hMap(R, Y, 0), E = R;
    var ee = hMap(z, k, 0);
    wbits(l, u, J - 257), wbits(l, u + 5, P - 1), wbits(l, u + 10, _ - 4), u += 14;
    for (var I = 0; I < _; ++I)
      wbits(l, u + 3 * I, z[clim[I]]);
    u += 3 * _;
    for (var m = [g, L], X = 0; X < 2; ++X)
      for (var y = m[X], I = 0; I < y.length; ++I) {
        var W = y[I] & 31;
        wbits(l, u, ee[W]), u += z[W], W > 15 && (wbits(l, u, y[I] >> 5 & 127), u += y[I] >> 12);
      }
  } else
    w = flm, H = flt, Q = fdm, E = fdt;
  for (var I = 0; I < o; ++I) {
    var T = s[I];
    if (T > 255) {
      var W = T >> 18 & 31;
      wbits16(l, u, w[W + 257]), u += H[W + 257], W > 7 && (wbits(l, u, T >> 23 & 31), u += fleb[W]);
      var K = T & 31;
      wbits16(l, u, Q[K]), u += E[K], K > 3 && (wbits16(l, u, T >> 5 & 8191), u += fdeb[K]);
    } else
      wbits16(l, u, w[T]), u += H[T];
  }
  return wbits16(l, u, w[256]), u + H[256];
}, deo = /* @__PURE__ */ new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), et = /* @__PURE__ */ new u8(0), dflt = function(n, l, t, s, c, a) {
  var r = a.z || n.length, o = new u8(s + r + 5 * (1 + Math.ceil(r / 7e3)) + c), h = o.subarray(s, o.length - c), b = a.l, u = (a.r || 0) & 7;
  if (l) {
    u && (h[0] = a.r >> 3);
    for (var Z = deo[l - 1], p = Z >> 13, G = Z & 8191, f = (1 << t) - 1, R = a.p || new u16(32768), Y = a.h || new u16(f + 1), S = Math.ceil(t / 3), g = 2 * S, J = function(oe) {
      return (n[oe] ^ n[oe + 1] << S ^ n[oe + 2] << g) & f;
    }, U = new i32(25e3), L = new u16(288), P = new u16(32), C = 0, I = 0, N = a.i || 0, z = 0, k = a.w || 0, _ = 0; N + 2 < r; ++N) {
      var q = J(N), D = N & 32767, A = Y[q];
      if (R[D] = A, Y[q] = D, k <= N) {
        var w = r - N;
        if ((C > 7e3 || z > 24576) && (w > 423 || !b)) {
          u = wblk(n, h, 0, U, L, P, I, z, _, N - _, u), z = C = I = 0, _ = N;
          for (var H = 0; H < 286; ++H)
            L[H] = 0;
          for (var H = 0; H < 30; ++H)
            P[H] = 0;
        }
        var Q = 2, E = 0, ee = G, m = D - A & 32767;
        if (w > 2 && q == J(N - m))
          for (var X = Math.min(p, w) - 1, y = Math.min(32767, N), W = Math.min(258, w); m <= y && --ee && D != A; ) {
            if (n[N + Q] == n[N + Q - m]) {
              for (var T = 0; T < W && n[N + T] == n[N + T - m]; ++T)
                ;
              if (T > Q) {
                if (Q = T, E = m, T > X)
                  break;
                for (var K = Math.min(m, T - 2), j = 0, H = 0; H < K; ++H) {
                  var O = N - m + H & 32767, Ge = R[O], be = O - Ge & 32767;
                  be > j && (j = be, A = O);
                }
              }
            }
            D = A, A = R[D], m += D - A & 32767;
          }
        if (E) {
          U[z++] = 268435456 | revfl[Q] << 18 | revfd[E];
          var ue = revfl[Q] & 31, me = revfd[E] & 31;
          I += fleb[ue] + fdeb[me], ++L[257 + ue], ++P[me], k = N + Q, ++C;
        } else
          U[z++] = n[N], ++L[n[N]];
      }
    }
    for (N = Math.max(N, k); N < r; ++N)
      U[z++] = n[N], ++L[n[N]];
    u = wblk(n, h, b, U, L, P, I, z, _, N - _, u), b || (a.r = u & 7 | h[u / 8 | 0] << 3, u -= 7, a.h = Y, a.p = R, a.i = N, a.w = k);
  } else {
    for (var N = a.w || 0; N < r + b; N += 65535) {
      var re = N + 65535;
      re >= r && (h[u / 8 | 0] = b, re = r), u = wfblk(h, u + 1, n.subarray(N, re));
    }
    a.i = r;
  }
  return slc(o, 0, s + shft(u) + c);
}, crct = /* @__PURE__ */ function() {
  for (var n = new Int32Array(256), l = 0; l < 256; ++l) {
    for (var t = l, s = 9; --s; )
      t = (t & 1 && -306674912) ^ t >>> 1;
    n[l] = t;
  }
  return n;
}(), crc = function() {
  var n = -1;
  return {
    p: function(l) {
      for (var t = n, s = 0; s < l.length; ++s)
        t = crct[t & 255 ^ l[s]] ^ t >>> 8;
      n = t;
    },
    d: function() {
      return ~n;
    }
  };
}, dopt = function(n, l, t, s, c) {
  if (!c && (c = { l: 1 }, l.dictionary)) {
    var a = l.dictionary.subarray(-32768), r = new u8(a.length + n.length);
    r.set(a), r.set(n, a.length), n = r, c.w = a.length;
  }
  return dflt(n, l.level == null ? 6 : l.level, l.mem == null ? c.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(n.length))) * 1.5) : 20 : 12 + l.mem, t, s, c);
}, wbytes = function(n, l, t) {
  for (; t; ++l)
    n[l] = t, t >>>= 8;
}, gzh = function(n, l) {
  var t = l.filename;
  if (n[0] = 31, n[1] = 139, n[2] = 8, n[8] = l.level < 2 ? 4 : l.level == 9 ? 2 : 0, n[9] = 3, l.mtime != 0 && wbytes(n, 4, Math.floor(new Date(l.mtime || Date.now()) / 1e3)), t) {
    n[3] = 8;
    for (var s = 0; s <= t.length; ++s)
      n[s + 10] = t.charCodeAt(s);
  }
}, gzhl = function(n) {
  return 10 + (n.filename ? n.filename.length + 1 : 0);
};
function gzipSync(n, l) {
  l || (l = {});
  var t = crc(), s = n.length;
  t.p(n);
  var c = dopt(n, l, gzhl(l), 8), a = c.length;
  return gzh(c, l), wbytes(c, a - 8, t.d()), wbytes(c, a - 4, s), c;
}
var td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder(), tds = 0;
try {
  td.decode(et, { stream: !0 }), tds = 1;
} catch (n) {
}
function gzip(n) {
  return V(this, null, function* () {
    if (caniuse.compressionStream())
      try {
        const l = createReadableStreamFromUint8Array(n), t = new globalThis.CompressionStream("gzip"), s = l.pipeThrough(t);
        return yield readAllFromStream(s);
      } catch (l) {
      }
    return gzipSync(n);
  });
}
const DefaultPackerConfig = { compression: { mode: "gzip" } };
class DefaultPacker extends AbstractFlow {
  constructor(t) {
    super();
    d(this, "_packetId", 0);
    d(this, "_frameOffset", 0);
    d(this, "_encoder");
    this.context = t, this._encoder = new DefaultEncoder(t);
  }
  handleInput(t) {
    return V(this, null, function* () {
      if (t.length > 0) {
        const s = this.encode(t), c = yield this.pack(s, t.length, t[0].time, t[t.length - 1].time);
        this.output(c);
      }
    });
  }
  encode(t) {
    return t.forEach((s, c) => {
      if (s.trackType === TrackType.HTML && s.event.eventType === TrackerEventType.HTMLIncrementalSnapshot) {
        const a = {
          id: `frame/${this._frameOffset + c}`,
          time: s.time,
          type: "frame",
          recordingId: this.context.id,
          data: {
            trackType: s.trackType,
            eventType: s.event.eventType,
            offset: this._frameOffset + c
          }
        };
        this.context.emit("feedback", { type: SignalType.FrameIndex, index: a });
      }
    }), this._encoder.encode(t);
  }
  pack(t, s, c, a) {
    return V(this, null, function* () {
      var u, Z;
      let r = t;
      (((Z = (u = this.context.transmitter) == null ? void 0 : u.strategy) == null ? void 0 : Z.packer) || DefaultPackerConfig).compression.mode === "gzip" && (r = yield gzip(t));
      const b = {
        id: `${this.context.recording.id}/${this._nextPacketId()}`,
        frameRange: [this._frameOffset, s],
        data: r,
        firstFrameTime: c - this.context.startTime,
        lastFrameTime: a - this.context.startTime
      };
      return this._frameOffset += s, b;
    });
  }
  _nextPacketId() {
    return this._packetId++;
  }
}
function pack(n, l, t, s, c, a) {
  return V(this, null, function* () {
    const r = yield gzip(n);
    return {
      id: `${c}/0`,
      frameRange: [0, l],
      data: r,
      firstFrameTime: t - a,
      lastFrameTime: s - a
    };
  });
}
class AbstractProcessor extends AbstractFlow {
  constructor(t, s) {
    super();
    d(this, "_trackTypesToHandle");
    d(this, "_context");
    if (this._context = t, s != null) {
      const c = {};
      Array.isArray(s) ? s.forEach((a) => {
        c[a] = !0;
      }) : c[s] = !0, this._trackTypesToHandle = c;
    }
  }
  handleInput(t) {
    this._shouldHandle(t) ? this.handleFrame(t) : this.output(t);
  }
  _shouldHandle(t) {
    return this._trackTypesToHandle == null || this._trackTypesToHandle[t.trackType] === !0;
  }
}
const DEFAULT_BLACKBOX_BUFFER_TIME = 12e4;
class BlackboxProcessor extends AbstractProcessor {
  constructor(t, s, c) {
    var a, r;
    super(t);
    d(this, "subscription");
    d(this, "_contextMap", /* @__PURE__ */ new Map());
    d(this, "_cacheLimit");
    d(this, "_storage");
    d(this, "_bufferTime");
    d(this, "_retry");
    d(this, "_startTime", 0);
    d(this, "_endTime", 0);
    d(this, "_endRealTime", 0);
    d(this, "_hasRotated", !1);
    d(this, "_queue", []);
    d(this, "_virtualRenderer", new VirtualSnapshotRenderer());
    d(this, "_manager");
    this._manager = s, this._retry = new Retry(), this._bufferTime = (c == null ? void 0 : c.bufferTime) || DEFAULT_BLACKBOX_BUFFER_TIME, this._cacheLimit = (a = c == null ? void 0 : c.cache) == null ? void 0 : a.limit, this._storage = (r = c == null ? void 0 : c.cache) == null ? void 0 : r.storageProvider.getStorage();
  }
  join(t) {
    this._contextMap.set(t.id, t);
  }
  remove(t) {
    this._contextMap.delete(t.id);
  }
  getSize() {
    return this._contextMap.size;
  }
  subscribe(t) {
    this.subscription = t.subscribe((s) => {
      this.handleInput(s);
    });
  }
  handleFrame(t) {
    this._enqueue(t);
  }
  /**
   * Caches current recordings.
   */
  cache() {
    return V(this, null, function* () {
      const t = [];
      if (this._storage && this._contextMap.size > 0) {
        const s = yield this._createFrames();
        for (const [c, a] of this._contextMap.entries()) {
          const r = this._createRecordingOptions(c, a), o = {
            id: r.id,
            frames: s,
            startTime: this._startTime,
            endTime: this._endTime,
            mode: RecordingMode.Blackbox,
            recordingOptions: r
          };
          yield this._storage.deleteRecordings(o), yield this._storage.putRecordings([o], this._cacheLimit), t.push(o.id);
        }
      }
      return t;
    });
  }
  dump(t, s) {
    return V(this, null, function* () {
      const c = this._contextMap.get(t);
      if (!c)
        throw new Error("Not exists blackbox recording");
      const a = this._createRecordingOptions(t, c, s), { recording: r, transport: o } = yield createRecording(this._manager.apiClient, a), h = o.strategies.find(
        (p) => p.mode === RecordingMode.Blackbox && "channelType" in p
      ), b = yield this._createFrames(), u = yield pack(
        encode(b, this._startTime),
        b.length,
        b[0].time,
        this._endTime,
        r.id,
        this._startTime
      );
      yield this._retry.attempt(
        () => createBlock(this._manager.apiClient, {
          blob: new Blob([u.data], { type: "application/octet-stream" }),
          recordingId: r.id,
          token: h.config.token,
          offset: u.frameRange[0],
          count: u.frameRange[1],
          firstFrameTime: u.firstFrameTime,
          lastFrameTime: u.lastFrameTime
        })
      );
      const Z = o.strategies.find((p) => p.name === "blackbox-record-dump");
      if (Z) {
        const p = Z.config;
        c.dumpConfig = p;
      } else
        c.dumpConfig = {
          id: generateUUID$1(),
          token: a.token
        };
      return {
        id: r.id,
        mode: RecordingMode.Blackbox,
        createTime: new Date(r.createTime).getTime(),
        meta: r.meta,
        environment: r.environment
      };
    });
  }
  dispose() {
    var t;
    (t = this.subscription) == null || t.unsubscribe(), this._queue.splice(0, this._queue.length), this._virtualRenderer.reset(), this._virtualRenderer = new VirtualSnapshotRenderer();
  }
  _enqueue(t) {
    this._queue.length === 0 && t.trackType === TrackType.HTML && t.event.eventType === TrackerEventType.HTMLSnapshot && (this._startTime = t.time), this._queue.push(t), this._rotate(t.time);
  }
  _rotate(t) {
    this._endTime = t, this._endRealTime = now();
    const s = t - this._bufferTime;
    let c;
    for (; (c = this._queue[0]) && c.time < s; )
      this._queue.shift(), this._virtualRenderer.performEvent(c.event), this._startTime = c.time, this._hasRotated = !0;
    s > this._startTime && (this._startTime = s);
  }
  _createRecordingOptions(t, s, c) {
    return M(v(v({}, c), s.dumpConfig), {
      clientTime: (/* @__PURE__ */ new Date()).toISOString(),
      mode: RecordingMode.Blackbox,
      parent: t,
      refType: "blackbox",
      trackers: s.trackers,
      environment: s.recording.environment,
      meta: v(v({}, s.recording.meta), c == null ? void 0 : c.meta)
    });
  }
  _createFrames() {
    return V(this, null, function* () {
      const t = now() - this._endRealTime, s = this._endTime + t;
      this._rotate(s);
      const c = [...this._queue];
      if (c.length === 0 || this._hasRotated) {
        const a = yield this._virtualRenderer.captureSnapshot(), r = {
          trackType: TrackType.HTML,
          time: this._startTime,
          event: {
            eventType: TrackerEventType.HTMLSnapshot,
            data: a
          }
        };
        c.unshift(r);
      }
      return c;
    });
  }
}
class Controller extends AbstractFlow {
  constructor() {
    super(...arguments);
    d(this, "_buffer", new Array());
    d(this, "_suspend", !1);
  }
  get isSuspend() {
    return this._suspend;
  }
  suspend() {
    this._suspend = !0;
  }
  resume() {
    let t = this._buffer.shift();
    for (; t; )
      this.output(t), t = this._buffer.shift();
    this._suspend = !1;
  }
  handleInput(t) {
    this.isSuspend ? this._buffer.push(t) : this.output(t);
  }
}
class HTMLDataMask {
  constructor(l, t) {
    d(this, "_renderer");
    d(this, "_textDataMask");
    d(this, "_nameDataMask");
    d(this, "_commonDataMask");
    d(this, "_strict", !1);
    this._renderer = l, this._nameDataMask = new CombinedDataMask(new ChineseNameDataMask(), new EnglishNameDataMask()), this._textDataMask = new TextDataMask();
    const { disableBuiltInDataMasks: s = !1, dataMasks: c = [], maskingLevel: a = DataMaskingLevel.BALANCE } = t;
    this._strict = a === DataMaskingLevel.STRICT, s || (this._strict ? this._commonDataMask = new TextDataMask() : this._commonDataMask = new CombinedDataMask(
      new EmailDataMask(),
      new IDCardDataMask(),
      new IPAddressDataMask(),
      new LicensePlateDataMask(),
      new MACAddressDataMask(),
      new VINDataMask(),
      new MobilePhoneDataMask(),
      new BankAccountDataMask()
    )), c.length > 0 && (this._commonDataMask = this._commonDataMask ? new CombinedDataMask(...c, this._commonDataMask) : new CombinedDataMask(...c));
  }
  mask(l) {
    var c, a;
    const { data: t, eventType: s } = l.event;
    if (s === TrackerEventType.HTMLSnapshot)
      isString(t.document.title) && (this._commonDataMask && (t.document.title = this._commonDataMask.mask(t.document.title)), this.maskElement(t.document.root));
    else if (s === TrackerEventType.HTMLMutations)
      t.forEach((r) => {
        var o, h, b, u;
        if (r.type === VMutationType.AddNode)
          this.maskElement(r.data.node, this._renderer.getNode(r.target));
        else if (r.type === VMutationType.ChangeAttributes)
          r.data = this.maskAttribute(r.data, this._renderer.getNode(r.target));
        else if (r.type === VMutationType.CharacterData && isString(r.data)) {
          let Z;
          const p = this._renderer.getNode(r.target);
          p && isVTextNode(p) && p.parentId != null && (Z = this._renderer.getNode(p.parentId)), ((o = p == null ? void 0 : p.attrs) == null ? void 0 : o[DATA_MASK]) === DATA_MASK_MAP.name || ((h = Z == null ? void 0 : Z.attrs) == null ? void 0 : h[DATA_MASK]) === DATA_MASK_MAP.name ? r.data = this._nameDataMask.mask(r.data) : includes(DATA_MASK_EMPTY, (b = p == null ? void 0 : p.attrs) == null ? void 0 : b[DATA_MASK]) || includes(DATA_MASK_EMPTY, (u = Z == null ? void 0 : Z.attrs) == null ? void 0 : u[DATA_MASK]) ? r.data = this._textDataMask.mask(r.data) : this._commonDataMask && (!Z || !isVStyleElement(Z)) && (r.data = this._commonDataMask.mask(r.data));
        }
      });
    else if (s === TrackerEventType.HTMLValueChange && isString(t.value)) {
      const r = this._renderer.getNode(t.target);
      ((c = r == null ? void 0 : r.attrs) == null ? void 0 : c[DATA_MASK]) === DATA_MASK_MAP.name ? t.value = this._nameDataMask.mask(t.value) : includes(DATA_MASK_EMPTY, (a = r == null ? void 0 : r.attrs) == null ? void 0 : a[DATA_MASK]) ? t.value = this._textDataMask.mask(t.value) : this._commonDataMask && (t.value = this._commonDataMask.mask(t.value));
    }
    return l;
  }
  maskElement(l, t) {
    var s, c, a, r, o;
    if (!_isIgnored(t) && !_isIgnored(l)) {
      let h = this._commonDataMask;
      ((s = l.attrs) == null ? void 0 : s[DATA_MASK]) === DATA_MASK_MAP.name || ((c = t == null ? void 0 : t.attrs) == null ? void 0 : c[DATA_MASK]) === DATA_MASK_MAP.name ? h = this._nameDataMask : (includes(DATA_MASK_EMPTY, (a = l.attrs) == null ? void 0 : a[DATA_MASK]) || includes(DATA_MASK_EMPTY, (r = t == null ? void 0 : t.attrs) == null ? void 0 : r[DATA_MASK])) && (h = this._textDataMask), h && this._maskElement(h, l), (o = l.children) == null || o.forEach((b) => this.maskElement(b, l));
    }
  }
  maskAttribute(l, t) {
    var s, c;
    if (!_isIgnored(t)) {
      let a = this._commonDataMask;
      if (((s = t == null ? void 0 : t.attrs) == null ? void 0 : s[DATA_MASK]) === DATA_MASK_MAP.name ? a = this._nameDataMask : includes(DATA_MASK_EMPTY, (c = t == null ? void 0 : t.attrs) == null ? void 0 : c[DATA_MASK]) && (a = this._textDataMask), a)
        return this._maskAttribute(a, l, t);
    }
    return l;
  }
  _maskElement(l, t) {
    const { text: s, value: c } = t;
    isString(s) && (t.text = l.mask(s)), isString(c) && (t.value = l.mask(c)), t.attrs = this._maskAttribute(l, t.attrs, t);
  }
  _maskAttribute(l, t, s) {
    if (!t)
      return t;
    const c = v({}, t);
    for (const a of ["value", "title", "aria-label", "aria-valuetext", "placeholder", "alt"]) {
      const r = c[a];
      isString(r) && (c[a] = l.mask(r));
    }
    if (!this._strict)
      return c;
    if ((s == null ? void 0 : s.tag) === "IMG" ? (c.src = ONE_PIXEL_TRANSPARENT, delete c.srcset) : (s == null ? void 0 : s.tag) === "SOURCE" ? delete c.src : (s == null ? void 0 : s.tag) === "A" && delete c.href, c.style) {
      const a = /url\(['"]?([^'")]+)['"]?\)/g;
      c.style = c.style.replace(a, function(r, o) {
        return /\.(png|jpe?g|gif|webp|bmp|tiff|svg)(\?.*)?$/i.test(o) ? `url(${ONE_PIXEL_TRANSPARENT})` : r;
      });
    }
    return c;
  }
}
const IGNORED_TAGS = { STYLE: !0, SCRIPT: !0, svg: !0 };
function _isIgnored(n) {
  return (n == null ? void 0 : n.type) === VNodeType.CommentNode ? !0 : (n == null ? void 0 : n.tag) != null ? IGNORED_TAGS[n.tag] : !1;
}
class HTMLProcessor extends AbstractProcessor {
  constructor(t, s) {
    super(t, TrackType.HTML);
    d(this, "_lastSnapshotTime", -1);
    d(this, "_virtualRenderer");
    d(this, "_capturerAwait", null);
    d(this, "_callbacks", new Array());
    d(this, "_dataMask");
    this._virtualRenderer = new VirtualSnapshotRenderer(), this._context.virtualRenderer = this._virtualRenderer, this.syncOptions(s);
  }
  syncOptions(t) {
    t != null && t.disableDataMasking ? this._dataMask = void 0 : this._dataMask = new HTMLDataMask(this._virtualRenderer, {
      disableDataMasking: t == null ? void 0 : t.disableDataMasking,
      disableBuiltInDataMasks: t == null ? void 0 : t.disableBuiltInDataMasks,
      dataMasks: t == null ? void 0 : t.dataMasks,
      maskingLevel: t == null ? void 0 : t.maskingLevel
    });
  }
  captureSnapshotFrame(t) {
    if (this._lastSnapshotTime === -1) {
      t(null);
      return;
    }
    return this._callbacks.push(t), this._capturerAwait ? this._capturerAwait : (this._context.controller.suspend(), this._capturerAwait = (() => V(this, null, function* () {
      try {
        const s = yield this._virtualRenderer.captureSnapshot();
        this._lastSnapshotTime = time.now();
        const c = {
          trackType: TrackType.HTML,
          time: this._lastSnapshotTime,
          event: {
            eventType: TrackerEventType.HTMLSnapshot,
            data: s
          }
        };
        this._callbacks.forEach((a) => {
          a(c);
        }), this._callbacks = new Array();
      } catch (s) {
        console.error("Capture virtual snapshot error", s);
      }
      this._context.controller.resume(), this._capturerAwait = null;
    }))(), this._capturerAwait);
  }
  outputSnapshotFrame() {
    this.captureSnapshotFrame((t) => {
      t && this.output(t);
    });
  }
  handleFrame(t) {
    const s = t.event;
    this._virtualRenderer.performEvent(s), s.eventType === TrackerEventType.HTMLSnapshot && (this._lastSnapshotTime = t.time), this.output(this._dataMask ? this._dataMask.mask(t) : t);
  }
}
const MINUTE = 60 * 1e3, ONE_TICK = 1e-6;
class IncrementalProcessor extends AbstractProcessor {
  constructor(t, s) {
    super(t, TrackType.HTML);
    d(this, "_recordingContext");
    d(this, "incrementalSnapshotRenderer", new IncrementalSnapshotRenderer());
    d(this, "_index", 0);
    d(this, "_lastSnapshotTime");
    d(this, "_capturerAwait", null);
    this._recordingContext = s;
  }
  handleFrame(t) {
    const s = t.event;
    if (this.incrementalSnapshotRenderer.performEvent(s), s.eventType === TrackerEventType.HTMLSnapshot && (this._lastSnapshotTime = t.time), this.output(t), this._lastSnapshotTime && this._recordingContext.now - this._lastSnapshotTime > 2 * MINUTE && this.incrementalSnapshotRenderer.getIncrementalPercent() > 0.3) {
      const a = t.time;
      this._createIncrementalSnapshot(a);
    }
  }
  _createIncrementalSnapshot(t) {
    return this._capturerAwait ? this._capturerAwait : (this._context.controller.suspend(), this._capturerAwait = (() => V(this, null, function* () {
      try {
        this._lastSnapshotTime = t;
        const s = yield this.incrementalSnapshotRenderer.captureIncrementalSnapshot(), c = ++this._index, a = {
          trackType: TrackType.HTML,
          time: t + ONE_TICK,
          event: {
            eventType: TrackerEventType.HTMLIncrementalSnapshot,
            data: { snapshot: s, index: c }
          }
        };
        this.output(a);
      } catch (s) {
        console.error("Capture virtual snapshot error", s);
      }
      this._context.controller.resume(), this._capturerAwait = null;
    }))(), this._capturerAwait);
  }
}
class AbstractInsightDetector extends EventEmitter {
  constructor(t) {
    super();
    d(this, "_config");
    this.setOptions(t);
  }
  /**
   * Set the options for the detector.
   */
  setOptions(t) {
    this._config = v(v({}, this.getDefaultOptions()), t);
  }
  /**
   * Get the default options for the detector.
   */
  getDefaultOptions() {
    return {};
  }
}
class DeadClickDetector extends AbstractInsightDetector {
  constructor(t, s) {
    super(s);
    d(this, "_HANDLED_FRAMES", /* @__PURE__ */ new Set([TrackType.HTML, TrackType.Mouse, TrackType.Network]));
    d(this, "_IGNORED_EVENTS", /* @__PURE__ */ new Set([
      TrackerEventType.HTMLSnapshot,
      TrackerEventType.HTMLIncrementalSnapshot,
      TrackerEventType.HTMLIFrame,
      TrackerEventType.MouseMove,
      TrackerEventType.MouseDown,
      TrackerEventType.MouseUp,
      TrackerEventType.TouchStart,
      TrackerEventType.TouchMove,
      TrackerEventType.TouchEnd,
      TrackerEventType.TouchCancel,
      TrackerEventType.NETWORK_ABORT,
      TrackerEventType.NETWORK_DONE,
      TrackerEventType.NETWORK_ERROR,
      TrackerEventType.NETWORK_TIMEOUT
    ]));
    d(this, "_vRenderer");
    // The first frame is a click frame, followed by other frames.
    d(this, "_subsequentFrames", []);
    d(this, "_timer");
    this._vRenderer = t;
  }
  getDefaultOptions() {
    return {
      changesThreshold: 1,
      timeoutThreshold: 500
    };
  }
  handle(t) {
    const { trackType: s, event: c } = t, a = c.eventType;
    if (!(isCustomTrackType(s) || !this._HANDLED_FRAMES.has(s) || this._IGNORED_EVENTS.has(a)) && !(this._timer == null && a !== TrackerEventType.MouseClick)) {
      if (a === TrackerEventType.MouseClick) {
        this._stop();
        const r = c.data[3];
        if (r != null) {
          const o = this._vRenderer.getNode(r);
          (o == null ? void 0 : o.type) === VNodeType.ElementNode && this._shouldHandle(o) && this._start(t);
        }
        return;
      }
      this._subsequentFrames.push(t);
    }
  }
  _start(t) {
    this._subsequentFrames.push(t), this._timer = setTimeout(() => {
      if (this._subsequentFrames.length - 1 < this._config.changesThreshold) {
        const c = this._subsequentFrames[0], [a, r, o, h, b] = c.event.data, u = {
          duration: time.now() - c.time,
          x: a,
          y: r,
          buttons: o
        };
        h != null && (u.targetId = h), b != null && (u.context = b), this.emit("detected", u);
      }
      this._stop();
    }, this._config.timeoutThreshold);
  }
  _stop() {
    this._timer != null && (this._subsequentFrames = [], clearTimeout(this._timer), this._timer = void 0);
  }
  _shouldHandle(t) {
    const { tag: s, attrs: c } = t;
    return s === "A" || s === "BUTTON" || s === "INPUT" && c != null && (c.type === "button" || c.type === "checkbox" || c.type === "submit" || c.type === "radio" && !t.checked);
  }
}
class ExcessiveScrollingDetector extends AbstractInsightDetector {
  constructor() {
    super(...arguments);
    d(this, "_distance", 0);
    d(this, "_startTime");
    d(this, "_lastScroll");
  }
  getDefaultOptions() {
    return {
      scrollThreshold: 1e3,
      timeoutThreshold: 3e3
    };
  }
  handle(t) {
    var r, o, h;
    if (t.event.eventType !== TrackerEventType.HTMLScroll)
      return;
    const s = t.event.data, { scroll: c, target: a } = s;
    if (this._startTime == null && (this._startTime = time.now()), ((r = this._lastScroll) == null ? void 0 : r.target) !== a)
      this._distance = 0, this._startTime = time.now(), this._lastScroll = s;
    else {
      const b = time.now() - this._startTime;
      b >= this._config.timeoutThreshold ? this._reset() : (this._distance += Math.abs(c[1] - ((h = (o = this._lastScroll) == null ? void 0 : o.scroll[1]) != null ? h : 0)), this._distance >= this._config.scrollThreshold ? (this.emit("detected", {
        distance: this._distance,
        duration: b,
        targetId: a
      }), this._reset()) : this._lastScroll = s);
    }
  }
  _reset() {
    this._distance = 0, this._startTime = void 0, this._lastScroll = void 0;
  }
}
class LongHoverDetector extends AbstractInsightDetector {
  constructor() {
    super(...arguments);
    d(this, "_HANDLED_FRAMES", /* @__PURE__ */ new Set([TrackType.HTML, TrackType.Mouse, TrackType.Keyboard]));
    d(this, "_IGNORED_EVENTS", /* @__PURE__ */ new Set([
      TrackerEventType.HTMLSnapshot,
      TrackerEventType.HTMLMutations,
      TrackerEventType.HTMLIncrementalSnapshot,
      TrackerEventType.HTMLIFrame
    ]));
    d(this, "_lastMouseFrame");
    d(this, "_lastInteraction");
    d(this, "_timer");
  }
  getDefaultOptions() {
    return { timeThreshold: 1e4 };
  }
  handle(t) {
    const { trackType: s, event: c } = t, a = c.eventType;
    if (!(isCustomTrackType(s) || !this._HANDLED_FRAMES.has(s) || this._IGNORED_EVENTS.has(a))) {
      if (s === TrackType.Mouse && (this._lastMouseFrame = t), this._lastInteraction == null) {
        this._start(t);
        return;
      }
      this._restart(t);
    }
  }
  _start(t) {
    this._lastInteraction = t, this._timer = setTimeout(() => {
      if (this._lastMouseFrame != null && this._lastInteraction != null) {
        const [s, c] = getMousePosition(this._lastMouseFrame.event), a = getMouseTargetId(this._lastMouseFrame.event), r = getMouseTargetContext(this._lastMouseFrame.event), o = {
          duration: time.now() - this._lastInteraction.time,
          x: s,
          y: c
        };
        a != null && (o.targetId = a), r != null && (o.context = r), this.emit("detected", o);
      }
      this._stop(), this._lastMouseFrame = void 0;
    }, this._config.timeThreshold);
  }
  _restart(t) {
    this._stop(), this._start(t);
  }
  _stop() {
    this._timer != null && (this._lastInteraction = void 0, clearTimeout(this._timer), this._timer = void 0);
  }
}
class RageClickDetector extends AbstractInsightDetector {
  constructor() {
    super(...arguments);
    d(this, "_clicks", []);
    d(this, "_timer");
  }
  getDefaultOptions() {
    return {
      clicksThreshold: 4,
      distanceThreshold: 30,
      timeoutThreshold: 800
    };
  }
  handle(t) {
    if (!(isCustomTrackType(t.trackType) || t.event.eventType !== TrackerEventType.MouseClick)) {
      if (this._clicks.length === 0) {
        this._start(t);
        return;
      }
      if (this._isWithInDistance(this._clicks[0], t)) {
        this._clicks.push(t);
        return;
      }
      this._restart(t);
    }
  }
  _start(t) {
    this._clicks.push(t), this._timer = setTimeout(() => {
      const { length: s } = this._clicks;
      if (s >= this._config.clicksThreshold) {
        const c = this._clicks[0], a = this._clicks[s - 1], [r, o, h, b, u] = c.event.data, Z = {
          duration: a.time - c.time,
          clicks: s,
          x: r,
          y: o,
          buttons: h
        };
        b != null && (Z.targetId = b), u != null && (Z.context = u), this.emit("detected", Z);
      }
      this._stop();
    }, this._config.timeoutThreshold);
  }
  _restart(t) {
    this._stop(), this._start(t);
  }
  _stop() {
    this._timer != null && (this._clicks = [], clearTimeout(this._timer), this._timer = void 0);
  }
  _isWithInDistance(t, s) {
    const [c, a] = t.event.data, [r, o] = s.event.data;
    return Math.abs(r - c) + Math.abs(o - a) <= this._config.distanceThreshold;
  }
}
class InsightProcessor extends AbstractProcessor {
  constructor(t, s) {
    super(t);
    d(this, "_deadClickDetector");
    d(this, "_longHoverDetector");
    d(this, "_rageClickDetector");
    d(this, "_excessiveScrollingDetector");
    d(this, "_handleInsight", (t) => (s) => {
      this.output(
        createFrameFromEvent(
          TrackType.Insight,
          {
            eventType: t,
            data: s
          },
          time.now()
        )
      );
    });
    this._initDetectors(s);
  }
  syncOptions(t) {
    var s, c, a, r, o, h, b, u;
    this._isDetectorEnabled(t == null ? void 0 : t.deadClick) ? (s = this._deadClickDetector) == null || s.setOptions(t == null ? void 0 : t.deadClick) : ((c = this._deadClickDetector) == null || c.removeAllListeners(), this._deadClickDetector = void 0), this._isDetectorEnabled(t == null ? void 0 : t.excessiveScrolling) ? (a = this._excessiveScrollingDetector) == null || a.setOptions(t == null ? void 0 : t.excessiveScrolling) : ((r = this._excessiveScrollingDetector) == null || r.removeAllListeners(), this._excessiveScrollingDetector = void 0), this._isDetectorEnabled(t == null ? void 0 : t.longHover) ? (o = this._longHoverDetector) == null || o.setOptions(t == null ? void 0 : t.longHover) : ((h = this._longHoverDetector) == null || h.removeAllListeners(), this._longHoverDetector = void 0), this._isDetectorEnabled(t == null ? void 0 : t.rageClick) ? (b = this._rageClickDetector) == null || b.setOptions(t == null ? void 0 : t.rageClick) : ((u = this._rageClickDetector) == null || u.removeAllListeners(), this._rageClickDetector = void 0);
  }
  handleFrame(t) {
    var s, c, a, r;
    this.output(t), (s = this._deadClickDetector) == null || s.handle(t), (c = this._excessiveScrollingDetector) == null || c.handle(t), (a = this._longHoverDetector) == null || a.handle(t), (r = this._rageClickDetector) == null || r.handle(t);
  }
  _initDetectors(t) {
    this._isDetectorEnabled(t == null ? void 0 : t.deadClick) && this._context.virtualRenderer && (this._deadClickDetector = new DeadClickDetector(this._context.virtualRenderer, t == null ? void 0 : t.deadClick), this._deadClickDetector.on("detected", this._handleInsight(TrackerEventType.INSIGHT_DEAD_CLICK))), this._isDetectorEnabled(t == null ? void 0 : t.excessiveScrolling) && (this._excessiveScrollingDetector = new ExcessiveScrollingDetector(t == null ? void 0 : t.excessiveScrolling), this._excessiveScrollingDetector.on(
      "detected",
      this._handleInsight(TrackerEventType.INSIGHT_EXCESSIVE_SCROLLING)
    )), this._isDetectorEnabled(t == null ? void 0 : t.longHover) && (this._longHoverDetector = new LongHoverDetector(t == null ? void 0 : t.longHover), this._longHoverDetector.on("detected", this._handleInsight(TrackerEventType.INSIGHT_LONG_HOVER))), this._isDetectorEnabled(t == null ? void 0 : t.rageClick) && (this._rageClickDetector = new RageClickDetector(t == null ? void 0 : t.rageClick), this._rageClickDetector.on("detected", this._handleInsight(TrackerEventType.INSIGHT_RAGE_CLICK)));
  }
  _isDetectorEnabled(t) {
    return t !== !1;
  }
}
class NetworkDataMask {
  constructor(l) {
    d(this, "_commonDataMask");
    const { disableBuiltInDataMasks: t = !1, dataMasks: s = [], maskingLevel: c = DataMaskingLevel.BALANCE } = l;
    t || (c === DataMaskingLevel.STRICT ? this._commonDataMask = new TextDataMask() : this._commonDataMask = new CombinedDataMask(
      new EmailDataMask(),
      new IDCardDataMask(),
      new IPAddressDataMask(),
      new LicensePlateDataMask(),
      new MACAddressDataMask(),
      new VINDataMask(),
      new MobilePhoneDataMask(),
      new BankAccountDataMask()
    )), s.length > 0 && (this._commonDataMask = this._commonDataMask ? new CombinedDataMask(...s, this._commonDataMask) : new CombinedDataMask(...s));
  }
  mask(l) {
    const { data: t, eventType: s } = l.event;
    if (s === TrackerEventType.NETWORK_DONE && this._commonDataMask) {
      const { body: c } = t;
      if (c != null)
        if (isString(c))
          t.body = this._commonDataMask.mask(c);
        else
          try {
            let a = !1;
            const r = JSON.stringify(c, (o, h) => isString(h) ? (a = !0, this._commonDataMask.mask(h)) : h);
            a && (t.body = r);
          } catch (a) {
          }
    }
    return l;
  }
}
class NetworkProcessor extends AbstractProcessor {
  constructor(t, s) {
    super(t, TrackType.Network);
    d(this, "_dataMask");
    this.syncOptions(s);
  }
  syncOptions(t) {
    t != null && t.disableDataMasking ? this._dataMask = void 0 : this._dataMask = new NetworkDataMask({
      disableDataMasking: t == null ? void 0 : t.disableDataMasking,
      disableBuiltInDataMasks: t == null ? void 0 : t.disableBuiltInDataMasks,
      dataMasks: t == null ? void 0 : t.dataMasks,
      maskingLevel: t == null ? void 0 : t.maskingLevel
    });
  }
  handleFrame(t) {
    this.output(this._dataMask ? this._dataMask.mask(t) : t);
  }
}
class ProcessorContext {
  constructor(l) {
    d(this, "_trackTypes");
    d(this, "_controller");
    d(this, "_virtualRenderer");
    this._controller = l;
  }
  get trackTypes() {
    return this._trackTypes;
  }
  set trackTypes(l) {
    this._trackTypes = l;
  }
  get controller() {
    return this._controller;
  }
  get virtualRenderer() {
    return this._virtualRenderer;
  }
  set virtualRenderer(l) {
    this._virtualRenderer = l;
  }
}
class FrameBuffer extends AbstractFlow {
  constructor(t) {
    super();
    d(this, "_bufferedFrames", []);
    d(this, "_timer", 0);
    d(this, "_handleTick", () => {
      this._bufferedFrames.length ? this.flush() : this.dispose();
    });
    this.options = t;
  }
  handleInput(t) {
    this._bufferedFrames.push(t), this._timer || (this._timer = setInterval(this._handleTick, this.options.bufferTime));
  }
  flush() {
    return V(this, null, function* () {
      return this._bufferedFrames.length ? (this.output([...this._bufferedFrames]), this._bufferedFrames.splice(0, this._bufferedFrames.length), new Promise((t) => {
        setTimeout(t, 0);
      })) : Promise.resolve();
    });
  }
  dispose() {
    clearInterval(this._timer), this._timer = 0;
  }
}
class BlobTransmitter extends AbstractFlow {
  constructor(t) {
    super();
    d(this, "_chunks", []);
    this.context = t;
  }
  handleInput(t) {
    this._chunks.push(t.data);
  }
  open() {
    return V(this, null, function* () {
    });
  }
  close() {
    return V(this, null, function* () {
    });
  }
  dump() {
    return V(this, null, function* () {
      return new Blob(this._chunks, { type: "text/plain" });
    });
  }
}
class BlockTransmitter extends AbstractFlow {
  constructor(t) {
    var s;
    super();
    d(this, "_retry");
    d(this, "_strategy");
    d(this, "_closing");
    this.context = t, this._strategy = (s = t.transmitter) == null ? void 0 : s.strategy, this._retry = new Retry();
  }
  open() {
    return V(this, null, function* () {
    });
  }
  close() {
    return V(this, null, function* () {
      return new Promise((t, s) => {
        this._closing = (c) => {
          this._closing = void 0, c ? s(c) : t();
        };
      });
    });
  }
  handleInput(t) {
    this.context.emit("feedback", { type: SignalType.CompensateSnapshot, recordingId: this.context.id }), this._retry.attempt(() => V(this, null, function* () {
      var s, c;
      try {
        return createBlock(this.context.manager.apiClient, {
          blob: new Blob([t.data], {
            type: ((c = (s = this._strategy.packer) == null ? void 0 : s.compression) == null ? void 0 : c.mode) === "gzip" ? "application/octet-stream" : "text/plain"
          }),
          recordingId: this.context.recording.id,
          token: this._strategy.config.token,
          offset: t.frameRange[0],
          count: t.frameRange[1],
          firstFrameTime: t.firstFrameTime,
          lastFrameTime: t.lastFrameTime
        });
      } catch (a) {
        throw a;
      }
    })).then((s) => {
      var c;
      this.context.emit("feedback", { type: SignalType.BlockCreated, block: s }), (c = this._closing) == null || c.call(this);
    }).catch((s) => {
      var c;
      (c = this._closing) == null || c.call(this, s);
    });
  }
}
var SeekOrigin = /* @__PURE__ */ ((n) => (n[n.Begin = 0] = "Begin", n[n.End = 1] = "End", n[n.Current = 2] = "Current", n))(SeekOrigin || {});
class BinaryWriter {
  constructor(l = 1024, t = l) {
    d(this, "_byteLength", 0);
    d(this, "_position", 0);
    d(this, "_bytes");
    d(this, "_buffer");
    d(this, "_view");
    d(this, "_encoder", null);
    d(this, "_allocCount", 0);
    d(this, "_allocWarned", !1);
    this.initialBufferSize = l, this.incrementalSize = t, this.realloc(l);
  }
  get byteLength() {
    return this._byteLength;
  }
  get capacity() {
    return this._bytes.length;
  }
  get currentPosition() {
    return this._position;
  }
  encode(l) {
    return this._encoder || (this._encoder = new TextEncoder()), this._encoder.encode(l);
  }
  seek(l, t = SeekOrigin.Begin) {
    let s;
    if (t === SeekOrigin.Current ? s = this.currentPosition : t === SeekOrigin.End ? s = this.byteLength : s = 0, s = s + l, s < 0)
      throw new IOError("The seeking position must equal to or be greater than 0.");
    this._position = s;
  }
  writeUint8(l) {
    this.checkAlloc(1), this._view.setUint8(this.currentPosition, l), this.increaseSize(1);
  }
  writeUint8Array(l) {
    const t = l.byteLength;
    this.checkAlloc(t), this._bytes.set(l, this.currentPosition), this.increaseSize(t);
  }
  writeUint16(l) {
    this.checkAlloc(2), this._view.setUint16(this.currentPosition, l), this.increaseSize(2);
  }
  writeUint32(l) {
    this.checkAlloc(4), this._view.setUint32(this.currentPosition, l, !1), this.increaseSize(4);
  }
  writeString(l, t) {
    let s = this.encode(l);
    if (t && s.length > t && (s = s.slice(0, t)), this.writeUint8Array(s), t) {
      const c = t - s.length;
      c && (this._bytes.fill(0, this.currentPosition, this.currentPosition + c), this.increaseSize(c));
    }
  }
  toUint8Array() {
    return this._bytes.slice(0, this.byteLength);
  }
  toBuffer() {
    return this._buffer.slice(0, this.byteLength);
  }
  toString() {
    return this.toUint8Array().toString();
  }
  increaseSize(l) {
    this._position = this.currentPosition + l, this._byteLength = Math.max(this._byteLength, this.currentPosition);
  }
  checkAlloc(l) {
    const t = this.currentPosition + l;
    if (this._buffer.byteLength >= t)
      return;
    let s = this.byteLength;
    for (; s < t; )
      s += this.incrementalSize;
    this.realloc(s);
  }
  realloc(l) {
    const t = new ArrayBuffer(l), s = new Uint8Array(t);
    this._bytes && s.set(this._bytes, 0), this._buffer = t, this._bytes = s, this._view = new DataView(this._buffer), this._allocCount++, !this._allocWarned && this._allocCount > 5 && (console.warn(
      "This BinaryWriter frequently reallocates itself. Try to avoid this by adjusting buffer settings.",
      this
    ), this._allocWarned = !0);
  }
}
class BoxWriter {
  constructor(l, t = 1024, s = t) {
    d(this, "_binaryWriter");
    this.name = l, this.initialBufferSize = t, this.incrementalSize = s, this._binaryWriter = new BinaryWriter(t, s), this._binaryWriter.writeUint32(0), this._binaryWriter.writeString(l, 4);
  }
  get byteLength() {
    return this._binaryWriter.byteLength;
  }
  get capacity() {
    return this._binaryWriter.capacity;
  }
  appendUint8(l, t) {
    this.writeKVHeader(l, 8 / 8), this._binaryWriter.writeUint8(t);
  }
  appendBoolean(l, t) {
    this.appendUint8(l, t ? 1 : 0);
  }
  appendUint16(l, t) {
    this.writeKVHeader(l, 16 / 8), this._binaryWriter.writeUint16(t);
  }
  appendUint32(l, t) {
    this.writeKVHeader(l, 32 / 8), this._binaryWriter.writeUint32(t);
  }
  appendUint32Tuple(l, t) {
    this.writeKVHeader(l, 32 / 8 + 32 / 8), this._binaryWriter.writeUint32(t[0]), this._binaryWriter.writeUint32(t[1]);
  }
  appendUint8Array(l, t) {
    this.writeKVHeader(l, t.byteLength), this._binaryWriter.writeUint8Array(t);
  }
  appendString(l, t) {
    const s = this._binaryWriter.encode(t);
    this.appendUint8Array(l, s);
  }
  appendBox(l) {
    const t = l.toUint8Array();
    this._binaryWriter.writeUint8Array(t);
  }
  toUint8Array() {
    const l = this._binaryWriter.currentPosition;
    return this._binaryWriter.seek(0), this._binaryWriter.writeUint32(this._binaryWriter.byteLength), this._binaryWriter.seek(l), this._binaryWriter.toUint8Array();
  }
  toString() {
    return this.toUint8Array().toString();
  }
  writeKVHeader(l, t) {
    this._binaryWriter.writeUint32(this._calcKVByteLength(t)), this._binaryWriter.writeString(l, 4);
  }
  _calcKVByteLength(l) {
    return 4 + 4 + l;
  }
}
const CHUNK_NAME = "chnk";
function serializeChunk(n) {
  const l = new BoxWriter("head", 160, 64);
  l.appendUint32("id", n.header.id), l.appendString("ver", n.header.version), l.appendUint16("idx", n.header.index), l.appendString("pid", n.header.packetId), l.appendUint32Tuple("rng", n.header.packetFrameRange), l.appendBoolean("fin", n.header.fin);
  const t = l.byteLength + n.body.length + /* chnk header */
  8 + /* body header */
  8, s = new BoxWriter(CHUNK_NAME, t, 64);
  return s.appendBox(l), s.appendUint8Array("body", n.body), s.toUint8Array();
}
function stringifyChunk(n) {
  return JSON.stringify(n, (l, t) => t instanceof Uint8Array ? new TextDecoder().decode(t) : t);
}
class ChunkSplitter {
  constructor(l) {
    d(this, "_chunkId", 0);
    this.context = l;
  }
  split(l, t = 1) {
    const s = [];
    for (let c = 0; c < t; c++) {
      const a = {
        header: {
          fin: !0,
          id: this._nextChunkId(),
          index: c,
          packetId: l.id,
          packetFrameRange: l.frameRange,
          version: "1.0.0"
        },
        body: l.data
      };
      s.push(a);
    }
    return s;
  }
  _nextChunkId() {
    return this._chunkId++;
  }
}
class StreamingCompensator extends EventEmitter {
  constructor(t = 100) {
    super();
    d(this, "_bufferSize");
    d(this, "_connection");
    d(this, "_mailbox");
    d(this, "_handleSend", (t) => {
      this._mailbox && typeof t == "object" && t.type === WebSocketMessageType.Chunk && this._mailbox.enqueue([t.sequence, t.data]);
    });
    d(this, "_handleMessage", (t) => {
      var s;
      if (!(!this._mailbox || !this._connection) && !(t === HeartbeatSignal.Ping || t === HeartbeatSignal.Pong))
        if (t.type === WebSocketMessageType.ACK) {
          const c = (s = this._mailbox.peek()) == null ? void 0 : s[0];
          if (c != null)
            if (t.sequence > c) {
              const a = this._mailbox.findIndex((r) => r[0] === t.sequence);
              a !== -1 && this._mailbox.remove(a);
              for (const r of a === -1 ? this._mailbox.slice() : this._mailbox.slice(0, a))
                this._connection.send(r[1]);
            } else
              t.sequence === c && this._mailbox.dequeue();
        } else
          t.type === WebSocketMessageType.Command && this.emit("command", t.data);
    });
    d(this, "_handleOpen", () => {
      this._sendAll();
    });
    d(this, "_handleRotated", () => {
      var t;
      (t = this._mailbox) == null || t.clear(), this.emit("compensate");
    });
    this._bufferSize = t;
  }
  attach(t) {
    this.detach(), this._connection = t, t.on("send", this._handleSend), t.on("message", this._handleMessage), t.on("open", this._handleOpen), this._mailbox = new RotatingQueue(this._bufferSize), this._mailbox.on("rotated", this._handleRotated);
  }
  detach() {
    var t, s, c, a, r;
    (t = this._connection) == null || t.off("send", this._handleSend), (s = this._connection) == null || s.off("message", this._handleMessage), (c = this._connection) == null || c.off("open", this._handleOpen), this._connection = void 0, (a = this._mailbox) == null || a.off("rotated", this._handleRotated), (r = this._mailbox) == null || r.clear(), this._mailbox = void 0;
  }
  flush() {
    this._sendAll();
  }
  _sendAll() {
    var t;
    (t = this._mailbox) == null || t.forEach((s) => {
      var c;
      (c = this._connection) == null || c.send(s[1]);
    });
  }
}
class StreamingTransmitter extends AbstractFlow {
  constructor(t) {
    var a;
    super();
    d(this, "_connection");
    d(this, "_compensator");
    d(this, "_splitter");
    d(this, "_strategy");
    d(this, "_closing");
    d(this, "_handleCompensate", () => {
      this.context.emit("feedback", { type: SignalType.CompensateSnapshot, recordingId: this.context.id });
    });
    d(this, "_handleCommand", (t) => {
      var s;
      switch (t.command) {
        case StreamingCommandType.SyncBlock: {
          this.context.emit("feedback", { type: SignalType.BlockCreated, block: t.block });
          break;
        }
        case StreamingCommandType.ReceiverStopped: {
          (s = this._closing) == null || s.call(this);
          break;
        }
      }
    });
    d(this, "_handleCloseByConn", () => {
      this.context.stopRecording();
    });
    this.context = t, this._splitter = new ChunkSplitter(t), this._strategy = (a = t == null ? void 0 : t.transmitter) == null ? void 0 : a.strategy;
    const r = this.strategy.config, { bufferSize: s } = r, c = le(r, ["bufferSize"]);
    this._connection = new WebSocketConnection(t.env.getFullUrl(this.strategy.url, !0), c), this._compensator = new StreamingCompensator(s), this._connection.on("closed", this._handleCloseByConn);
  }
  get strategy() {
    return this._strategy;
  }
  open() {
    return V(this, null, function* () {
      this._compensator.attach(this._connection), this._compensator.on("compensate", this._handleCompensate), this._compensator.on("command", this._handleCommand), yield this._connection.open();
    });
  }
  close() {
    return V(this, null, function* () {
      return this._compensator.flush(), this._connection.send(JSON.stringify(NewCommand({ command: StreamingCommandType.RecorderStopped }))), new Promise((t, s) => {
        this._closing = (c) => {
          c ? s(c) : t(), this._closing = void 0;
        };
      }).then(() => (this._compensator.detach(), this._compensator.off("compensate", this._handleCompensate), this._compensator.off("command", this._handleCommand), this._connection.close()));
    });
  }
  handleInput(t) {
    return V(this, null, function* () {
      if (this.strategy.config.splitChunks !== !1) {
        const s = this._splitter.split(t);
        for (const c of s)
          this._connection.sendChunk({
            type: WebSocketMessageType.Chunk,
            sequence: c.header.id,
            data: serializeChunk(c)
          });
      } else {
        const c = this._splitter.split(t, 1)[0], a = yield gzip(new TextEncoder().encode(stringifyChunk(c)));
        this._connection.sendChunk({
          type: WebSocketMessageType.Chunk,
          sequence: c.header.id,
          data: a
        });
      }
    });
  }
}
class TransmittingError extends RecordingError {
  constructor(l, t) {
    super(l, t), this.name = "bytereplay.recorder.TransmittingError";
  }
}
class RecordingFlow extends AbstractFlow {
  constructor(t) {
    var h, b, u, Z;
    super();
    d(this, "_transmitter");
    d(this, "_frameBuffer");
    d(this, "_subscription");
    this.context = t;
    const s = new DefaultPacker(t);
    let c = 1e3;
    const a = (h = t.transmitter) == null ? void 0 : h.strategy;
    if ((a == null ? void 0 : a.mode) === RecordingMode.Streaming || (a == null ? void 0 : a.mode) === RecordingMode.LiveStreaming)
      this._transmitter = new StreamingTransmitter(t), c = (b = a.config.bufferTime) != null ? b : 1e3;
    else if ((a == null ? void 0 : a.mode) === RecordingMode.Blocking) {
      const p = this.context.options.modeOption;
      this._transmitter = new BlockTransmitter(t), c = (Z = (u = p == null ? void 0 : p.bufferTime) != null ? u : a.config.bufferTime) != null ? Z : 12e4;
    } else
      this._transmitter = new BlobTransmitter(t);
    this._frameBuffer = new FrameBuffer({ bufferTime: c });
    const r = new ProcessorContext(new Controller()), o = new IncrementalProcessor(r, t);
    this.pipe(r.controller.asPipeable()).pipe(o.asPipeable()).pipe(this._frameBuffer.asPipeable()).pipe(s.asPipeable()).pipe(this._transmitter.asPipeable());
  }
  subscribe(t) {
    this._subscription = t.subscribe((s) => {
      this.handleInput(s);
    });
  }
  handleInput(t) {
    this.output(t);
  }
  open() {
    return V(this, null, function* () {
      yield this._transmitter.open();
    });
  }
  close() {
    return V(this, null, function* () {
      var t;
      this.output(newNoopFrame(time.now())), (t = this._subscription) == null || t.unsubscribe(), yield this._frameBuffer.flush(), this._frameBuffer.dispose(), yield this._transmitter.close();
    });
  }
  dump() {
    return V(this, null, function* () {
      if (this._transmitter.dump)
        return this._transmitter.dump();
      throw new RecordingError(`Transmitter for '${this.context.recording.id}' does not support dumping.`);
    });
  }
}
class RecordingManagerImpl {
  constructor(l) {
    d(this, "input");
    d(this, "_retry");
    d(this, "env");
    d(this, "apiClient");
    d(this, "htmlProcessor");
    d(this, "insightProcessor");
    d(this, "networkProcessor");
    d(this, "_processorContext");
    d(this, "_cacheOptions");
    d(this, "_blackboxOptions");
    d(this, "_blockingOptions");
    d(this, "_blackboxProcessor");
    d(this, "_events", new EventEmitter());
    d(this, "_contextMap", /* @__PURE__ */ new Map());
    d(this, "_flowMap", /* @__PURE__ */ new Map());
    d(this, "handleFeedback", (l) => {
      switch (l.type) {
        case SignalType.CompensateSnapshot:
          this.htmlProcessor.captureSnapshotFrame((t) => {
            if (!t)
              return;
            const s = this._flowMap.get(l.recordingId);
            s && s.output(t);
          });
          break;
      }
    });
    d(this, "_handleFrame", (l) => {
      this._emit("frame", l);
    });
    this._retry = new Retry();
    const { environment: t, html: s, network: c, insight: a, interceptRequest: r } = l;
    this.env = new Environment(t), this.apiClient = new APIClient(this.env), r && (this.apiClient.requestInterceptor = r), this._processorContext = new ProcessorContext(new Controller()), this._processorContext.trackTypes = normalizeTrackTypes(l.trackers), this.htmlProcessor = new HTMLProcessor(this._processorContext, s), this.networkProcessor = new NetworkProcessor(this._processorContext, c), this.insightProcessor = new InsightProcessor(this._processorContext, a), this._initCacheOptions(l), this._initBlackboxOptions(l);
  }
  observe(l) {
    let t = l.pipe(this._processorContext.controller.asPipeable()).pipe(this.htmlProcessor.asPipeable()).pipe(this.networkProcessor.asPipeable());
    this.insightProcessor && (t = t.pipe(this.insightProcessor.asPipeable())), this.input = t.pipe(tap(this._handleFrame)).pipe(share());
  }
  syncOptions(l, t) {
    return V(this, null, function* () {
      var s, c, a, r, o;
      this.env.baseURL = (s = l.environment) == null ? void 0 : s.baseURL, this.env.type = (c = l.environment) == null ? void 0 : c.type, this.env.apiPrefix = (a = l.environment) == null ? void 0 : a.apiPrefix, this.env.headers = (r = l.environment) == null ? void 0 : r.headers, l.interceptRequest && (this.apiClient.requestInterceptor = l.interceptRequest), this._initBlackboxOptions(l), this._blockingOptions = l.blocking, this.htmlProcessor.syncOptions(l.html), this.networkProcessor.syncOptions(l.network), (o = this.insightProcessor) == null || o.syncOptions(l.insight), time.sync(t.mainTime);
    });
  }
  getCurrentRecordingCount() {
    return V(this, null, function* () {
      return this._contextMap.size;
    });
  }
  createRecordingContext(l) {
    return V(this, null, function* () {
      if (!this.input)
        throw new Error("Tracking source is not ready.");
      const { recording: t, transport: s } = yield createRecording(this.apiClient, l), c = M(v({}, t), { createTime: new Date(t.createTime).getTime() }), a = M(v({}, l), {
        transport: s
      });
      let r;
      if (l.mode === RecordingMode.Blackbox ? r = new BlackboxRecordingContext(this, c, a) : l.mode === RecordingMode.InMemory ? r = new InMemoryRecordingContext(this, c, a) : (l.mode === RecordingMode.Blocking && (a.modeOption = this._blockingOptions), r = new RecordingContext(this, c, a)), r.on("feedback", this.handleFeedback), l.mode === RecordingMode.Blackbox) {
        if (!this._blackboxProcessor) {
          const o = new BlackboxProcessor(this._processorContext, this, this._blackboxOptions);
          o.subscribe(this.input), this._blackboxProcessor = o;
        }
        this._blackboxProcessor.join(r);
      } else {
        const o = new RecordingFlow(r);
        yield o.open(), o.subscribe(this.input), this._contextMap.size > 0 && (yield this.htmlProcessor.captureSnapshotFrame((h) => {
          h && (h.time = r.startTime, o.handleInput(h));
        })), this._flowMap.set(c.id, o);
      }
      return this._contextMap.set(r.id, r), this._emit("startRecording", r.recording), r;
    });
  }
  stopRecordingContext(l) {
    return V(this, null, function* () {
      const t = this._flowMap.get(l);
      t && (yield t.close()), this._cleanRecordingContext(l);
    });
  }
  _cleanRecordingContext(l) {
    var c, a, r, o;
    const t = this._flowMap.get(l), s = this._contextMap.get(l);
    t && (t.context.off("feedback", this.handleFeedback), t.context.emit("stopped")), this._flowMap.delete(l), s && (this._contextMap.delete(l), this._emit("stopRecording", s.recording), (c = this._blackboxProcessor) == null || c.remove(s), ((r = (a = this._blackboxProcessor) == null ? void 0 : a.getSize()) != null ? r : 0) === 0 && ((o = this._blackboxProcessor) == null || o.dispose(), this._blackboxProcessor = void 0));
  }
  dumpRecording(l, t) {
    return V(this, null, function* () {
      if (this._flowMap.has(l))
        return this._flowMap.get(l).dump();
      if (this._blackboxProcessor) {
        const s = { meta: t }, c = yield this._blackboxProcessor.dump(l, s);
        return this._emit("dumpRecording", M(v({}, c), { parent: l, refType: "blackbox" })), c;
      }
      throw new RecordingError(`Unknown recording ${l}.`);
    });
  }
  cacheRecordings() {
    return V(this, null, function* () {
      return this._blackboxProcessor ? this._blackboxProcessor.cache() : [];
    });
  }
  uploadRecordingCaches() {
    return V(this, null, function* () {
      var t;
      const l = (t = this._cacheOptions) == null ? void 0 : t.storageProvider.getStorage();
      if (l) {
        const s = yield l.getRecordings();
        this._uploadRecordingCaches(s, l);
      }
    });
  }
  _uploadRecordingCaches(l, t) {
    return V(this, null, function* () {
      for (const s of l)
        try {
          const { frames: c, startTime: a, endTime: r, mode: o, recordingOptions: h } = s;
          if (o === RecordingMode.Blackbox) {
            const { recording: b, transport: u } = yield createRecording(
              this.apiClient,
              h
            ), Z = u.strategies.find(
              (G) => G.mode === RecordingMode.Blackbox && "channelType" in G
            ), p = yield pack(
              encode(c, a),
              c.length,
              c[0].time,
              r,
              b.id,
              a
            );
            yield this._retry.attempt(
              () => createBlock(this.apiClient, {
                blob: new Blob([p.data], { type: "application/octet-stream" }),
                recordingId: b.id,
                token: Z.config.token,
                offset: p.frameRange[0],
                count: p.frameRange[1],
                firstFrameTime: p.firstFrameTime,
                lastFrameTime: p.lastFrameTime
              })
            );
          }
          yield t.deleteRecordings(s);
        } catch (c) {
          if (c.code === BR_RECORDING_DUPLICATED)
            try {
              yield t.deleteRecordings(s);
            } catch (r) {
            }
        }
    });
  }
  _initCacheOptions(l) {
    const t = v({
      limit: 10
    }, typeof (l == null ? void 0 : l.cache) == "boolean" ? {} : l.cache);
    t.storageProvider || (t.storageProvider = new IndexedDBRecordingStorageProvider()), this._cacheOptions = t;
  }
  _initBlackboxOptions(l) {
    this._blackboxOptions = M(v({}, l.blackbox), { cache: this._cacheOptions });
  }
  //////////////////////////
  //// Override EventEmitter
  //////////////////////////
  _emit(l, ...t) {
    this._events.emit(l, ...t);
  }
  on(l, t) {
    this._events.on(l, t, {});
  }
  once(l, t) {
    this._events.once(l, t, {});
  }
  off(l, t, s, c) {
    this._events.off(l, t, {}, c);
  }
  addListener(l, t) {
    this._events.addListener(l, t, {});
  }
  removeListener(l, t, s, c) {
    this._events.removeListener(l, t, {}, c);
  }
}
class StandardRecorder extends AbstractRecorder {
  constructor(l) {
    super(RecorderMode.Standard, l);
  }
  createRecordingManager() {
    const l = new RecordingManagerImpl(this.options);
    return l.on("stopRecording", this._watchRecordingStop), l.on("dumpRecording", this._watchRecordingDump), l.on("frame", this._watchRecordingFrame), this.addInitialTask(
      new Promise((t) => {
        this.trackerSource && l.observe(this.trackerSource), t();
      })
    ), l;
  }
}
class ReceiveContext {
  constructor(l) {
    d(this, "envelop");
    d(this, "_source");
    this.envelop = l.envelop, this._source = l.source;
  }
  // request<T>(target: Endpoint | Window, message: unknown, options?: MessageRequestOptions): Promise<T> {
  //   return new Promise<T>((resolve, reject) => {
  //     setTimeout(() => {
  //       reject(new Error('message request timeout'));
  //     }, options?.timeout ?? 5000);
  //   });
  // }
  message() {
    return this.envelop.message;
  }
  sourceId() {
    return this.envelop.fromId;
  }
  sourceWindow() {
    return isWindow(this._source) ? this._source : null;
  }
}
class MessageBridge extends EventEmitter {
  constructor(t) {
    super();
    d(this, "uuid");
    // Endpoint -> origin map
    d(this, "_connections", /* @__PURE__ */ new WeakMap());
    d(this, "_allowedOrigins", /* @__PURE__ */ new Set());
    d(this, "_handleMessage", (t) => {
      const { origin: s, source: c, data: a } = t;
      if (this.isAllowedOrigin(s))
        try {
          if (isEnvelop(a)) {
            const r = new ReceiveContext({ origin: s, source: c, envelop: a });
            switch (r.message().type) {
              case InternalMessageType.Handshake:
                c && (this._sendMessage({ type: InternalMessageType.Connected, payload: {} }, c), this._connections.get(c) || this.handshake(c));
                break;
              case InternalMessageType.Connected:
                if (c) {
                  if (this._connections.get(c))
                    return;
                  this._connections.set(c, s);
                }
                break;
              default:
                break;
            }
            this.onReceive(r);
          }
        } catch (r) {
        }
    });
    d(this, "_handleSelfUnload", (t) => {
      t.currentTarget && this._connections.has(t.currentTarget) && (this._connections.delete(t.currentTarget), this.onReceive(
        new ReceiveContext({
          origin,
          source: t.currentTarget,
          envelop: this._newEnvelop({ type: InternalMessageType.Stopped, payload: {} })
        })
      ));
    });
    this.options = t, this.uuid = generateUUID$1(), globalThis.addEventListener("message", this._handleMessage), globalThis.addEventListener("beforeunload", this._handleSelfUnload), globalThis.addEventListener("DOMContentLoaded", () => {
      globalThis.removeEventListener("message", this._handleMessage), globalThis.removeEventListener("beforeunload", this._handleSelfUnload), globalThis.addEventListener("message", this._handleMessage), globalThis.addEventListener("beforeunload", this._handleSelfUnload);
    });
  }
  get connections() {
    return this._connections;
  }
  isAllowedOrigin(t) {
    return this._allowedOrigins.size === 0 ? !0 : this._allowedOrigins.has(t);
  }
  addAllowedOrigins(...t) {
    for (const s of t)
      this._allowedOrigins.add(s);
  }
  handshake(t) {
    this._connections.get(t) || this._sendMessage({ type: InternalMessageType.Handshake, payload: {} }, t);
  }
  send(t, s) {
    this._sendMessage(t, s);
  }
  _sendMessage(t, s) {
    var c, a;
    if (isWindow(s)) {
      const r = this._connections.get(s);
      s.postMessage(this._newEnvelop(t), (a = r != null ? r : (c = this.options) == null ? void 0 : c.targetOrigin) != null ? a : "*");
    } else
      s.postMessage(this._newEnvelop(t));
  }
  _newEnvelop(t) {
    return {
      id: generateUUID$1(),
      fromId: this.uuid,
      topic: BRIDGING_TOPIC,
      message: t
    };
  }
}
var BridgeMessageType = /* @__PURE__ */ ((n) => (n.InitRecorder = "InitRecorder", n.StartRecording = "StartRecording", n.DumpRecording = "DumpRecording", n.StopRecording = "StopRecording", n.RecordingStarted = "RecordingStarted", n.RecordingStopped = "RecordingStopped", n))(BridgeMessageType || {});
class RecorderFrameBridge extends MessageBridge {
  constructor(t) {
    super({ namespace: "data.dp.bytereplay.iframe", targetOrigin: "*" });
    d(this, "localRecordings", /* @__PURE__ */ new Map());
    // parent - local recording mapping
    d(this, "mapping", /* @__PURE__ */ new Map());
    this._options = t, globalThis.self && globalThis.self.parent !== globalThis.self && this.handshake(globalThis.self.parent);
  }
  onReceive(t) {
    var a, r, o;
    const s = t.message(), c = t.sourceWindow();
    switch (s.type) {
      case InternalMessageType.Stopped:
        this.send({ type: InternalMessageType.Disconnected, payload: {} }, window.parent);
        break;
      case InternalMessageType.Connected:
        if (c && this.connections.has(c) && c !== globalThis.self.parent) {
          try {
            (a = bridge.global) != null && a.recorder && this.send(
              {
                type: "InitRecorder",
                payload: { options: serialize(v({}, (r = bridge.global.recorder) == null ? void 0 : r.options)) }
              },
              c
            );
          } catch (Z) {
            console.error("send InitRecorder", Z);
          }
          this.localRecordings.forEach((Z, p) => {
            this.send(
              { type: "StartRecording", payload: M(v({}, Z), { parent: p, refType: "iframe" }) },
              c
            );
          });
        }
        break;
      case InternalMessageType.Disconnected:
        c && this.emit("unload", c);
        break;
      case "InitRecorder":
        (o = bridge.global) == null || o.initRecorder(s.payload.options);
        break;
      case "StartRecording":
        s.payload.parent && this._options.onParentStart(s.payload);
        break;
      case "DumpRecording":
        const b = this.mapping.get(s.payload.id);
        b && this._options.onParentDump(b, s.payload.meta);
        break;
      case "StopRecording":
        const u = this.mapping.get(s.payload.id);
        u && this._options.onParentStop(u);
        break;
      case "RecordingStarted":
        this.emit("recordingStarted", s.payload, c);
        break;
      case "RecordingStopped":
        this.emit("recordingStopped", s.payload, c);
        break;
    }
  }
  get children() {
    const t = document.querySelectorAll("iframe"), s = [];
    for (let c = 0; c < t.length; c++) {
      const { contentWindow: a } = t[c];
      if (a != null) {
        const r = this.connections.get(a);
        r != null && s.push({ id: r, target: a });
      }
    }
    return s;
  }
  initRecorder(t) {
    var c;
    const s = (c = t.html) == null ? void 0 : c.iframe;
    typeof s == "object" && s.allowOrigins && this.addAllowedOrigins(...s.allowOrigins), this.children.forEach(({ id: a, target: r }) => {
      a != null && this.send({ type: "InitRecorder", payload: { options: serialize(v({}, t)) } }, r);
    });
  }
  startRecording(t, s) {
    this.localRecordings.set(s.id, t), this.children.forEach(({ id: c, target: a }) => {
      c != null && this.send(
        { type: "StartRecording", payload: M(v({}, t), { parent: s.id, refType: "iframe" }) },
        a
      );
    });
  }
  dumpRecording(t) {
    this.children.forEach(({ id: s, target: c }) => {
      s != null && t.parent && this.send(
        { type: "DumpRecording", payload: { id: t.parent, meta: t.meta } },
        c
      );
    });
  }
  sendStartedToParent(t, s) {
    if (t.parent) {
      const c = v({}, s.recording);
      s.recording.mode === RecordingMode.Blackbox && (c.id = s.dumpConfig.id), this.send(
        {
          type: "RecordingStarted",
          payload: { recording: c, parentId: t.parent }
        },
        window.parent
      ), this.mapping.set(t.parent, s.id);
    }
  }
  stopRecording(t) {
    this.children.forEach(({ id: s, target: c }) => {
      s != null && c !== self.parent && this.send({ type: "StopRecording", payload: { id: t } }, c);
    });
  }
  sendStoppedToParent(t) {
    const s = this.localRecordings.get(t);
    s != null && s.parent && this.send(
      { type: "RecordingStopped", payload: { recordingId: t, parentId: s.parent } },
      window.parent
    );
  }
  connect(t, s) {
    var c;
    try {
      if (!this.isAllowedOrigin(s.origin))
        return;
      this.handshake(t), !s.isCrossOrigin && t && t.document && ((c = bridge.global) == null || c.inject(t));
    } catch (a) {
    }
  }
}
function injectScriptURL(n, l) {
  if (globalThis.__bytereplay_bridge__) {
    const c = globalThis.__bytereplay_bridge__;
    c == null || c.initRecorder(l);
    return;
  }
  let t;
  self.define && self.define.amd && (t = self.define.amd, self.define.amd = void 0);
  const s = document.createElement("script");
  s.src = n, s.crossOrigin = "anonymous", s.onload = () => {
    const c = globalThis.__bytereplay_bridge__;
    c == null || c.initRecorder(l), t && (self.define.amd = t);
  }, s.onerror = () => {
    t && (self.define.amd = t);
  }, self.document.body.append(s);
}
function injectTo(n, l, t) {
  typeof n.eval == "function" && n.eval(`(${injectScriptURL.toString()})('${l}', ${JSON.stringify(t || {})})`);
}
class GlobalBridge {
  constructor() {
    d(this, "recorder");
    d(this, "iframe");
    this.iframe = new RecorderFrameBridge({
      onParentStart: (l) => {
        var t;
        (t = this.recorder) == null || t.startRecording(l).then((s) => {
          this.iframe.sendStartedToParent(l, s);
        });
      },
      onParentDump: (l, t) => {
        var s, c;
        (c = (s = this.recorder) == null ? void 0 : s.getManager()) == null || c.dumpRecording(l, t);
      },
      onParentStop: (l) => {
        var t;
        (t = this.recorder) == null || t.stopRecording(l).then(() => {
          this.iframe.sendStoppedToParent(l);
        });
      }
    });
  }
  inject(l) {
    var c, a, r;
    const t = (a = (c = this.recorder) == null ? void 0 : c.options.html) == null ? void 0 : a.iframe;
    if (typeof t != "object" || !t.autoInject || !t.injectScript)
      return;
    const s = t.injectScript;
    l.document && l.document.body && l.document.body.children.length > 0 && injectTo(l, s, (r = this.recorder) == null ? void 0 : r.options), l.addEventListener(
      "load",
      () => {
        var o;
        injectTo(l, s, (o = this.recorder) == null ? void 0 : o.options);
      },
      { once: !0 }
    ), l.addEventListener("DOMContentLoaded", () => {
      var o;
      injectTo(l, s, (o = this.recorder) == null ? void 0 : o.options);
    });
  }
  setRecorder(l) {
    this.recorder = l, this.iframe.initRecorder(l.options);
  }
  initRecorder(l) {
    l == null || delete l.worker, this.setRecorder(new MultithreadedRecorder(l));
  }
  startRecording(l, t) {
    this.iframe.startRecording(l, t);
  }
  dumpRecording(l) {
    this.iframe.dumpRecording(l);
  }
  stopRecording(l) {
    this.iframe.stopRecording(l.id);
  }
}
const globalBridge = new GlobalBridge();
globalThis[GLOBAL_BRIDGE_SYMBOL] = globalBridge;
const container$4 = "_container_1lxa9_1", second = "_second_1lxa9_11", tips = "_tips_1lxa9_19", cancelButton = "_cancelButton_1lxa9_28", stopped = "_stopped_1lxa9_38", styles$4 = {
  container: container$4,
  second,
  tips,
  cancelButton,
  stopped
};
class Countdown extends Component {
  constructor(t) {
    var r, o, h;
    super("div");
    d(this, "_svg");
    d(this, "_progressPath");
    d(this, "_second");
    d(this, "_stopped", !0);
    d(this, "_startTime", 0);
    d(this, "_totalDuration", 0);
    this.options = t, this.addClass(styles$4.container);
    const s = new DOMParser().parseFromString(
      `<svg width="120" height="120" xmlns="http://www.w3.org/2000/svg"><path d="m 60,2
    a 58,58 0 1,0 0,116
    a 58,58 0 1,0 0,-116" fill="none" stroke="rgba(255, 255, 255, 0.3)" stroke-width="4"></path><path id="progress" d="m 60,2
    a 58,58 0 1,0 0,116
    a 58,58 0 1,0 0,-116" fill="none" stroke="rgba(254, 200, 75, 1)" stroke-linecap="round" stroke-width="4" stroke-dasharray="360" stroke-dashoffset="0"></path></svg>`,
      "image/svg+xml"
    );
    this._svg = this.container.ownerDocument.importNode(s.documentElement, !0), this._progressPath = this._svg.querySelector("path#progress"), this.container.appendChild(this._svg), this._second = document.createElement("div"), this._second.classList.add(styles$4.second), this.container.appendChild(this._second);
    const c = document.createElement("div");
    c.classList.add(styles$4.tips), typeof ((r = this.options) == null ? void 0 : r.tips) == "string" ? c.innerHTML = this.options.tips : ((o = this.options) == null ? void 0 : o.tips) instanceof HTMLElement ? c.appendChild(this.options.tips) : c.innerHTML = "仅能录制<span>当前页</span>", this.container.appendChild(c);
    const a = document.createElement("button");
    a.classList.add(styles$4.cancelButton), a.innerText = ((h = this.options) == null ? void 0 : h.cancelText) || "不录了", a.addEventListener("click", () => {
      this.emit("cancelled"), this.reset();
    }), this.container.appendChild(a), this.reset();
  }
  get stopped() {
    return this._stopped;
  }
  reset() {
    this._stopped = !0, this._second.innerText = "", this.addClass(styles$4.stopped);
  }
  start(t = 3) {
    return this.reset(), this._totalDuration = t * 1e3, this._startTime = Date.now(), this._stopped = !1, this.removeClass(styles$4.stopped), this.render(), new Promise((s, c) => {
      this.once("finished", () => {
        s();
      }), this.once("cancelled", () => {
        const a = new Error("cancelled");
        a.name = "CancelledError", c(a);
      });
    });
  }
  stop() {
    this._stopped = !0, this.addClass(styles$4.stopped), this.emit("finished");
  }
  render() {
    const t = Date.now() - this._startTime;
    if (t < this._totalDuration) {
      const s = t / this._totalDuration;
      this._progressPath.style.strokeDashoffset = `${s * 360}`, this._progressPath.style.display = "", this._second.innerText = (this._totalDuration / 1e3 - Math.floor(t / 1e3)).toString(), window.requestAnimationFrame(() => {
        this._stopped || this.render();
      });
    } else
      this._progressPath.style.display = "none", this.stop();
  }
}
const container$3 = "_container_2hh0t_1", title = "_title_2hh0t_6", message$1 = "_message_2hh0t_10", buttons$1 = "_buttons_2hh0t_13", primary = "_primary_2hh0t_29", styles$3 = {
  container: container$3,
  title,
  message: message$1,
  buttons: buttons$1,
  primary
};
class MessageBox extends Component {
  constructor() {
    super("div");
    d(this, "_title");
    d(this, "_message");
    d(this, "_confirmButton");
    d(this, "_confirmCallback", null);
    d(this, "_cancelCallback", null);
    this.addClass(styles$3.container), this._title = document.createElement("div"), this._title.classList.add(styles$3.title), this.container.appendChild(this._title), this._message = document.createElement("div"), this._message.classList.add(styles$3.message), this.container.appendChild(this._message);
    const t = document.createElement("div");
    t.classList.add(styles$3.buttons), this.container.appendChild(t);
    const s = document.createElement("button");
    s.innerText = "我再想想", t.appendChild(s), this._confirmButton = document.createElement("button"), this._confirmButton.classList.add(styles$3.primary), this._confirmButton.innerText = "OK", t.appendChild(this._confirmButton), this._confirmButton.addEventListener("click", () => {
      this._confirmCallback && this._confirmCallback();
    }), s.addEventListener("click", () => {
      this._cancelCallback && this._cancelCallback();
    });
  }
  show(t, s, c, a = null, r = null) {
    this._title.innerText = t, this._message.innerText = s, this._confirmButton.innerText = c, this._confirmCallback = a, this._cancelCallback = r;
  }
}
const container$2 = "_container_15hlf_1", circle = "_circle_15hlf_11", rect = "_rect_15hlf_20", active = "_active_15hlf_26", styles$2 = {
  container: container$2,
  circle,
  rect,
  active,
  "stop-button-animation": "_stop-button-animation_15hlf_1"
};
class StopButton extends Component {
  constructor() {
    super("div");
    d(this, "_circle");
    d(this, "_rect");
    d(this, "_enabled", !0);
    this.addClass(styles$2.container, styles$2.recording), this.container.title = "停止录制", this._circle = this.createElement("div", styles$2.circle), this.container.appendChild(this._circle), this._rect = this.createElement("div", styles$2.rect), this._circle.appendChild(this._rect), this.container.addEventListener(
      "click",
      () => {
        this.emit("click", { command: "stop" });
      },
      !0
    );
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    this._enabled = t, this.toggleClass(styles$2.active, t);
  }
}
class TimeDisplay extends Component {
  constructor() {
    super("div");
    d(this, "_time");
    d(this, "_timer");
    d(this, "_startTime", 0);
    d(this, "_enabled", !1);
    d(this, "_updateTime", () => {
      this._time.style.display = "inline";
      let t = 0;
      t = now() - this.startTime, this.enabled && (this.startTime === 0 ? this._time.childNodes[0].nodeValue = "00:00" : this._time.childNodes[0].nodeValue = formatTime(t, t > 3600 * 1e3));
    });
    this._time = document.createElement("span"), this._time.appendChild(document.createTextNode("")), this.container.appendChild(this._time), this._timer = window.setInterval(this._updateTime, 1e3), this._updateTime();
  }
  get startTime() {
    return this._startTime;
  }
  set startTime(t) {
    this._startTime = t, this._updateTime();
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    this._enabled = t;
  }
  reset() {
    this._startTime = 0, this._time.childNodes[0].nodeValue = "00:00";
  }
}
function formatTime(n, l = !1) {
  const t = Math.round(n / 1e3), s = Math.floor(t / 3600), c = Math.floor((t - s * 3600) / 60), a = t - s * 3600 - c * 60;
  return `${l ? `${s}:` : ""}${format2Digits(c)}:${format2Digits(a)}`;
}
function format2Digits(n) {
  return n < 10 ? `0${n}` : n;
}
const container$1 = "_container_14o0x_1", stopButton$1 = "_stopButton_14o0x_5", timeDisplay = "_timeDisplay_14o0x_8", buttons = "_buttons_14o0x_13", recording$1 = "_recording_14o0x_21", styles$1 = {
  container: container$1,
  stopButton: stopButton$1,
  timeDisplay,
  buttons,
  recording: recording$1,
  "mini-recorder-controller-animation": "_mini-recorder-controller-animation_14o0x_1"
};
class RecorderController extends Component {
  // private _restartButton: Button;
  // private _giveUpButton: Button;
  constructor() {
    super("div");
    d(this, "_overlay");
    d(this, "_stopButton");
    d(this, "_timeDisplay");
    d(this, "_enabled", !0);
    d(this, "_recordingContext", null);
    d(this, "_handleClick", ({ command: t }) => {
      this.emit("click", { command: t });
    });
    d(this, "_handleStopped", () => {
      var t;
      this.removeClass(styles$1.recording), (t = this.recordingContext) != null && t.removeListener && this.recordingContext.removeListener("stopped", this._handleStopped);
    });
    this.addClass(styles$1.container), this._overlay = document.createElement("div"), this._overlay.classList.add(styles$1.overlay), document.body.appendChild(this._overlay), this._stopButton = new StopButton(), this._stopButton.addClass(styles$1.stopButton), this._stopButton.addClass("stopButton"), this._stopButton.placeAt(this), this._timeDisplay = new TimeDisplay(), this._timeDisplay.addClass(styles$1.timeDisplay), this._timeDisplay.placeAt(this), this._stopButton.addListener("click", this._handleClick);
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    this._enabled = t, this._stopButton.enabled = this._enabled, this._timeDisplay.enabled = this._enabled;
  }
  get recordingContext() {
    return this._recordingContext;
  }
  set recordingContext(t) {
    this._recordingContext = t, this._recordingContext ? (this.enabled = !0, this._timeDisplay.startTime = this._recordingContext.startTime) : (this.enabled = !1, this._timeDisplay.reset());
  }
}
const controllerWidth = "136px", controllerHeight = "48px", miniControllerWidth = "64px", miniControllerHeight = "32px", container = "_container_36akj_7", overlay = "_overlay_36akj_27", masking = "_masking_36akj_37", controller = "_controller_36akj_41", countdown = "_countdown_36akj_47", messageBox = "_messageBox_36akj_52", handleBar = "_handleBar_36akj_62", dot = "_dot_36akj_78", initial = "_initial_36akj_93", countingDown = "_countingDown_36akj_97", center = "_center_36akj_103", stopButton = "_stopButton_36akj_106", recording = "_recording_36akj_113", mini = "_mini_36akj_130", message = "_message_36akj_52", dragContainer = "_dragContainer_36akj_170", styles = {
  controllerWidth,
  controllerHeight,
  miniControllerWidth,
  miniControllerHeight,
  container,
  overlay,
  masking,
  controller,
  countdown,
  messageBox,
  handleBar,
  dot,
  initial,
  countingDown,
  center,
  stopButton,
  recording,
  mini,
  "mini-recorder-controller-animation": "_mini-recorder-controller-animation_36akj_1",
  message,
  dragContainer
}, DISPLAY_MODES = [
  "none",
  "initial",
  "countingDown",
  "recording",
  "mini",
  "message"
], CONTAINER_WIDTH = parseInt(styles.controllerWidth), CONTAINER_HEIGHT = parseInt(styles.controllerHeight);
class RecorderIsland extends Component {
  constructor(t, s) {
    super("div");
    d(this, "_config");
    d(this, "_mouseEnter", !1);
    d(this, "_disableMouseEnterDetection", !1);
    d(this, "_isCountingDown", !1);
    d(this, "_recordingContext", null);
    d(this, "_overlay");
    d(this, "_handleBar");
    d(this, "_dragContainer", null);
    d(this, "_controller");
    d(this, "_countdown");
    d(this, "_messageBox");
    d(this, "_displayMode", "none");
    d(this, "_handleRecordingStopped", () => {
      this._recordingContext = null, this._controller.recordingContext = null, this.setDisplayMode("none");
    });
    d(this, "_handleClick", (s) => V(this, [s], function* ({ command: t }) {
      switch (t) {
        case "stop":
          this.isRecording && (yield this.stopRecording());
          break;
        case "restart":
          this.isRecording && (this.setDisplayMode("message"), this._messageBox.show(
            "确定重新录制吗？",
            "重新意味着已录制的部分将永久删除，你确定要重新录制吗？",
            "重新录制",
            () => V(this, null, function* () {
              this.reset(), this.setDisplayMode("initial");
            }),
            () => {
              this.setDisplayMode("mini");
            }
          ));
          break;
      }
    }));
    d(this, "_horizontalAlign", "center");
    d(this, "_verticalAlign", "top");
    d(this, "_isDragging", !1);
    d(this, "_draggingContext", null);
    d(this, "_handleDraggingMouseMove", (t) => {
      if (this._draggingContext) {
        const { startX: s, startY: c, startMouseX: a, startMouseY: r } = this._draggingContext;
        let o = s + (t.clientX - a);
        o < this._config.leftOffset ? o = this._config.leftOffset : o + CONTAINER_WIDTH >= window.innerWidth - this._config.rightOffset && (o = window.innerWidth - CONTAINER_WIDTH - this._config.rightOffset);
        let h = c + (t.clientY - r);
        h < this._config.topOffset ? h = this._config.topOffset : h + CONTAINER_HEIGHT >= window.innerHeight - this._config.bottomOffset && (h = window.innerHeight - CONTAINER_HEIGHT - this._config.bottomOffset), this.container.style.left = `${o}px`, this.container.style.top = `${h}px`;
      }
    });
    d(this, "_handleDraggingMouseUp", () => {
      this._endDragging();
    });
    this.recorder = t, this.addClass("bytereplay-recorder-island", styles.container, styles.center), this.setAttribute(DATA_MASK, "ignore"), this._config = v({
      countdown: {},
      topOffset: 0,
      bottomOffset: 0,
      leftOffset: 0,
      rightOffset: 0
    }, s), this._overlay = document.createElement("div"), this._overlay.classList.add(styles.overlay), this._overlay.setAttribute(DATA_MASK, "ignore"), this._controller = new RecorderController(), this._controller.addClass(styles.controller), this._controller.placeAt(this), this._controller.addListener("click", this._handleClick), this._countdown = new Countdown(s == null ? void 0 : s.countdown), this._countdown.addClass(styles.countdown), this._countdown.placeAt(this), this._countdown.on("cancelled", () => {
      this.emit("cancelled");
    }), this._messageBox = new MessageBox(), this._messageBox.addClass(styles.messageBox), this._messageBox.placeAt(this), this._handleBar = document.createElement("div");
    for (let c = 0; c < 6; c++) {
      const a = document.createElement("div");
      a.innerHTML = "<div></div>", a.classList.add(styles.dot), this._handleBar.appendChild(a);
    }
    this._handleBar.classList.add(styles.handleBar), this.container.appendChild(this._handleBar), this.container.addEventListener(
      "mouseenter",
      () => {
        this._mouseEnter = !0, this.displayMode === "mini" && !this._isDragging && (this._speedUpTransition(), this.setDisplayMode("recording"));
      },
      !0
    ), this.container.addEventListener(
      "mouseleave",
      (c) => {
        !this._disableMouseEnterDetection && this.displayMode === "recording" && !this._isDragging && (this._mouseEnter = !1, c.target === this.container && (this._speedUpTransition(), this.setDisplayMode("mini")));
      },
      !0
    ), this._handleBar.addEventListener("mousedown", (c) => {
      this._isDragging || this._beginDragging(c);
    }), this.setDisplayMode("none");
  }
  get recordingContext() {
    return this._recordingContext;
  }
  get recording() {
    var t;
    return (t = this._recordingContext) == null ? void 0 : t.recording;
  }
  get isRecording() {
    return this._recordingContext !== null;
  }
  get isCountingDown() {
    return this._isCountingDown;
  }
  get isBusy() {
    return this.isCountingDown || this.isRecording;
  }
  get displayMode() {
    return this._displayMode;
  }
  startRecording(t) {
    return V(this, null, function* () {
      var s, c;
      if (this.resetPosition(), t.countdown !== 0) {
        this.setDisplayMode("initial"), setTimeout(() => {
          this.setDisplayMode("countingDown");
        }, 0);
        try {
          this._isCountingDown = !0, yield this._countdown.start((s = t.countdown) != null ? s : 3), this._isCountingDown = !1;
        } catch (a) {
          throw this._isCountingDown = !1, this.setDisplayMode("initial"), this.reset(), a;
        }
      }
      try {
        this.setDisplayMode("mini"), this._controller.enabled = !0, this.addClass("recording"), this._recordingContext = yield this.recorder.startRecording(t), this._recordingContext.once("stopped", this._handleRecordingStopped), this._controller.recordingContext = this.recordingContext;
        const a = (c = this.recording) == null ? void 0 : c.id;
        return setTimeout(() => {
          var r;
          !this._mouseEnter && ((r = this.recording) == null ? void 0 : r.id) === a && this.setDisplayMode("mini");
        }, 3e3), this._recordingContext;
      } catch (a) {
        throw this._isCountingDown = !1, this.setDisplayMode("initial"), this.reset(), a;
      }
    });
  }
  stopRecording() {
    return V(this, null, function* () {
      this.removeClass("recording"), this.recordingContext && (yield this.recordingContext.stopRecording(), this.emit("stopped", this.recordingContext), this._recordingContext = null, this._controller.recordingContext = null);
    });
  }
  setDisplayMode(t) {
    var s;
    this.container.style.display = t === "none" ? "none" : "", t === "countingDown" ? ((s = this.container.parentElement) == null || s.appendChild(this._overlay), setTimeout(() => {
      this._overlay.classList.add(styles.masking);
    }, 0)) : (this._overlay.remove(), this._overlay.classList.remove(styles.masking)), this.container.classList.toggle("mini", t === "mini");
    for (const c of DISPLAY_MODES)
      this.container.classList.toggle(styles[c], c === t);
    switch (this.displayMode === "countingDown" && t === "recording" && (this._disableMouseEnterDetection = !0, setTimeout(() => {
      this._disableMouseEnterDetection = !1;
    }, 300)), t) {
      case "initial":
        this._controller.container.style.display = "none", this._countdown.container.style.display = "none";
        break;
      case "countingDown":
        this._controller.container.style.display = "", this._countdown.container.style.display = "";
        break;
      default:
        this._controller.container.style.display = "", this._countdown.container.style.display = "none";
        break;
    }
    this._displayMode = t;
  }
  reset() {
    this._isCountingDown = !1, this._controller.recordingContext = null, this._recordingContext = null, this._countdown.reset(), this.resetPosition(), this.setDisplayMode("none");
  }
  resetPosition() {
    var t;
    this._horizontalAlign = "center", this._verticalAlign = "top", this.container.style.left = (window.innerWidth - CONTAINER_WIDTH) / 2 + "px", this.container.style.top = `${(t = this._config.topOffset) != null ? t : 8}px`, this.container.style.right = "", this.container.style.bottom = "";
  }
  _speedUpTransition() {
    this.container.style.transitionDuration = "200ms", setTimeout(() => {
      this.container.style.transitionDuration = "";
    }, 200);
  }
  _beginDragging({ clientX: t, clientY: s }) {
    this._dragContainer || (this._dragContainer = document.createElement("div"), this._dragContainer.classList.add(styles.dragContainer), document.body.appendChild(this._dragContainer)), this._isDragging = !0, this._draggingContext = {
      startX: this.container.offsetLeft,
      startY: this.container.offsetTop,
      startMouseX: t,
      startMouseY: s
    }, this.container.style.left = `${this.container.offsetLeft}px`, this.container.style.top = `${this.container.offsetTop}px`, this.container.style.right = "", this.container.style.bottom = "", this.addClass(styles.dragging), this.container.style.transitionDuration = "0ms", window.addEventListener("mousemove", this._handleDraggingMouseMove, !0), window.addEventListener("mouseup", this._handleDraggingMouseUp, !0);
  }
  _endDragging() {
    if (this._dragContainer && (this._dragContainer.remove(), this._dragContainer = null), this._isDragging = !1, this._draggingContext = null, this.container.style.transitionDuration = "", this.removeClass(styles.dragging), this._updateAlign(), this._horizontalAlign === "right") {
      const t = window.innerWidth - this.container.offsetLeft - this.container.offsetWidth;
      this.container.style.right = `${t}px`, this.container.style.left = "";
    }
    if (this._verticalAlign === "bottom") {
      const t = window.innerHeight - this.container.offsetTop - this.container.offsetHeight;
      this.container.style.bottom = `${t}px`, this.container.style.top = "";
    }
    window.removeEventListener("mousemove", this._handleDraggingMouseMove, !0), window.removeEventListener("mouseup", this._handleDraggingMouseUp, !0);
  }
  _updateAlign() {
    this.container.offsetLeft + this.container.offsetWidth / 2 > window.innerWidth / 9 * 4 && this.container.offsetLeft + this.container.offsetWidth / 2 < window.innerWidth / 9 * 5 ? this._centralize() : this.container.offsetLeft < window.innerWidth / 2 ? (this._horizontalAlign = "left", this.removeClass(styles.center)) : (this._horizontalAlign = "right", this.removeClass(styles.center)), this.container.offsetTop < window.innerHeight / 2 ? this._verticalAlign = "top" : this._verticalAlign = "bottom";
  }
  _centralize() {
    this._horizontalAlign = "center", this.container.style.left = (window.innerWidth - parseInt(styles.width)) / 2 + "px", this.container.style.right = "", this.addClass(styles.center);
  }
}
export {
  AbstractDataMask,
  AbstractRecorder,
  AbstractTracker,
  BRIDGING_TOPIC,
  BlackboxRecordingContext,
  BlobTransmitter,
  BlockTransmitter,
  BridgeMessageType,
  CanvasElementObserver,
  ConsoleTracker,
  CustomTracker,
  DataMaskingLevel,
  ErrorTracker,
  GLOBAL_BRIDGE_SYMBOL,
  GlobalBridge,
  HTMLTracker,
  InMemoryRecordingContext,
  InternalMessageType,
  KeyboardTracker,
  MessageBridge,
  MouseTracker,
  MultithreadedRecorder,
  NetworkTracker,
  PerformanceTracker,
  ReceiveContext,
  RecorderFrameBridge,
  RecorderIsland,
  RecorderMode,
  RecordingContext,
  RecordingContextTransferHandler,
  RecordingError,
  RecordingManagerImpl,
  RecordingMode,
  SignalType,
  SnapshotCapturer,
  StandardRecorder,
  StreamingCompensator,
  StreamingTransmitter,
  TrackerContext,
  TransferPosition,
  TransmittingError,
  bridge,
  createRecordingManagerFromWorker,
  deserialize,
  env,
  hasByteReplayBridge,
  isEnvelop,
  normalizeTrackType,
  normalizeTrackTypes,
  serialize,
  version
};
